import { InjectionToken, Injectable, ɵɵdefineInjectable, ɵɵinject, Inject, Component, Input, LOCALE_ID, EventEmitter, Output, ViewChild, Pipe, NgModule } from '@angular/core';
import { HttpClient, HttpParams, HttpClientModule } from '@angular/common/http';
import { map, flatMap, shareReplay, take, catchError, mergeMap } from 'rxjs/operators';
import { ReplaySubject, BehaviorSubject, of, forkJoin, throwError } from 'rxjs';
import { formatNumber, formatDate, Location } from '@angular/common';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { UNAUTHORIZED } from 'http-status-codes';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/app-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAppConfig() { }
if (false) {
    /** @type {?} */
    IAppConfig.prototype.apiBaseUrl;
    /** @type {?} */
    IAppConfig.prototype.pageSize;
    /** @type {?} */
    IAppConfig.prototype.maxNumPages;
}
/** @type {?} */
const APP_CONFIG = new InjectionToken('app-config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/file-helper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FILE_READ_ERROR = Object.freeze({
    Message: 'File could not be read.'
});
class FileHelper {
    /**
     * @param {?} fileName
     * @return {?}
     */
    static getFileExt(fileName) {
        if (fileName == null || fileName.length === 0) {
            return '';
        }
        /** @type {?} */
        const fileExt = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
        return fileExt;
    }
    /**
     * @param {?} fileName
     * @param {?} supportedExtensions
     * @return {?}
     */
    static isSupportedFileType(fileName, supportedExtensions) {
        /** @type {?} */
        const fileExt = FileHelper.getFileExt(fileName);
        if (fileExt == null || fileExt.length === 0) {
            return false;
        }
        return supportedExtensions.includes(fileExt);
    }
    /**
     * @param {?} fileData
     * @return {?}
     */
    static getFileAsDataUrl(fileData) {
        /** @type {?} */
        const imageUrlSubject = new ReplaySubject(1);
        /** @type {?} */
        const fileReader = new FileReader();
        fileReader.onload = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const imageUrl = (/** @type {?} */ (fileReader.result));
            imageUrlSubject.next(imageUrl);
            imageUrlSubject.complete();
        });
        fileReader.onerror = (/**
         * @return {?}
         */
        () => {
            imageUrlSubject.error(FILE_READ_ERROR);
            imageUrlSubject.complete();
        });
        fileReader.readAsDataURL(fileData);
        return imageUrlSubject.asObservable();
    }
    /**
     * @param {?} fileData
     * @return {?}
     */
    static getFileAsObjectUrl(fileData) {
        return URL.createObjectURL(fileData);
    }
    /**
     * @param {?} objectUrl
     * @return {?}
     */
    static disposeObjectUrl(objectUrl) {
        return URL.revokeObjectURL(objectUrl);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/file.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FILENAME_WITH_QUOTES_REGEX = /filename="[^;]+"/;
/** @type {?} */
const FILENAME_WITHOUT_QUOTES_REGEX = /filename=[^;"]+/;
class FileService {
    /**
     * @param {?} _http
     */
    constructor(_http) {
        this._http = _http;
    }
    /**
     * @param {?} requestUrl
     * @return {?}
     */
    downloadFile(requestUrl) {
        /** @type {?} */
        const requestOptions = this.getFileRequestOptions();
        /** @type {?} */
        const request = this._http.get(requestUrl, requestOptions);
        return this.getFileInfoFromRequest(request);
    }
    /**
     * @param {?} requestUrl
     * @return {?}
     */
    downloadPrevFile(requestUrl) {
        /** @type {?} */
        const requestOptions = this.getFileRequestOptions();
        /** @type {?} */
        const request = this._http.get(requestUrl, requestOptions);
        return this.getPrevFileInfoFromRequest(request);
    }
    /**
     * @param {?} request
     * @return {?}
     */
    getFileInfoFromRequest(request) {
        return request.pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            /** @type {?} */
            const fileInfo = {
                FileData: response.body,
                FileName: this.getFileNameFromResponse(response),
                MimeType: this.getMimeTypeFromResponse(response)
            };
            return fileInfo;
        })));
    }
    /**
     * @param {?} request
     * @return {?}
     */
    getPrevFileInfoFromRequest(request) {
        return request.pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            /** @type {?} */
            const fileInfo = {
                FileData: response.body,
                FileName: this.getFileNameFromResponse(response),
                MimeType: this.getMimeTypeFromResponse(response)
            };
            return fileInfo;
        })));
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    getFileRequestOptions(params) {
        return {
            responseType: 'blob',
            observe: 'response',
            params
        };
    }
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    getMimeTypeFromResponse(response) {
        return response.headers.get('Content-Type');
    }
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    getFileNameFromResponse(response) {
        // if no content disposition header, no filename was given
        /** @type {?} */
        const contentDispositionHeader = response.headers.get('Content-Disposition');
        if (contentDispositionHeader == null || contentDispositionHeader.length === 0) {
            return '';
        }
        // attempt to match the filename surrounded by quotes
        /** @type {?} */
        let match = contentDispositionHeader.match(FILENAME_WITH_QUOTES_REGEX);
        /** @type {?} */
        const hasQuotes = match != null && match.length > 0;
        if (match == null || match.length === 0) {
            match = contentDispositionHeader.match(FILENAME_WITHOUT_QUOTES_REGEX);
        }
        if (match == null || match.length === 0) {
            return '';
        }
        // split the filename into key value pair
        /** @type {?} */
        const fileKeyValuePair = match[0].split('=');
        /** @type {?} */
        let filename = fileKeyValuePair[1].trim();
        if (hasQuotes) {
            filename = filename.substr(1, filename.length - 2);
        }
        return filename;
    }
    /**
     * @param {?} fileData
     * @return {?}
     */
    getFileAsDataUrl(fileData) {
        return FileHelper.getFileAsDataUrl(fileData);
    }
    /**
     * @param {?} fileData
     * @return {?}
     */
    getFileAsObjectUrl(fileData) {
        return FileHelper.getFileAsObjectUrl(fileData);
    }
    /**
     * @param {?} objectUrl
     * @return {?}
     */
    disposeObjectUrl(objectUrl) {
        FileHelper.disposeObjectUrl(objectUrl);
    }
}
FileService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FileService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ FileService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FileService_Factory() { return new FileService(ɵɵinject(HttpClient)); }, token: FileService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    FileService.prototype._http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/asset.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AssetService {
    /**
     * @param {?} _http
     * @param {?} _fileService
     * @param {?} _appConfig
     */
    constructor(_http, _fileService, _appConfig) {
        this._http = _http;
        this._fileService = _fileService;
        this._appConfig = _appConfig;
    }
    /**
     * @param {?} assetID
     * @return {?}
     */
    downloadAsset(assetID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/asset/${assetID}/source`;
        return this._fileService.downloadFile(requestUrl);
    }
    /**
     * @param {?} assetID
     * @return {?}
     */
    getAsset(assetID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/asset/${assetID}`;
        return this._http.get(requestUrl);
    }
    /**
     * @param {?} assetFile
     * @param {?} wellID
     * @param {?} inspectionDate
     * @param {?=} assetID
     * @return {?}
     */
    uploadAsset(assetFile, wellID, inspectionDate, assetID = null) {
        /** @type {?} */
        const requestData = new FormData();
        requestData.append('File', assetFile);
        requestData.append('WellID', wellID.toString());
        requestData.append('InspectionDate', inspectionDate.toISOString());
        if (assetID != null) {
            requestData.append('AssetID', assetID.toString());
            return this.updateAsset(requestData);
        }
        else {
            return this.createAsset(requestData);
        }
    }
    /**
     * @param {?} assetID
     * @return {?}
     */
    deleteAsset(assetID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/asset/${assetID}`;
        return this._http.delete(requestUrl);
    }
    /**
     * @private
     * @param {?} requestData
     * @return {?}
     */
    createAsset(requestData) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/asset`;
        return this._http.post(requestUrl, requestData);
    }
    /**
     * @private
     * @param {?} requestData
     * @return {?}
     */
    updateAsset(requestData) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/asset`;
        return this._http.put(requestUrl, requestData);
    }
}
AssetService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AssetService.ctorParameters = () => [
    { type: HttpClient },
    { type: FileService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ AssetService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AssetService_Factory() { return new AssetService(ɵɵinject(HttpClient), ɵɵinject(FileService), ɵɵinject(APP_CONFIG)); }, token: AssetService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AssetService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    AssetService.prototype._fileService;
    /**
     * @type {?}
     * @private
     */
    AssetService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/asset-img/asset-img.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AssetImgComponent {
    /**
     * @param {?} _assetService
     */
    constructor(_assetService) {
        this._assetService = _assetService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes == null) {
            return;
        }
        /** @type {?} */
        const assetChanged = (changes.asset && changes.asset.currentValue !== changes.asset.previousValue);
        if (assetChanged) {
            this.onAssetChanged();
        }
    }
    /**
     * @private
     * @return {?}
     */
    onAssetChanged() {
        if (typeof (this.asset) === 'number') {
            this.imgSrc$ = this._assetService.downloadAsset(this.asset)
                .pipe(map((/**
             * @param {?} fileInfo
             * @return {?}
             */
            fileInfo => {
                return fileInfo.FileData;
            })));
        }
        else {
            this.imgSrc$ = this.asset;
        }
    }
}
AssetImgComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-asset-img',
                template: "<eec-async-img [src$]=\"imgSrc$\" [class]=\"'img-fluid img-thumbnail'\"></eec-async-img>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
AssetImgComponent.ctorParameters = () => [
    { type: AssetService }
];
AssetImgComponent.propDecorators = {
    asset: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    AssetImgComponent.prototype.asset;
    /** @type {?} */
    AssetImgComponent.prototype.imgSrc$;
    /**
     * @type {?}
     * @private
     */
    AssetImgComponent.prototype._assetService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/async-img/async-img.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AsyncImgComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.unload();
    }
    /**
     * @private
     * @return {?}
     */
    unload() {
        if (this._srcSub) {
            this._srcSub.unsubscribe();
            this._srcSub = null;
            this.loading = false;
            this.showSrc = false;
        }
        this.disposeImgSrc();
    }
    /**
     * @private
     * @return {?}
     */
    disposeImgSrc() {
        if (this.src) {
            FileHelper.disposeObjectUrl(this.src);
            this.src = null;
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes == null) {
            return;
        }
        if (changes.src$ != null && changes.src$.currentValue !== changes.src$.previousValue) {
            this.onSrcChanged();
        }
    }
    /**
     * @private
     * @return {?}
     */
    onSrcChanged() {
        this.unload();
        if (this.src$ == null) {
            return;
        }
        this.loading = true;
        this._srcSub = this.src$.pipe(flatMap((/**
         * @param {?} fileData
         * @return {?}
         */
        fileData => {
            return FileHelper.getFileAsDataUrl(fileData);
        }))).subscribe({
            next: (/**
             * @param {?} srcUrl
             * @return {?}
             */
            (srcUrl) => {
                this.src = srcUrl;
                this.loading = false;
                this.showSrc = srcUrl != null && srcUrl.length > 0;
            }),
            error: (/**
             * @return {?}
             */
            () => {
                this.loading = false;
                this.showSrc = true;
            })
        });
    }
}
AsyncImgComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-async-img',
                template: "<eec-spinner [hidden]=\"!loading\" class=\"text-primary\"></eec-spinner>\n<img *ngIf=\"!loading && showSrc\" [src]=\"src\" [class]=\"class\">\n",
                styles: [""]
            }] }
];
/** @nocollapse */
AsyncImgComponent.ctorParameters = () => [];
AsyncImgComponent.propDecorators = {
    src$: [{ type: Input }],
    class: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    AsyncImgComponent.prototype.src$;
    /** @type {?} */
    AsyncImgComponent.prototype.class;
    /** @type {?} */
    AsyncImgComponent.prototype.loading;
    /** @type {?} */
    AsyncImgComponent.prototype.showSrc;
    /** @type {?} */
    AsyncImgComponent.prototype.src;
    /**
     * @type {?}
     * @private
     */
    AsyncImgComponent.prototype._srcSub;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/input-converter.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const MONTH_YEAR_DATE_FORMAT = 'MM/yyyy';
/** @type {?} */
const ABBREV_MONTH_YEAR_DATE_FORMAT = 'MMM yyyy';
/** @type {?} */
const MONTH_DAY_YEAR_DATE_FORMAT = 'MM/dd/yyyy';
/** @type {?} */
const DEFAULT_DATE_INPUT_FORMAT = 'yyyy-MM-dd';
/** @type {?} */
const MONTH_YEAR_INPUT_FORMAT = 'yyyy-MM';
/** @type {?} */
const BOOL_REGEX = /^true$/i;
class InputConverterService {
    /**
     * @param {?} _locale
     */
    constructor(_locale) {
        this._locale = _locale;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static parseInt(value) {
        if (this.isEmpty(value)) {
            return null;
        }
        else {
            /** @type {?} */
            const parsedValue = parseInt(value, 10);
            if (isNaN(parsedValue)) {
                return null;
            }
            else {
                return parsedValue;
            }
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static parseFloat(value) {
        if (InputConverterService.isEmpty(value)) {
            return null;
        }
        else {
            /** @type {?} */
            const parsedValue = parseFloat(value);
            if (isNaN(parsedValue)) {
                return null;
            }
            else {
                return parsedValue;
            }
        }
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static getDateAsLocal(date) {
        if (typeof (date) === 'string') {
            date = InputConverterService.parseDate(date);
        }
        if (date == null) {
            return null;
        }
        /** @type {?} */
        const localDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        return localDate;
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static getDateAsUtc(date) {
        if (typeof (date) === 'string') {
            date = InputConverterService.parseDate(date);
        }
        if (date == null) {
            return null;
        }
        /** @type {?} */
        const utcDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
        return utcDate;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static parseDate(value) {
        if (InputConverterService.isEmpty(value)) {
            return null;
        }
        else {
            /** @type {?} */
            const date = new Date(value);
            return date;
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static parseBoolean(value) {
        if (InputConverterService.isEmpty(value)) {
            return null;
        }
        else {
            return BOOL_REGEX.test(value);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static isEmpty(value) {
        return value == null || value.length === 0;
    }
    /**
     * @return {?}
     */
    static getCurrentYear() {
        /** @type {?} */
        const today = new Date();
        return today.getFullYear();
    }
    /**
     * @return {?}
     */
    static getCurrentMonth() {
        /** @type {?} */
        const today = new Date();
        return today.getMonth() + 1;
    }
    /**
     * @return {?}
     */
    static getCurrentDate() {
        /** @type {?} */
        const today = new Date();
        return today.getDate();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static numberToString(value) {
        if (value == null) {
            return '';
        }
        else {
            return value.toString();
        }
    }
    /**
     * @param {?} calendarMonth
     * @return {?}
     */
    static getDateFromCalendarMonth(calendarMonth) {
        /** @type {?} */
        const date = new Date(calendarMonth.year, calendarMonth.month - 1);
        return date;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static trim(value) {
        if (value == null) {
            return null;
        }
        return value.trim();
    }
    /**
     * @param {?} value
     * @param {?=} digitsInfo
     * @return {?}
     */
    formatNumber(value, digitsInfo) {
        if (value == null) {
            return '';
        }
        else {
            return formatNumber(value, this._locale, digitsInfo);
        }
    }
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    formatDate(value, format = DEFAULT_DATE_INPUT_FORMAT) {
        if (value == null) {
            return '';
        }
        else {
            return formatDate(value, format, this._locale);
        }
    }
}
InputConverterService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
InputConverterService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
];
/** @nocollapse */ InputConverterService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InputConverterService_Factory() { return new InputConverterService(ɵɵinject(LOCALE_ID)); }, token: InputConverterService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    InputConverterService.prototype._locale;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/calendar-pagination/calendar-pagination.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CalendarPaginationComponent {
    constructor() {
        this.currentMonthChanged = new EventEmitter();
        this.dateFormat = ABBREV_MONTH_YEAR_DATE_FORMAT;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    get currentDate() {
        if (this.currentMonth == null) {
            return null;
        }
        /** @type {?} */
        const newDate = new Date(this.currentMonth.year, this.currentMonth.month - 1);
        return newDate;
    }
    /**
     * @return {?}
     */
    onPreviousMonth() {
        if (this.currentMonth == null) {
            return;
        }
        /** @type {?} */
        const newDate = this.currentDate;
        newDate.setMonth(newDate.getMonth() - 1);
        this.onCurrentMonthChanged(newDate);
    }
    /**
     * @return {?}
     */
    onNextMonth() {
        if (this.currentMonth == null) {
            return;
        }
        /** @type {?} */
        const newDate = this.currentDate;
        newDate.setMonth(newDate.getMonth() + 1);
        this.onCurrentMonthChanged(newDate);
    }
    /**
     * @private
     * @param {?} newMonth
     * @return {?}
     */
    onCurrentMonthChanged(newMonth) {
        this.currentMonthChanged.emit({
            year: newMonth.getFullYear(),
            month: newMonth.getMonth() + 1
        });
    }
}
CalendarPaginationComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-calendar-pagination',
                template: "<div>\n    <span class=\"fa fa-2x fa-chevron-left mr-3 arrow\" title=\"Previous Month\" role=\"button\" (click)=\"onPreviousMonth()\"></span>\n    <span class=\"h3\">{{currentDate | date: dateFormat}}</span>\n    <span class=\"fa fa-2x fa-chevron-right ml-3 arrow\" title=\"Next Month\" role=\"button\" (click)=\"onNextMonth()\"></span>\n</div>\n",
                styles: [".arrow{cursor:pointer}"]
            }] }
];
/** @nocollapse */
CalendarPaginationComponent.ctorParameters = () => [];
CalendarPaginationComponent.propDecorators = {
    currentMonth: [{ type: Input }],
    currentMonthChanged: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    CalendarPaginationComponent.prototype.currentMonth;
    /** @type {?} */
    CalendarPaginationComponent.prototype.currentMonthChanged;
    /** @type {?} */
    CalendarPaginationComponent.prototype.dateFormat;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/auth-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAuthConfig() { }
if (false) {
    /** @type {?} */
    IAuthConfig.prototype.loginUrl;
    /** @type {?} */
    IAuthConfig.prototype.defaultRole;
}
/** @type {?} */
const AUTH_CONFIG = new InjectionToken('auth-config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/user-role.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const UserRole = {
    Admin: "ADMIN",
    Customer: "CUST",
    FieldTech: "TECH",
    User: "USER",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/user.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserService {
    /**
     * @param {?} _router
     * @param {?} _http
     * @param {?} _appConfig
     * @param {?} _authConfig
     */
    constructor(_router, _http, _appConfig, _authConfig) {
        this._router = _router;
        this._http = _http;
        this._appConfig = _appConfig;
        this._authConfig = _authConfig;
        this.onCurrentUserChanged = (/**
         * @param {?} user
         * @return {?}
         */
        (user) => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            this._currentUserSubject.next(user);
            this.storedCurrentUser = user;
            return user;
        });
        /** @type {?} */
        const storedCurrentUser = this.storedCurrentUser;
        this._currentUserSubject = new BehaviorSubject(storedCurrentUser);
        this._currentUser$ = this._currentUserSubject.asObservable();
    }
    /**
     * @private
     * @return {?}
     */
    get storedCurrentUser() {
        if (typeof localStorage === 'undefined') {
            return null;
        }
        /** @type {?} */
        const storedValue = localStorage.getItem('currentUser');
        if (storedValue === null || storedValue === '') {
            return null;
        }
        return JSON.parse(storedValue);
    }
    /**
     * @param {?} userID
     * @return {?}
     */
    getContact(userID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/user/contact/${userID}`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} userID
     * @return {?}
     */
    getUser(userID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/user/${userID}`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    set storedCurrentUser(value) {
        if (value === null) {
            localStorage.removeItem('currentUser');
        }
        else {
            /** @type {?} */
            const storedValue = JSON.stringify(value);
            localStorage.setItem('currentUser', storedValue);
        }
    }
    /**
     * @param {?} username
     * @param {?} password
     * @return {?}
     */
    login(username, password) {
        /** @type {?} */
        const data = {
            LoginID: username,
            Password: password
        };
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/authentication/authenticate`;
        return this._http.post(requestUrl, data)
            .pipe(map(this.onCurrentUserChanged));
    }
    /**
     * @param {?} currentPassword
     * @param {?} newPassword
     * @param {?} confirmNewPassword
     * @return {?}
     */
    changePassword(currentPassword, newPassword, confirmNewPassword) {
        /** @type {?} */
        const data = {
            CurrentPassword: currentPassword,
            NewPassword: newPassword,
            ConfirmNewPassword: confirmNewPassword
        };
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/user/changepassword`;
        return this._http.put(requestUrl, data)
            .pipe(map(this.onCurrentUserChanged));
    }
    /**
     * @param {?} user
     * @param {?} userID
     * @param {?} newLoginID
     * @return {?}
     */
    updateUser(user, userID, newLoginID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/user/${userID}/update/${newLoginID}`;
        return this._http.put(requestUrl, user);
    }
    /**
     * @return {?}
     */
    logout() {
        this._currentUserSubject.next(null);
        this.storedCurrentUser = null;
    }
    /**
     * @param {?=} returnUrl
     * @return {?}
     */
    logoutAndRedirectToLoginPage(returnUrl = null) {
        if (returnUrl != null && returnUrl.toLowerCase().startsWith(this._authConfig.loginUrl.toLowerCase())) {
            return;
        }
        this.logout();
        /** @type {?} */
        let queryParams = null;
        if (returnUrl != null && returnUrl.length > 0 && returnUrl !== '/') {
            queryParams = {
                returnUrl
            };
        }
        this._router.navigate([this._authConfig.loginUrl], { queryParams });
    }
    /**
     * @return {?}
     */
    get currentUserIsAuthenticated() {
        /** @type {?} */
        const currentUser = this.currentUser;
        return currentUser != null && currentUser.AuthToken != null && currentUser.AuthToken.length > 0;
    }
    /**
     * @param {?=} allowedRoles
     * @return {?}
     */
    currentUserIsAuthorized(allowedRoles) {
        // if the user is not authenticated, then they cannot be authorized
        /** @type {?} */
        const isAuthenticated = this.currentUserIsAuthenticated;
        if (!isAuthenticated) {
            return false;
        }
        // the user must have the default role in order to gain authorization
        allowedRoles = allowedRoles || [];
        if (allowedRoles.indexOf(this._authConfig.defaultRole) < 0) {
            allowedRoles.push(this._authConfig.defaultRole);
        }
        /** @type {?} */
        let isAuthorized = false;
        for (const authorizedRole of allowedRoles) {
            if (this.currentUserHasRole(authorizedRole)) {
                isAuthorized = true;
                break;
            }
        }
        return isAuthorized;
    }
    /**
     * @param {?} role
     * @return {?}
     */
    currentUserHasRole(role) {
        /** @type {?} */
        const currentUser = this.currentUser;
        if (currentUser == null) {
            return false;
        }
        // every user has the User role by default
        if (role === UserRole.User) {
            return true;
        }
        if (currentUser.Roles == null || currentUser.Roles.length === 0) {
            return false;
        }
        /** @type {?} */
        let userHasRole = false;
        for (const userRole of currentUser.Roles) {
            if (userRole === role) {
                userHasRole = true;
                break;
            }
        }
        return userHasRole;
    }
    /**
     * @return {?}
     */
    get currentUser$() {
        return this._currentUser$;
    }
    /**
     * @return {?}
     */
    get currentUser() {
        return this._currentUserSubject.value;
    }
}
UserService.decorators = [
    { type: Injectable, args: [{ providedIn: 'root' },] }
];
/** @nocollapse */
UserService.ctorParameters = () => [
    { type: Router },
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_CONFIG,] }] }
];
/** @nocollapse */ UserService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(ɵɵinject(Router), ɵɵinject(HttpClient), ɵɵinject(APP_CONFIG), ɵɵinject(AUTH_CONFIG)); }, token: UserService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    UserService.prototype._currentUserSubject;
    /**
     * @type {?}
     * @private
     */
    UserService.prototype._currentUser$;
    /**
     * @type {?}
     * @private
     */
    UserService.prototype.onCurrentUserChanged;
    /**
     * @type {?}
     * @private
     */
    UserService.prototype._router;
    /**
     * @type {?}
     * @private
     */
    UserService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    UserService.prototype._appConfig;
    /**
     * @type {?}
     * @private
     */
    UserService.prototype._authConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/authentication.constant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const AUTHENTICATION = Object.freeze({
    MinPasswordLength: 8
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/value-match.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} controlName1
 * @param {?} controlName2
 * @return {?}
 */
function ValueMatchValidator(controlName1, controlName2) {
    return (/**
     * @param {?} group
     * @return {?}
     */
    (group) => {
        /** @type {?} */
        const control1 = group.controls[controlName1];
        /** @type {?} */
        const control2 = group.controls[controlName2];
        if (control1.value === control2.value) {
            return null;
        }
        else {
            return {
                valuematch: true
            };
        }
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/password-match-form/password-match-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IPasswordMatchFormData() { }
if (false) {
    /** @type {?} */
    IPasswordMatchFormData.prototype.Password;
    /** @type {?} */
    IPasswordMatchFormData.prototype.ConfirmPassword;
}
class PasswordMatchFormComponent {
    /**
     * @param {?} _formBuilder
     */
    constructor(_formBuilder) {
        this._formBuilder = _formBuilder;
        this.minPasswordLength = AUTHENTICATION.MinPasswordLength;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.form = this._formBuilder.group({
            Password: ['', []],
            ConfirmPassword: ['', []]
        }, { validators: ValueMatchValidator('Password', 'ConfirmPassword') });
    }
    /**
     * @return {?}
     */
    reset() {
        this.form.reset();
    }
    /**
     * @return {?}
     */
    get data() {
        return this.form.value;
    }
    /**
     * @return {?}
     */
    get controls() {
        return this.form.controls;
    }
}
PasswordMatchFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-password-match-form',
                template: "<form [formGroup]=\"form\">\n    \n    <div class=\"form-group\">\n        <label for=\"Password\">{{isNewPassword ? 'New Password' : 'Password'}}</label>\n        <input id=\"Password\" formControlName=\"Password\" type=\"password\" class=\"form-control\" placeholder=\"Enter password\"\n               [ngClass]=\"{ 'is-invalid': showErrors && (form.errors || controls.Password.errors) }\" />\n\n        <div *ngIf=\"showErrors && controls.Password.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"controls.Password.errors.required\">Password is required</div>\n            <div *ngIf=\"controls.Password.errors.minlength\">Password must be at least {{minPasswordLength}} characters long</div>\n        </div>\n    </div>\n\n    <div class=\"form-group\">\n        <label for=\"ConfirmPassword\">{{isNewPassword ? 'Confirm New Password' : 'Confirm Password'}}</label>\n        <input id=\"ConfirmPassword\" formControlName=\"ConfirmPassword\" type=\"password\" class=\"form-control\" placeholder=\"Confirm password\"\n               [ngClass]=\"{ 'is-invalid': showErrors && (form.errors || controls.ConfirmPassword.errors) }\" />\n\n        <div *ngIf=\"showErrors && controls.ConfirmPassword.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"controls.ConfirmPassword.errors.required\">Confirmation password is required</div>\n            <div *ngIf=\"controls.ConfirmPassword.errors.minlength\">Password must be at least {{minPasswordLength}} characters long</div>\n        </div>\n        <div *ngIf=\"showErrors && form.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"form.errors.valuematch\">Passwords don't match</div>\n        </div>\n    </div>\n</form>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
PasswordMatchFormComponent.ctorParameters = () => [
    { type: FormBuilder }
];
PasswordMatchFormComponent.propDecorators = {
    showErrors: [{ type: Input }],
    isNewPassword: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PasswordMatchFormComponent.prototype.showErrors;
    /** @type {?} */
    PasswordMatchFormComponent.prototype.isNewPassword;
    /** @type {?} */
    PasswordMatchFormComponent.prototype.form;
    /** @type {?} */
    PasswordMatchFormComponent.prototype.minPasswordLength;
    /**
     * @type {?}
     * @private
     */
    PasswordMatchFormComponent.prototype._formBuilder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/change-password/change-password.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChangePasswordComponent {
    /**
     * @param {?} _formBuilder
     * @param {?} _userService
     */
    constructor(_formBuilder, _userService) {
        this._formBuilder = _formBuilder;
        this._userService = _userService;
        this.loading = false;
        this.submitted = false;
        this.errorMsg = '';
        this.successMsg = '';
    }
    /**
     * @return {?}
     */
    get controls() {
        return this.form.controls;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.form = this._formBuilder.group({
            CurrentPassword: ['', Validators.required]
        });
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.form.addControl('NewPassword', this._newPasswordForm.form);
        }));
    }
    /**
     * @return {?}
     */
    onSubmit() {
        this.submitted = true;
        this.errorMsg = '';
        this.successMsg = '';
        if (this.form.invalid) {
            return;
        }
        /** @type {?} */
        const currentPassword = this.controls.CurrentPassword.value;
        /** @type {?} */
        const newPasswordData = this._newPasswordForm.data;
        this.reset();
        this.loading = true;
        this._userService.changePassword(currentPassword, newPasswordData.Password, newPasswordData.ConfirmPassword).subscribe({
            next: (/**
             * @return {?}
             */
            () => {
                this.successMsg = 'Password changed successfully!';
                this.loading = false;
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.errorMsg = error != null ? error.Message : '';
                this.loading = false;
            })
        });
    }
    /**
     * @return {?}
     */
    reset() {
        this.submitted = false;
        this.form.reset();
    }
}
ChangePasswordComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-change-password',
                template: "<div>\n\t<h3>Change Password</h3>\n\t<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\">\n\t\t<div class=\"form-group\">\n\t\t\t<label for=\"CurrentPassword\">Current Password</label>\n\t\t\t<input id=\"CurrentPassword\" formControlName=\"CurrentPassword\" type=\"password\" class=\"form-control\" placeholder=\"Enter current password\"\n\t\t\t\t   [ngClass]=\"{ 'is-invalid': submitted && controls.CurrentPassword.errors }\"/>\n\n\t\t\t<div *ngIf=\"submitted && controls.CurrentPassword.errors\" class=\"invalid-feedback\">\n\t\t\t\t<div *ngIf=\"controls.CurrentPassword.errors.required\">Current password is required</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<eec-password-match-form [showErrors]=\"submitted\" [isNewPassword]=\"true\"></eec-password-match-form>\n\n\t\t<eec-form-alerts \n\t\t\t[formInvalid]=\"submitted && form.invalid\" \n\t\t\t[errorMsg]=\"errorMsg\" \n\t\t\t[successMsg]=\"successMsg\">\n\t\t</eec-form-alerts>\n\n\t\t<button [disabled]=\"loading\" class=\"btn btn-primary\" type=\"submit\">\n\t\t\t<eec-spinner [hidden]=\"!loading\" small=\"true\" class=\"mr-1\"></eec-spinner>\n\t\t\tChange Password\n\t\t</button>\n\t</form>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ChangePasswordComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: UserService }
];
ChangePasswordComponent.propDecorators = {
    _newPasswordForm: [{ type: ViewChild, args: [PasswordMatchFormComponent, { static: false },] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ChangePasswordComponent.prototype._newPasswordForm;
    /** @type {?} */
    ChangePasswordComponent.prototype.form;
    /** @type {?} */
    ChangePasswordComponent.prototype.loading;
    /** @type {?} */
    ChangePasswordComponent.prototype.submitted;
    /** @type {?} */
    ChangePasswordComponent.prototype.errorMsg;
    /** @type {?} */
    ChangePasswordComponent.prototype.successMsg;
    /**
     * @type {?}
     * @private
     */
    ChangePasswordComponent.prototype._formBuilder;
    /**
     * @type {?}
     * @private
     */
    ChangePasswordComponent.prototype._userService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/inspection-condition.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const InspectionCondition = {
    Red: "RED",
    Green: "GRN",
    Yellow: "YLW",
    Orange: "ORG",
    Blue: "BLU",
    White: "WHT",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/condition-text/condition-text.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConditionTextComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    get conditionClass() {
        switch (this.condition) {
            case InspectionCondition.Red: {
                return 'condition-red';
            }
            case InspectionCondition.Green: {
                return 'condition-green';
            }
            case InspectionCondition.Yellow: {
                return 'condition-yellow';
            }
            case InspectionCondition.Orange: {
                return 'condition-orange';
            }
            case InspectionCondition.Blue: {
                return 'condition-blue';
            }
            case InspectionCondition.White: {
                return 'condition-white';
            }
        }
    }
    /**
     * @return {?}
     */
    get showCaps() {
        return this.condition === InspectionCondition.Red;
    }
}
ConditionTextComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-condition-text',
                template: "<span [ngClass]=\"conditionClass\">\n    {{(showCaps ? (description | uppercase) : description) | notany }}\n</span>\n",
                styles: [".condition-red{color:red}.condition-yellow{color:#daa520}.condition-orange{color:#ff8c00}.condition-green{color:green}.condition-blue{color:#00f}.condition-white{color:#000}"]
            }] }
];
/** @nocollapse */
ConditionTextComponent.ctorParameters = () => [];
ConditionTextComponent.propDecorators = {
    condition: [{ type: Input }],
    description: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ConditionTextComponent.prototype.condition;
    /** @type {?} */
    ConditionTextComponent.prototype.description;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/inspection-date-hydrator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InspectionDateHydrator {
    /**
     * @param {?} inspectionList
     * @return {?}
     */
    static processInspectionList(inspectionList) {
        for (const inspection of inspectionList) {
            this.processInspectionBase(inspection);
            this.processFireTube(inspection.FireTube);
            this.processAnode(inspection.Anode);
        }
        return inspectionList;
    }
    /**
     * @param {?} inspection
     * @return {?}
     */
    static processInspection(inspection) {
        this.processInspectionBase(inspection);
        this.processAnode(inspection.Anode);
        this.processFieldNote(inspection.FieldNote);
        this.processFireTube(inspection.FireTube);
    }
    /**
     * @param {?} inspections
     * @return {?}
     */
    static processInspections(inspections) {
        for (const inspection of inspections) {
            this.processInspection(inspection);
        }
    }
    /**
     * @private
     * @param {?} inspection
     * @return {?}
     */
    static processInspectionBase(inspection) {
        if (typeof (inspection.InspectionDate) === 'string') {
            inspection.InspectionDate = InputConverterService.getDateAsLocal(inspection.InspectionDate);
        }
    }
    /**
     * @private
     * @param {?} fireTube
     * @return {?}
     */
    static processFireTube(fireTube) {
        if (fireTube && typeof (fireTube.InspectionDate) === 'string') {
            fireTube.InspectionDate = InputConverterService.getDateAsLocal(fireTube.InspectionDate);
        }
    }
    /**
     * @private
     * @param {?} anode
     * @return {?}
     */
    static processAnode(anode) {
        if (anode && typeof (anode.InspectionDate) === 'string') {
            anode.InspectionDate = InputConverterService.getDateAsLocal(anode.InspectionDate);
        }
    }
    /**
     * @private
     * @param {?} fieldNote
     * @return {?}
     */
    static processFieldNote(fieldNote) {
        if (fieldNote && typeof (fieldNote.InspectionDate) === 'string') {
            fieldNote.InspectionDate = InputConverterService.getDateAsLocal(fieldNote.InspectionDate);
        }
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/well.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WellService {
    /**
     * @param {?} _http
     * @param {?} _appConfig
     */
    constructor(_http, _appConfig) {
        this._http = _http;
        this._appConfig = _appConfig;
        this.onInspectionRequested = (/**
         * @param {?} inspection
         * @return {?}
         */
        (inspection) => {
            if (inspection == null) {
                return;
            }
            InspectionDateHydrator.processInspection(inspection);
            return inspection;
        });
    }
    /**
     * @param {?} page
     * @param {?} pageSize
     * @param {?} keyword
     * @return {?}
     */
    getWellList(page, pageSize, keyword) {
        if (keyword != null) {
            keyword = keyword.replace("#", "^");
        }
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/wells/${keyword}/list/page/${page}`;
        /** @type {?} */
        const requestParams = {
            pageSize: pageSize.toString()
        };
        return this._http.get(requestUrl, { params: requestParams }).pipe(shareReplay(1));
    }
    /**
     * @param {?} val
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    getWellsList(val, page, pageSize) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/wells/search/page/${page}`;
        /** @type {?} */
        const requestParams = {
            keyword: val,
            pageSize: pageSize.toString()
        };
        return this._http.get(requestUrl, { params: requestParams }).pipe(shareReplay(1));
    }
    /**
     * @param {?} routeID
     * @return {?}
     */
    getRouteWells(routeID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/route/${routeID}/wells`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} routeID
     * @param {?} page
     * @param {?} pageSize
     * @param {?} keyword
     * @return {?}
     */
    getRouteWellList(routeID, page, pageSize, keyword) {
        if (keyword != null) {
            keyword = keyword.replace("#", "^");
        }
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/route/${routeID}/wells/${keyword}/list/page/${page}`;
        /** @type {?} */
        const requestParams = {
            pageSize: pageSize.toString()
        };
        return this._http.get(requestUrl, { params: requestParams }).pipe(shareReplay(1));
    }
    /**
     * @param {?} customerID
     * @param {?} page
     * @param {?} pageSize
     * @param {?} keyword
     * @return {?}
     */
    getCustomerWellList(customerID, page, pageSize, keyword) {
        if (keyword != null) {
            keyword = keyword.replace("#", "^");
        }
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/wells/${keyword}/list/page/${page}`;
        /** @type {?} */
        const requestParams = {
            pageSize: pageSize.toString()
        };
        return this._http.get(requestUrl, { params: requestParams }).pipe(shareReplay(1));
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    getWell(wellID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well/${wellID}`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} keyword
     * @return {?}
     */
    findWell(keyword) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well/find`;
        /** @type {?} */
        const requestParams = {
            keyword
        };
        return this._http.get(requestUrl, { params: requestParams }).pipe(shareReplay(1));
    }
    /**
     * @param {?} well
     * @return {?}
     */
    createWell(well) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well`;
        return this._http.post(requestUrl, well);
    }
    /**
     * @param {?} well
     * @return {?}
     */
    updateWell(well) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well`;
        return this._http.put(requestUrl, well);
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    deleteWell(wellID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well/${wellID}`;
        return this._http.delete(requestUrl);
    }
    /**
     * @param {?} wellID
     * @param {?} requestFollowUp
     * @param {?} numMonthsFromLastInspection
     * @param {?} inspectionID
     * @return {?}
     */
    requestInspection(wellID, requestFollowUp, numMonthsFromLastInspection, inspectionID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well/${wellID}/inspection/${inspectionID}/request`;
        /** @type {?} */
        const requestData = {
            RequestFollowUp: requestFollowUp,
            NumMonthsFromLastInspection: numMonthsFromLastInspection
        };
        return this._http.post(requestUrl, requestData).pipe(map(this.onInspectionRequested));
    }
}
WellService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
WellService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ WellService.ngInjectableDef = ɵɵdefineInjectable({ factory: function WellService_Factory() { return new WellService(ɵɵinject(HttpClient), ɵɵinject(APP_CONFIG)); }, token: WellService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    WellService.prototype.onInspectionRequested;
    /**
     * @type {?}
     * @private
     */
    WellService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    WellService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/route.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RouteService {
    /**
     * @param {?} _http
     * @param {?} _appConfig
     */
    constructor(_http, _appConfig) {
        this._http = _http;
        this._appConfig = _appConfig;
    }
    /**
     * @param {?} customerID
     * @return {?}
     */
    getCustomerRoutes(customerID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/routes`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    getWellRoute(wellID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well/${wellID}/routes`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} customerID
     * @return {?}
     */
    getCustomerRouteList(customerID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/routes/list`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} routeID
     * @return {?}
     */
    getRoute(routeID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/route/${routeID}`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} route
     * @return {?}
     */
    createRoute(route) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/route`;
        return this._http.post(requestUrl, route).pipe(shareReplay(1));
    }
    /**
     * @param {?} route
     * @return {?}
     */
    updateRoute(route) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/route`;
        return this._http.put(requestUrl, route).pipe(shareReplay(1));
    }
    /**
     * @param {?} routeID
     * @return {?}
     */
    deleteRoute(routeID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/route/${routeID}`;
        return this._http.delete(requestUrl);
    }
}
RouteService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RouteService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ RouteService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RouteService_Factory() { return new RouteService(ɵɵinject(HttpClient), ɵɵinject(APP_CONFIG)); }, token: RouteService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RouteService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    RouteService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/yes-no.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const YesNo = {
    Yes: "Yes",
    No: "No",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/edit-well-form/edit-well-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFormData() { }
if (false) {
    /** @type {?} */
    IFormData.prototype.CustomerID;
    /** @type {?} */
    IFormData.prototype.RouteID;
    /** @type {?} */
    IFormData.prototype.Name;
    /** @type {?} */
    IFormData.prototype.Description;
    /** @type {?} */
    IFormData.prototype.State;
    /** @type {?} */
    IFormData.prototype.IsH2s;
}
class EditWellFormComponent {
    /**
     * @param {?} _formBuilder
     * @param {?} _routeService
     */
    constructor(_formBuilder, _routeService) {
        this._formBuilder = _formBuilder;
        this._routeService = _routeService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.form = this._formBuilder.group({
            CustomerID: ['', Validators.required],
            RouteID: ['', Validators.required],
            Name: ['', [Validators.required, Validators.maxLength(100)]],
            Description: [''],
            State: [''],
            IsH2s: [YesNo.No]
        });
        this.controls.CustomerID.valueChanges.subscribe((/**
         * @return {?}
         */
        () => {
            this.refreshRoutes();
        }));
        this.reset();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes == null || this.form == null) {
            return;
        }
        if (changes.well != null && changes.well.previousValue !== changes.well.currentValue) {
            this.reset();
        }
    }
    /**
     * @param {?} item
     * @return {?}
     */
    getIndex(item) {
        return item.Index;
    }
    /**
     * @param {?} producer
     * @return {?}
     */
    getCustomerID(producer) {
        return producer.CustomerID;
    }
    /**
     * @param {?} route
     * @return {?}
     */
    getRouteID(route) {
        return route.RouteID;
    }
    /**
     * @return {?}
     */
    get controls() {
        return this.form.controls;
    }
    /**
     * @return {?}
     */
    reset() {
        if (this.form == null) {
            return;
        }
        /** @type {?} */
        const wellState = this.well != null ? this.well.State : null;
        /** @type {?} */
        const H2s = this.well != null ? this.well.IsH2s : null;
        /** @type {?} */
        const hasH2s = H2s != null;
        /** @type {?} */
        const formData = {
            CustomerID: this.well != null && this.well.CustomerID != null ? this.well.CustomerID.toString() : '',
            RouteID: this.well != null && this.well.RouteID != null ? this.well.RouteID.toString() : '',
            Name: this.well != null ? this.well.Name : '',
            Description: this.well != null ? this.well.Description : '',
            State: !InputConverterService.isEmpty(wellState) ? wellState : '',
            IsH2s: hasH2s && H2s ? YesNo.Yes : YesNo.No
        };
        this.controls.Name.enable();
        this.form.reset(formData);
    }
    /**
     * @return {?}
     */
    data() {
        /** @type {?} */
        const state = this.controls.State.value;
        /** @type {?} */
        const hasH2s = this.controls.IsH2s.value === YesNo.Yes;
        /** @type {?} */
        const well = {
            WellID: this.well != null ? this.well.WellID : null,
            CustomerID: InputConverterService.parseInt(this.controls.CustomerID.value),
            RouteID: InputConverterService.parseInt(this.controls.RouteID.value),
            Description: InputConverterService.trim(this.controls.Description.value),
            Name: InputConverterService.trim(this.controls.Name.value),
            State: !InputConverterService.isEmpty(state) ? state : null,
            IsH2s: hasH2s
        };
        return well;
    }
    /**
     * @private
     * @return {?}
     */
    refreshRoutes() {
        /** @type {?} */
        const customerID = InputConverterService.parseInt(this.controls.CustomerID.value);
        if (customerID !== this._customerID) {
            this._customerID = customerID;
            this.clearRoutes();
            if (customerID != null) {
                this.clearRoutes();
                this.fetchCustomerRoutes(customerID);
            }
        }
    }
    /**
     * @private
     * @param {?} customerID
     * @return {?}
     */
    fetchCustomerRoutes(customerID) {
        this.routes$ = this._routeService.getCustomerRoutes(customerID);
    }
    /**
     * @private
     * @return {?}
     */
    clearRoutes() {
        this.controls.RouteID.setValue('');
        this.routes$ = of([]);
    }
}
EditWellFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-edit-well-form',
                template: "<form [formGroup]=\"form\">\n    <div class=\"form-group\">\n        <label for=\"CustomerID\">Producer</label>\n        <select id=\"CustomerID\" formControlName=\"CustomerID\" class=\"form-control\"\n                [ngClass]=\"{ 'is-invalid': showErrors && controls.CustomerID.errors }\">\n            <option disabled selected hidden value=\"\">Select producer</option>\n            <option *ngFor=\"let producer of producers; trackBy: getCustomerID\" [value]=\"producer.CustomerID\">\n                {{producer.Code}}\n            </option>\n        </select>\n\n        <div *ngIf=\"showErrors && controls.CustomerID.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"controls.CustomerID.errors.required\">Producer is required</div>\n        </div>\n    </div>\n\n    <div class=\"form-group\">\n        <label for=\"RouteID\">Route</label>\n        <select id=\"RouteID\" formControlName=\"RouteID\" class=\"form-control\"\n                [ngClass]=\"{ 'is-invalid': showErrors && controls.RouteID.errors }\">\n            <option disabled selected hidden value=\"\">Select route</option>\n            <option *ngFor=\"let route of routes$ | async; trackBy: getRouteID\" [value]=\"route.RouteID\">\n                {{route.Name}}\n            </option>\n        </select>\n\n        <div *ngIf=\"showErrors && controls.RouteID.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"controls.RouteID.errors.required\">Route is required</div>\n        </div>\n    </div>\n\n    <div class=\"form-group\">\n        <label for=\"Name\">Name</label>\n        <input id=\"Name\" formControlName=\"Name\" class=\"form-control\" placeholder=\"Enter name\"\n               [ngClass]=\"{ 'is-invalid': showErrors && controls.Name.errors }\" />\n\n        <div *ngIf=\"showErrors && controls.Name.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"controls.Name.errors.required\">Name is required</div>\n            <div *ngIf=\"controls.Name.errors.maxlength\">Name cannot exceed 100 characters</div>\n        </div>\n    </div>\n\n    <div class=\"form-group\">\n        <label for=\"Description\">Description</label>\n        <textarea id=\"Description\" formControlName=\"Description\"\n                  class=\"form-control\" placeholder=\"Enter description\" rows=\"5\"></textarea>\n    </div>\n\n    <div class=\"form-group mb-0\">\n        <label class=\"mr-2\">Has H2S?</label>\n        <div class=\"form-check form-check-inline\">\n            <input formControlName=\"IsH2s\" type=\"radio\" value=\"Yes\" class=\"form-check-input\" aria-label=\"Well Has H2S\" />\n            <label class=\"form-check-label\">Yes</label>\n        </div>\n        <div class=\"form-check form-check-inline\">\n            <input formControlName=\"IsH2s\" type=\"radio\" value=\"No\" class=\"form-check-input\" aria-label=\"Well Did Not Has H2S\" />\n            <label class=\"form-check-label\">No</label>\n        </div>\n    </div>\n\n    <div class=\"form-group\">\n        <label for=\"State\">State</label>\n        <select id=\"State\" formControlName=\"State\" class=\"form-control\">\n            <option disabled selected hidden value=\"\">Select state</option>\n            <option *ngFor=\"let state of states; trackBy: getIndex\" [value]=\"state.Index\">\n                {{state.Description}}\n            </option>\n        </select>\n    </div>\n</form>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
EditWellFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: RouteService }
];
EditWellFormComponent.propDecorators = {
    well: [{ type: Input }],
    producers: [{ type: Input }],
    states: [{ type: Input }],
    showErrors: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    EditWellFormComponent.prototype.well;
    /** @type {?} */
    EditWellFormComponent.prototype.producers;
    /** @type {?} */
    EditWellFormComponent.prototype.states;
    /** @type {?} */
    EditWellFormComponent.prototype.showErrors;
    /**
     * @type {?}
     * @private
     */
    EditWellFormComponent.prototype._customerID;
    /** @type {?} */
    EditWellFormComponent.prototype.form;
    /** @type {?} */
    EditWellFormComponent.prototype.routes$;
    /**
     * @type {?}
     * @private
     */
    EditWellFormComponent.prototype._formBuilder;
    /**
     * @type {?}
     * @private
     */
    EditWellFormComponent.prototype._routeService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/create-well/create-well.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IRouteData() { }
if (false) {
    /** @type {?} */
    IRouteData.prototype.producers;
    /** @type {?} */
    IRouteData.prototype.states;
}
class CreateWellComponent {
    /**
     * @param {?} _route
     * @param {?} _wellService
     */
    constructor(_route, _wellService) {
        this._route = _route;
        this._wellService = _wellService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._routeDataSub = this._route.data.subscribe({
            next: (/**
             * @param {?} data
             * @return {?}
             */
            (data) => {
                this.producers = data.producers;
                this.states = data.states;
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.errorMsg = `Failed to fetch well data: ${error.Message}`;
            })
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._routeDataSub.unsubscribe();
    }
    /**
     * @return {?}
     */
    onReset() {
        this.reset();
    }
    /**
     * @return {?}
     */
    onSubmit() {
        this.submitted = true;
        this.errorMsg = '';
        this.successMsg = '';
        if (this._wellForm.form.invalid) {
            return;
        }
        this.creating = true;
        /** @type {?} */
        const well = this._wellForm.data();
        this._wellService.createWell(well).subscribe({
            next: (/**
             * @param {?} newWell
             * @return {?}
             */
            newWell => {
                this.reset();
                this.creating = false;
                this.successMsg = 'Well was added successfully';
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.errorMsg = `Well was not added: ${error.Message}`;
                this.creating = false;
            })
        });
    }
    /**
     * @return {?}
     */
    reset() {
        this.submitted = false;
        this._wellForm.reset();
    }
}
CreateWellComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-create-well',
                template: "<h2>Add Well</h2>\n\n<eec-edit-well-form  #editWellForm\n    [producers]=\"producers\"\n    [showErrors]=\"submitted\"\n    [states]=\"states\">\n</eec-edit-well-form>\n\n<eec-form-alerts \n    [formInvalid]=\"submitted && editWellForm.form.invalid\" \n    [errorMsg]=\"errorMsg\" \n    [successMsg]=\"successMsg\">\n</eec-form-alerts>\n\n<button [disabled]=\"creating\" class=\"btn btn-secondary my-2 mr-2\" type=\"reset\" (click)=\"onReset()\">Reset</button>\n<button [disabled]=\"creating\" class=\"btn btn-primary my-2 mr-2\" type=\"submit\" (click)=\"onSubmit()\">\n    <eec-spinner [hidden]=\"!creating\" small=\"true\" class=\"m-1\"></eec-spinner>\n    Add Well\n</button>",
                styles: [""]
            }] }
];
/** @nocollapse */
CreateWellComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: WellService }
];
CreateWellComponent.propDecorators = {
    _wellForm: [{ type: ViewChild, args: [EditWellFormComponent, { static: false },] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    CreateWellComponent.prototype._wellForm;
    /**
     * @type {?}
     * @private
     */
    CreateWellComponent.prototype._routeDataSub;
    /** @type {?} */
    CreateWellComponent.prototype.producers;
    /** @type {?} */
    CreateWellComponent.prototype.states;
    /** @type {?} */
    CreateWellComponent.prototype.submitted;
    /** @type {?} */
    CreateWellComponent.prototype.creating;
    /** @type {?} */
    CreateWellComponent.prototype.successMsg;
    /** @type {?} */
    CreateWellComponent.prototype.errorMsg;
    /**
     * @type {?}
     * @private
     */
    CreateWellComponent.prototype._route;
    /**
     * @type {?}
     * @private
     */
    CreateWellComponent.prototype._wellService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/customer-route-search-form/customer-route-search-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICustomerRouteChange() { }
if (false) {
    /** @type {?} */
    ICustomerRouteChange.prototype.CustomerID;
    /** @type {?} */
    ICustomerRouteChange.prototype.RouteID;
    /** @type {?} */
    ICustomerRouteChange.prototype.SearchKeyword;
}
class CustomerRouteSearchFormComponent {
    /**
     * @param {?} _formBuilder
     * @param {?} _routeService
     */
    constructor(_formBuilder, _routeService) {
        this._formBuilder = _formBuilder;
        this._routeService = _routeService;
        this.customerRouteChanged = new EventEmitter();
        this.customerPlaceholder = 'All Customers';
        this.routePlaceholder = 'All Routes';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.form = this._formBuilder.group({
            CustomerID: [''],
            RouteID: [''],
            SearchKeyword: ['']
        });
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes == null || this.form == null) {
            return;
        }
        if (changes.customers.currentValue !== changes.customers.previousValue) {
            this.selectInitialCustomer();
        }
    }
    /**
     * @param {?} route
     * @return {?}
     */
    getRouteID(route) {
        return route.RouteID;
    }
    /**
     * @param {?} customer
     * @return {?}
     */
    getCustomerID(customer) {
        return customer.CustomerID;
    }
    /**
     * @return {?}
     */
    get controls() {
        return this.form.controls;
    }
    /**
     * @return {?}
     */
    onCustomerIDChanged() {
        /** @type {?} */
        const customerID = InputConverterService.parseInt(this.controls.CustomerID.value);
        this.refreshRoutes(customerID);
        this.customerRouteChanged.emit({
            CustomerID: customerID,
            RouteID: null,
            SearchKeyword: null
        });
    }
    /**
     * @private
     * @param {?} customerID
     * @return {?}
     */
    refreshRoutes(customerID) {
        this.controls.RouteID.setValue('');
        if (customerID != null) {
            this.routes$ = this._routeService.getCustomerRoutes(customerID);
        }
        else {
            this.routes$ = null;
        }
    }
    /**
     * @return {?}
     */
    onRouteIDChanged() {
        /** @type {?} */
        const routeID = InputConverterService.parseInt(this.controls.RouteID.value);
        /** @type {?} */
        const customerID = InputConverterService.parseInt(this.controls.CustomerID.value);
        this.customerRouteChanged.emit({
            CustomerID: customerID,
            RouteID: routeID,
            SearchKeyword: null
        });
    }
    /**
     * @private
     * @return {?}
     */
    selectInitialCustomer() {
        /** @type {?} */
        let customerID = '';
        if (this.autoSelectCustomer && this.customers != null && this.customers.length > 0) {
            customerID = this.customers[0].CustomerID.toString();
        }
        this.controls.CustomerID.setValue(customerID);
    }
    /**
     * @return {?}
     */
    onSearch() {
        /** @type {?} */
        const routeID = InputConverterService.parseInt(this.controls.RouteID.value);
        /** @type {?} */
        const customerID = InputConverterService.parseInt(this.controls.CustomerID.value);
        /** @type {?} */
        const searchKeyword = this.controls.SearchKeyword.value == '' ? 'nofilter' : this.controls.SearchKeyword.value;
        this.customerRouteChanged.emit({
            CustomerID: customerID,
            RouteID: routeID,
            SearchKeyword: searchKeyword
        });
    }
}
CustomerRouteSearchFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-customer-route-search-form',
                template: "<form class=\"form-inline\" [formGroup]=\"form\">\n    <select formControlName=\"CustomerID\" class=\"form-control mr-2\"\n           (change)=\"onCustomerIDChanged()\">\n        <option selected value=\"\">{{customerPlaceholder}}</option>\n        <option *ngFor=\"let customer of customers; trackBy: getCustomerID\" [value]=\"customer.CustomerID\">\n            {{customer.Code}}\n        </option>\n    </select>\n    <select formControlName=\"RouteID\" class=\"form-control mr-2\"\n           (change)=\"onRouteIDChanged()\">\n        <option selected value=\"\">{{routePlaceholder}}</option>\n        <option *ngFor=\"let route of routes$ | async; trackBy: getRouteID\" [value]=\"route.RouteID\">\n            {{route.Name}}\n        </option>\n    </select>\n    <input formControlName=\"SearchKeyword\" class=\"form-control mr-2\" placeholder=\"Enter Keyword For Well\" />\n    <button id=\"btnSearch\" [disabled]=\"searching\" class=\"btn btn-primary mx-2\" type=\"submit\" (click)=\"onSearch()\">\n        <eec-spinner [hidden]=\"!searching\" small=\"true\" class=\"m-1\"></eec-spinner>\n        Search\n    </button>\n</form>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
CustomerRouteSearchFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: RouteService }
];
CustomerRouteSearchFormComponent.propDecorators = {
    customers: [{ type: Input }],
    autoSelectCustomer: [{ type: Input }],
    customerPlaceholder: [{ type: Input }],
    routePlaceholder: [{ type: Input }],
    customerRouteChanged: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    CustomerRouteSearchFormComponent.prototype.customers;
    /** @type {?} */
    CustomerRouteSearchFormComponent.prototype.autoSelectCustomer;
    /** @type {?} */
    CustomerRouteSearchFormComponent.prototype.customerPlaceholder;
    /** @type {?} */
    CustomerRouteSearchFormComponent.prototype.routePlaceholder;
    /** @type {?} */
    CustomerRouteSearchFormComponent.prototype.customerRouteChanged;
    /** @type {?} */
    CustomerRouteSearchFormComponent.prototype.form;
    /** @type {?} */
    CustomerRouteSearchFormComponent.prototype.routes$;
    /** @type {?} */
    CustomerRouteSearchFormComponent.prototype.searching;
    /**
     * @type {?}
     * @private
     */
    CustomerRouteSearchFormComponent.prototype._formBuilder;
    /**
     * @type {?}
     * @private
     */
    CustomerRouteSearchFormComponent.prototype._routeService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/download-file/download-file.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const FileDownloadAction = {
    PromptForDownload: 0,
    ShowInNewTab: 1,
};
FileDownloadAction[FileDownloadAction.PromptForDownload] = 'PromptForDownload';
FileDownloadAction[FileDownloadAction.ShowInNewTab] = 'ShowInNewTab';
/**
 * @record
 */
function IFileDownloadResult() { }
if (false) {
    /** @type {?} */
    IFileDownloadResult.prototype.fileName;
    /** @type {?} */
    IFileDownloadResult.prototype.mimeType;
}
class DownloadFileComponent {
    /**
     * @param {?} _fileService
     * @param {?} _sanitizer
     */
    constructor(_fileService, _sanitizer) {
        this._fileService = _fileService;
        this._sanitizer = _sanitizer;
        this._action = FileDownloadAction.PromptForDownload;
    }
    /**
     * @return {?}
     */
    get safeFileObjectUrl() {
        return this._safeFileObjectUrl;
    }
    /**
     * @return {?}
     */
    get fileName() {
        return this._fileName;
    }
    /**
     * @return {?}
     */
    get mimeType() {
        return this._mimeType;
    }
    /**
     * @return {?}
     */
    get promptForDownload() {
        return this._safeFileObjectUrl != null && this._action === FileDownloadAction.PromptForDownload;
    }
    /**
     * @return {?}
     */
    get showInNewTab() {
        return this._safeFileObjectUrl != null && this._action === FileDownloadAction.ShowInNewTab;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.disposeFile();
    }
    /**
     * @private
     * @return {?}
     */
    disposeFile() {
        if (this._fileObjectUrl) {
            URL.revokeObjectURL(this._fileObjectUrl);
            this._fileObjectUrl = null;
            this._safeFileObjectUrl = null;
            this._fileName = null;
            this._mimeType = null;
        }
    }
    /**
     * @param {?=} action
     * @return {?}
     */
    startDownload(action) {
        if (!action) {
            action = FileDownloadAction.PromptForDownload;
        }
        this._action = action;
        return this._requestDownload();
    }
    /**
     * @param {?=} action
     * @return {?}
     */
    startPrevDownload(action) {
        if (!action) {
            action = FileDownloadAction.PromptForDownload;
        }
        this._action = action;
        return this._requestPrevDownload();
    }
    /**
     * @private
     * @return {?}
     */
    _requestDownload() {
        if (!this.downloadCompleted) {
            return this._downloadResultSubject.asObservable();
        }
        this.disposeFile();
        this._downloadResultSubject = new ReplaySubject(1);
        /** @type {?} */
        let downloadRequest$;
        if (typeof (this.request) === 'string') {
            downloadRequest$ = this._fileService.downloadFile(this.request);
        }
        else {
            downloadRequest$ = this.request();
        }
        downloadRequest$.subscribe({
            next: (/**
             * @param {?} fileInfo
             * @return {?}
             */
            (fileInfo) => {
                this._fileName = fileInfo.FileName;
                this._mimeType = fileInfo.MimeType;
                /** @type {?} */
                const fileObjectUrl = this._fileService.getFileAsObjectUrl(fileInfo.FileData);
                this._fileObjectUrl = fileObjectUrl;
                this._safeFileObjectUrl = this._sanitizer.bypassSecurityTrustUrl(fileObjectUrl);
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this._downloadResultSubject.error(error);
                this._downloadResultSubject.complete();
                this._downloadResultSubject = null;
            }),
            complete: (/**
             * @return {?}
             */
            () => {
                this.onDownloadCompleted();
            })
        });
        return this._downloadResultSubject.asObservable();
    }
    /**
     * @private
     * @return {?}
     */
    _requestPrevDownload() {
        if (!this.downloadCompleted) {
            return this._downloadResultSubject.asObservable();
        }
        this.disposeFile();
        this._downloadResultSubject = new ReplaySubject(1);
        /** @type {?} */
        let downloadPrevRequest$;
        if (typeof (this.requestPrev) === 'string') {
            downloadPrevRequest$ = this._fileService.downloadPrevFile(this.requestPrev);
        }
        else {
            downloadPrevRequest$ = this.requestPrev();
        }
        downloadPrevRequest$.subscribe({
            next: (/**
             * @param {?} fileInfo
             * @return {?}
             */
            (fileInfo) => {
                this._fileName = fileInfo.FileName;
                this._mimeType = fileInfo.MimeType;
                /** @type {?} */
                const fileObjectUrl = this._fileService.getFileAsObjectUrl(fileInfo.FileData);
                this._fileObjectUrl = fileObjectUrl;
                this._safeFileObjectUrl = this._sanitizer.bypassSecurityTrustUrl(fileObjectUrl);
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this._downloadResultSubject.error(error);
                this._downloadResultSubject.complete();
                this._downloadResultSubject = null;
            }),
            complete: (/**
             * @return {?}
             */
            () => {
                this.onDownloadCompleted();
            })
        });
        return this._downloadResultSubject.asObservable();
    }
    /**
     * @private
     * @return {?}
     */
    get downloadCompleted() {
        return this._downloadResultSubject == null || this._downloadResultSubject.isStopped;
    }
    /**
     * @return {?}
     */
    onDownloaded() {
        /** @type {?} */
        const downloadResult = {
            fileName: this.fileName,
            mimeType: this.mimeType
        };
        this._downloadResultSubject.next(downloadResult);
        this.onDownloadCompleted();
    }
    /**
     * @private
     * @return {?}
     */
    onDownloadCompleted() {
        this._downloadResultSubject.complete();
    }
}
DownloadFileComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-download-file',
                template: "    <eec-download-file-trigger \n        *ngIf=\"promptForDownload;\" \n        [fileObjectUrl]=\"safeFileObjectUrl\" \n        [fileName]=\"fileName\"\n        (downloaded)=\"onDownloaded()\">\n    </eec-download-file-trigger>\n    <eec-view-file-trigger\n        *ngIf=\"showInNewTab\"\n        [fileObjectUrl]=\"safeFileObjectUrl\"\n        (viewed)=\"onDownloaded()\">\n    </eec-view-file-trigger>\n\n",
                styles: [""]
            }] }
];
/** @nocollapse */
DownloadFileComponent.ctorParameters = () => [
    { type: FileService },
    { type: DomSanitizer }
];
DownloadFileComponent.propDecorators = {
    request: [{ type: Input }],
    requestPrev: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    DownloadFileComponent.prototype.request;
    /** @type {?} */
    DownloadFileComponent.prototype.requestPrev;
    /**
     * @type {?}
     * @private
     */
    DownloadFileComponent.prototype._downloadResultSubject;
    /**
     * @type {?}
     * @private
     */
    DownloadFileComponent.prototype._fileObjectUrl;
    /**
     * @type {?}
     * @private
     */
    DownloadFileComponent.prototype._action;
    /**
     * @type {?}
     * @private
     */
    DownloadFileComponent.prototype._safeFileObjectUrl;
    /**
     * @type {?}
     * @private
     */
    DownloadFileComponent.prototype._fileName;
    /**
     * @type {?}
     * @private
     */
    DownloadFileComponent.prototype._mimeType;
    /**
     * @type {?}
     * @private
     */
    DownloadFileComponent.prototype._fileService;
    /**
     * @type {?}
     * @private
     */
    DownloadFileComponent.prototype._sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/download-file-button/download-file-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DownloadFileButtonComponent {
    constructor() {
        this.downloaded = new EventEmitter();
        this.downloadFailed = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    onDownload() {
        this.downloading = true;
        this._downloadFileComponent.startDownload().subscribe({
            next: (/**
             * @param {?} result
             * @return {?}
             */
            result => {
                this.downloaded.emit(result);
                this.downloading = false;
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.downloadFailed.emit(error);
                this.downloading = false;
            }),
            complete: (/**
             * @return {?}
             */
            () => {
                this.downloading = false;
            })
        });
    }
}
DownloadFileButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-download-file-button',
                template: "<button class=\"btn btn-secondary\" type=\"button\" (click)=\"onDownload()\" [disabled]=\"downloading || disabled\">\n    <eec-spinner [hidden]=\"!downloading\" small=\"true\" class=\"mr-1\"></eec-spinner>\n    <span>{{label}}</span>\n    <span class=\"mx-1\">\n        <i class=\"fa fa-download\"></i>\n    </span>\n</button>\n<eec-download-file [request]=\"request\"></eec-download-file>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
DownloadFileButtonComponent.ctorParameters = () => [];
DownloadFileButtonComponent.propDecorators = {
    _downloadFileComponent: [{ type: ViewChild, args: [DownloadFileComponent, { static: false },] }],
    request: [{ type: Input }],
    label: [{ type: Input }],
    disabled: [{ type: Input }],
    downloaded: [{ type: Output }],
    downloadFailed: [{ type: Output }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    DownloadFileButtonComponent.prototype._downloadFileComponent;
    /** @type {?} */
    DownloadFileButtonComponent.prototype.request;
    /** @type {?} */
    DownloadFileButtonComponent.prototype.label;
    /** @type {?} */
    DownloadFileButtonComponent.prototype.disabled;
    /** @type {?} */
    DownloadFileButtonComponent.prototype.downloaded;
    /** @type {?} */
    DownloadFileButtonComponent.prototype.downloadFailed;
    /** @type {?} */
    DownloadFileButtonComponent.prototype.downloading;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/report.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReportService {
    /**
     * @param {?} _http
     * @param {?} _fileService
     * @param {?} _appConfig
     */
    constructor(_http, _fileService, _appConfig) {
        this._http = _http;
        this._fileService = _fileService;
        this._appConfig = _appConfig;
    }
    /**
     * @param {?} reportID
     * @return {?}
     */
    downloadReport(reportID) {
        /** @type {?} */
        const requestUrl = this.getReportDownloadLink(reportID);
        return this._fileService.downloadFile(requestUrl);
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    downloadPreviousReport(wellID) {
        /** @type {?} */
        const requestUrl = this.getPrevReportDownloadLink(wellID);
        return this._fileService.downloadPrevFile(requestUrl);
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    getPrevReportDownloadLink(wellID) {
        //alert("report Servicep");
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/report/${wellID}/prev/source`;
        return requestUrl;
    }
    /**
     * @param {?} reportID
     * @return {?}
     */
    getReportDownloadLink(reportID) {
        //alert("report Service");
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/report/${reportID}/source`;
        return requestUrl;
    }
    /**
     * @param {?} reportID
     * @return {?}
     */
    getReport(reportID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/report/${reportID}`;
        return this._http.get(requestUrl);
    }
    /**
     * @param {?} reportFile
     * @param {?} wellID
     * @param {?} inspectionDate
     * @param {?} hwl
     * @param {?=} reportID
     * @return {?}
     */
    uploadReport(reportFile, wellID, inspectionDate, hwl, reportID = null) {
        /** @type {?} */
        const hwlText = hwl != null ? hwl.toString() : '';
        /** @type {?} */
        const requestData = new FormData();
        requestData.append('File', reportFile);
        requestData.append('WellID', wellID.toString());
        requestData.append('InspectionDate', inspectionDate.toISOString());
        requestData.append('HWL', hwlText);
        if (reportID != null) {
            requestData.append('ReportID', reportID.toString());
            return this.updateReport(requestData);
        }
        else {
            return this.createReport(requestData);
        }
    }
    /**
     * @private
     * @param {?} requestData
     * @return {?}
     */
    createReport(requestData) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/report`;
        return this._http.post(requestUrl, requestData);
    }
    /**
     * @private
     * @param {?} requestData
     * @return {?}
     */
    updateReport(requestData) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/report`;
        return this._http.put(requestUrl, requestData);
    }
}
ReportService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ReportService.ctorParameters = () => [
    { type: HttpClient },
    { type: FileService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ ReportService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ReportService_Factory() { return new ReportService(ɵɵinject(HttpClient), ɵɵinject(FileService), ɵɵinject(APP_CONFIG)); }, token: ReportService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ReportService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    ReportService.prototype._fileService;
    /**
     * @type {?}
     * @private
     */
    ReportService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/download-report-button/download-report-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DownloadReportButtonComponent {
    /**
     * @param {?} _reportService
     */
    constructor(_reportService) {
        this._reportService = _reportService;
        this.downloadFailed = new EventEmitter();
        this.requestReport = (/**
         * @return {?}
         */
        () => {
            //alert("report download");
            return this._reportService.downloadReport(this.reportID);
        });
        this.requestPrevReport = (/**
         * @return {?}
         */
        () => {
            //alert("report downloadp");
            return this._reportService.downloadPreviousReport(this.wellID);
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onDownloadFailed(event) {
        this.downloadFailed.emit(event);
    }
}
DownloadReportButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-download-report-button',
                template: "<eec-view-or-download-file-button\n    label=\"View Report\" \n    [request]=\"requestReport\"\n    [requestPrev]=\"requestPrevReport\"\n    (downloadFailed)=\"onDownloadFailed($event)\">\n</eec-view-or-download-file-button>\n\n",
                styles: [""]
            }] }
];
/** @nocollapse */
DownloadReportButtonComponent.ctorParameters = () => [
    { type: ReportService }
];
DownloadReportButtonComponent.propDecorators = {
    reportID: [{ type: Input }],
    wellID: [{ type: Input }],
    reportName: [{ type: Input }],
    downloadFailed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    DownloadReportButtonComponent.prototype.reportID;
    /** @type {?} */
    DownloadReportButtonComponent.prototype.wellID;
    /** @type {?} */
    DownloadReportButtonComponent.prototype.reportName;
    /** @type {?} */
    DownloadReportButtonComponent.prototype.downloadFailed;
    /** @type {?} */
    DownloadReportButtonComponent.prototype.requestReport;
    /** @type {?} */
    DownloadReportButtonComponent.prototype.requestPrevReport;
    /**
     * @type {?}
     * @private
     */
    DownloadReportButtonComponent.prototype._reportService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/edit-contact-form/edit-contact-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFormData$1() { }
if (false) {
    /** @type {?} */
    IFormData$1.prototype.FirstName;
    /** @type {?} */
    IFormData$1.prototype.LastName;
}
class EditContactFormComponent {
    /**
     * @param {?} _formBuilder
     */
    constructor(_formBuilder) {
        this._formBuilder = _formBuilder;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.form = this._formBuilder.group({
            FirstName: ['', Validators.maxLength(50)],
            LastName: ['', Validators.maxLength(50)]
        });
        this.reset();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!changes) {
            return;
        }
        /** @type {?} */
        const contactChanges = changes.contact;
        if (contactChanges && contactChanges.currentValue !== contactChanges.previousValue) {
            this.reset();
        }
    }
    /**
     * @return {?}
     */
    get controls() {
        return this.form.controls;
    }
    /**
     * @return {?}
     */
    reset() {
        /** @type {?} */
        const formData = {
            FirstName: this.contact != null ? this.contact.FirstName : '',
            LastName: this.contact != null ? this.contact.LastName : ''
        };
        this.form.reset(formData);
    }
    /**
     * @return {?}
     */
    get data() {
        /** @type {?} */
        const data = {
            Address: null,
            Address2: null,
            City: null,
            EmailAddress: null,
            FirstName: InputConverterService.trim(this.form.value.FirstName),
            LastName: InputConverterService.trim(this.form.value.LastName),
            MobilePhone: null,
            StateCode: null,
            WorkPhone: null,
            Zip: null
        };
        return data;
    }
}
EditContactFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-edit-contact-form',
                template: "<form [formGroup]=\"form\">\n    <div class=\"form-group\">\n        <label for=\"FirstName\">First Name</label>\n        <input id=\"FirstName\" formControlName=\"FirstName\" class=\"form-control\" placeholder=\"Enter first name\"\n               [ngClass]=\"{ 'is-invalid': showErrors && controls.FirstName.errors }\"/>\n\n        <div *ngIf=\"showErrors && controls.FirstName.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"controls.FirstName.errors.maxlength\">First name cannot be longer than 50 characters</div>\n        </div>\n    </div>\n\n    <div class=\"form-group\">\n        <label for=\"LastName\">Last Name</label>\n        <input id=\"LastName\" formControlName=\"LastName\" class=\"form-control\" placeholder=\"Enter last name\"\n               [ngClass]=\"{ 'is-invalid': showErrors && controls.LastName.errors }\"/>\n\n        <div *ngIf=\"showErrors && controls.LastName.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"controls.LastName.errors.maxlength\">Last name cannot be longer than 50 characters</div>\n        </div>\n    </div>\n</form>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
EditContactFormComponent.ctorParameters = () => [
    { type: FormBuilder }
];
EditContactFormComponent.propDecorators = {
    contact: [{ type: Input }],
    showErrors: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    EditContactFormComponent.prototype.contact;
    /** @type {?} */
    EditContactFormComponent.prototype.showErrors;
    /** @type {?} */
    EditContactFormComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    EditContactFormComponent.prototype._formBuilder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/condition-category.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const ConditionCategory = {
    Blue: "BLU",
    HWL: "HWL",
    NA: "NA",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/customer.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomerService {
    /**
     * @param {?} _http
     * @param {?} _appConfig
     */
    constructor(_http, _appConfig) {
        this._http = _http;
        this._appConfig = _appConfig;
    }
    /**
     * @return {?}
     */
    getAllCustomers() {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @return {?}
     */
    getCustomersForFilters() {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/filter`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @return {?}
     */
    getCustomerList() {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customers/list`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} customerID
     * @return {?}
     */
    getCustomerReps(customerID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/reps`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} customer
     * @return {?}
     */
    createCustomer(customer) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer`;
        return this._http.post(requestUrl, customer).pipe(shareReplay(1));
    }
    /**
     * @param {?} customer
     * @return {?}
     */
    updateCustomer(customer) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer`;
        return this._http.put(requestUrl, customer).pipe(shareReplay(1));
    }
    /**
     * @param {?} customerID
     * @return {?}
     */
    getCustomer(customerID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} customerID
     * @return {?}
     */
    deleteCustomer(customerID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}`;
        return this._http.delete(requestUrl);
    }
}
CustomerService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CustomerService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ CustomerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(ɵɵinject(HttpClient), ɵɵinject(APP_CONFIG)); }, token: CustomerService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CustomerService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    CustomerService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/file-ext.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} supportedExtensions
 * @return {?}
 */
function FileExtValidator(supportedExtensions) {
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        /** @type {?} */
        const fileName = control.value;
        if (fileName == null || fileName.length === 0) {
            return null;
        }
        /** @type {?} */
        const isSupported = FileHelper.isSupportedFileType(fileName, supportedExtensions);
        if (isSupported) {
            return null;
        }
        return {
            fileExt: supportedExtensions.join(', ')
        };
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/hwl.constant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const HWLRange = {
    Min: 10,
    Max: 100,
};
HWLRange[HWLRange.Min] = 'Min';
HWLRange[HWLRange.Max] = 'Max';
class HWL {
    /**
     * @param {?} hwl
     * @return {?}
     */
    static isValidRange(hwl) {
        return hwl != null && hwl >= HWLRange.Min && hwl <= HWLRange.Max;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/edit-inspection-form/edit-inspection-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFormData$2() { }
if (false) {
    /** @type {?} */
    IFormData$2.prototype.InspectionID;
    /** @type {?} */
    IFormData$2.prototype.InspectionDate;
    /** @type {?} */
    IFormData$2.prototype.CustomerID;
    /** @type {?} */
    IFormData$2.prototype.RouteID;
    /** @type {?} */
    IFormData$2.prototype.WellID;
    /** @type {?} */
    IFormData$2.prototype.searchedWell;
    /** @type {?} */
    IFormData$2.prototype.CustomerRepID;
    /** @type {?} */
    IFormData$2.prototype.VesselID;
    /** @type {?} */
    IFormData$2.prototype.ScanTechnicianID;
    /** @type {?} */
    IFormData$2.prototype.ReportID;
    /** @type {?} */
    IFormData$2.prototype.ReportName;
    /** @type {?} */
    IFormData$2.prototype.FireTube;
    /** @type {?} */
    IFormData$2.prototype.Anode;
    /** @type {?} */
    IFormData$2.prototype.FieldNote;
}
/**
 * @record
 */
function IEditInspectionFormResult() { }
if (false) {
    /** @type {?} */
    IEditInspectionFormResult.prototype.Inspection;
    /** @type {?} */
    IEditInspectionFormResult.prototype.FieldNoteAssetFile;
    /** @type {?} */
    IEditInspectionFormResult.prototype.InspectionReportFile;
}
class EditInspectionFormComponent {
    /**
     * @param {?} _formBuilder
     * @param {?} _customerService
     * @param {?} _routeService
     * @param {?} _wellService
     * @param {?} _inputConverterService
     */
    constructor(_formBuilder, _customerService, _routeService, _wellService, _inputConverterService) {
        this._formBuilder = _formBuilder;
        this._customerService = _customerService;
        this._routeService = _routeService;
        this._wellService = _wellService;
        this._inputConverterService = _inputConverterService;
        // form submit
        this.saved = false;
        this.show_autocompl = true;
        this.save = new EventEmitter();
        this.flag = 'Yes';
        this.isFromAdmin = false;
        this.isFromTech = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.form = this._formBuilder.group({
            // inspection specific fields
            InspectionID: [null],
            InspectionDate: ['', Validators.required],
            CustomerID: ['', Validators.required],
            RouteID: ['', Validators.required],
            WellID: [''],
            CustomerRepID: ['', Validators.required],
            VesselID: ['', Validators.maxLength(100)],
            ScanTechnicianID: [null],
            ReportID: [null],
            ReportName: ['', FileExtValidator(this.supportedReportExtensions)],
            FireTube: this._formBuilder.group({
                HWL: ['', [Validators.min(HWLRange.Min), Validators.max(HWLRange.Max)]],
                ConditionCategory: [ConditionCategory.NA],
                IsWhiteProtocol: [YesNo.No],
                HasTemperature: [YesNo.Yes],
                Temperature: ['', Validators.required],
                //ReplacedGasket: [YesNo.No],
                //ReplacedGasketIsBillable: [YesNo.No],
                TubeDiameter: ['', Validators.required],
                TubeThickness: [''],
                Orientation: ['', Validators.required]
            }),
            Anode: this._formBuilder.group({
                AnodeReading: [''],
                AnodeReadingType: [''],
                AnodeType: ['']
            }),
            FieldNote: this._formBuilder.group({
                Note: [''],
                AssetID: [null],
                AssetName: ['', FileExtValidator(this.supportedAssetExtensions)]
            })
        });
        this.form.controls.FireTube.get('ConditionCategory').valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        value => {
            /** @type {?} */
            const hasHwl = value === ConditionCategory.HWL;
            this.updateHwlControlState(hasHwl);
        }));
        this.form.controls.FireTube.get('HasTemperature').valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        value => {
            /** @type {?} */
            const hasTemperature = value === YesNo.Yes;
            this.updateTemperatureControlState(hasTemperature);
        }));
        //this.form.controls.FireTube.get('ReplacedGasket').valueChanges.subscribe(value => {
        //	const replacedGasket = value === YesNo.Yes;
        //	this.updateReplacedGasketIsBillableControlState(replacedGasket);
        //});
        this.isFromAutoComplete = false;
        this.reset();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!changes) {
            return;
        }
        /** @type {?} */
        const inspectionChanges = changes.inspection;
        if (inspectionChanges && inspectionChanges.currentValue !== inspectionChanges.previousValue) {
            this.reset();
        }
        this.showErrorMsg = changes.errorMsg != null && !InputConverterService.isEmpty(changes.errorMsg.currentValue);
        this.showSuccessMsg = changes.successMsg != null && !InputConverterService.isEmpty(changes.successMsg.currentValue);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.cancelRefreshCustomerReps();
    }
    /**
     * @return {?}
     */
    get controls() {
        return this.form.controls;
    }
    /**
     * @param {?} customer
     * @return {?}
     */
    getCustomerID(customer) {
        return customer.CustomerID;
    }
    /**
     * @param {?} customerRep
     * @return {?}
     */
    getCustomerRepID(customerRep) {
        return customerRep.UserID;
    }
    /**
     * @param {?} route
     * @return {?}
     */
    getRouteID(route) {
        return route.RouteID;
    }
    /**
     * @param {?} well
     * @return {?}
     */
    getWellID(well) {
        return well.WellID;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onCustomerIDChanged(value) {
        this.clearRoutes();
        this.clearWells();
        this.clearCustomerReps();
        /** @type {?} */
        const customerID = InputConverterService.parseInt(value);
        if (customerID != null) {
            this.fetchCustomerRoutes(customerID);
            this.fetchCustomerReps(customerID);
        }
    }
    /**
     * @private
     * @param {?} customerID
     * @return {?}
     */
    fetchCustomerRoutes(customerID) {
        this.routes$ = this._routeService.getCustomerRoutes(customerID);
    }
    /**
     * @private
     * @param {?} wellID
     * @return {?}
     */
    fetchWellRoute(wellID) {
        this.routes$ = this._routeService.getWellRoute(wellID);
    }
    /**
     * @private
     * @param {?} customerID
     * @return {?}
     */
    fetchCustomerReps(customerID) {
        this.cancelRefreshCustomerReps();
        this._customerReps = [];
        this.filteredCustomerReps = [];
        this._customerService.getCustomerReps(customerID).subscribe((/**
         * @param {?} customerReps
         * @return {?}
         */
        customerReps => {
            this._customerReps = customerReps;
            this.filterCustomerReps();
        }));
    }
    /**
     * @private
     * @return {?}
     */
    filterCustomerReps() {
        if (this._customerReps == null || this._customerReps.length === 0) {
            this.filteredCustomerReps = [];
            return;
        }
        this.filteredCustomerReps = this._customerReps.filter((/**
         * @param {?} customerRep
         * @return {?}
         */
        customerRep => {
            return !customerRep.IsInactive || (this.inspection != null && customerRep.UserID === this.inspection.CustomerRepID);
        }));
    }
    /**
     * @private
     * @param {?} routeID
     * @return {?}
     */
    fetchRouteWells(routeID) {
        this.wells$ = this._wellService.getRouteWells(routeID);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onRouteIDChanged(value) {
        this.clearWells();
        /** @type {?} */
        const routeID = parseInt(value, 10);
        if (!isNaN(routeID)) {
            this.fetchRouteWells(routeID);
        }
        this.show_autocompl = false;
    }
    /**
     * @private
     * @return {?}
     */
    clearWells() {
        this.controls.WellID.setValue('');
        this.wells$ = of([]);
    }
    /**
     * @private
     * @return {?}
     */
    clearRoutes() {
        this.controls.RouteID.setValue('');
        this.routes$ = of([]);
    }
    /**
     * @private
     * @return {?}
     */
    cancelRefreshCustomerReps() {
        if (this._customerRepsSub != null) {
            this._customerRepsSub.unsubscribe();
            this._customerRepsSub = null;
        }
    }
    /**
     * @private
     * @return {?}
     */
    clearCustomerReps() {
        this.controls.CustomerRepID.setValue('');
        this._customerReps = [];
        this.filteredCustomerReps = [];
    }
    /**
     * @return {?}
     */
    onSubmit() {
        this.saved = true;
        if (this.form.invalid) {
            return;
        }
        /** @type {?} */
        const data = this.getEditedInspection();
        this.save.emit(data);
    }
    /**
     * @return {?}
     */
    onCancel() {
        this.reset();
    }
    /**
     * @private
     * @return {?}
     */
    getEditedInspection() {
        /** @type {?} */
        const data = (/** @type {?} */ (this.form.value));
        return {
            Inspection: {
                CustomerID: InputConverterService.parseInt(data.CustomerID),
                RouteID: InputConverterService.parseInt(data.RouteID),
                CustomerRepID: InputConverterService.parseInt(data.CustomerRepID),
                InspectionDate: InputConverterService.getDateAsUtc(data.InspectionDate),
                InspectionID: data.InspectionID,
                ScanTechnicianID: data.ScanTechnicianID,
                VesselID: InputConverterService.trim(data.VesselID),
                WellID: this.show_autocompl ? InputConverterService.parseInt(this.selectedWell) : InputConverterService.parseInt(data.WellID),
                searchedWell: '',
                ReportID: data.ReportID,
                ReportName: data.ReportName,
                Anode: this.getAnodeData(data),
                FieldNote: this.getFieldNoteData(data),
                FireTube: this.getFireTubeData(data)
            },
            FieldNoteAssetFile: this._assetImageFile,
            InspectionReportFile: this._reportFile
        };
    }
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    getFieldNoteData(data) {
        return {
            AssetID: data.FieldNote.AssetID,
            Note: InputConverterService.trim(data.FieldNote.Note),
        };
    }
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    getFireTubeData(data) {
        /** @type {?} */
        const hasHwl = data.FireTube.ConditionCategory === ConditionCategory.HWL;
        /** @type {?} */
        const isWhite = data.FireTube.IsWhiteProtocol === YesNo.Yes;
        //const replacedGasket = data.FireTube.ReplacedGasket === YesNo.Yes;
        //const replacedGasketIsBillable = data.FireTube.ReplacedGasketIsBillable === YesNo.Yes;
        return {
            HWL: hasHwl ? data.FireTube.HWL / 100 : null,
            ConditionCategory: data.FireTube.ConditionCategory,
            IsWhiteProtocol: isWhite,
            Orientation: data.FireTube.Orientation,
            //ReplacedGasket: replacedGasket,
            //ReplacedGasketIsBillable: replacedGasketIsBillable,
            Temperature: data.FireTube.Temperature,
            TubeDiameter: data.FireTube.TubeDiameter,
            TubeThickness: data.FireTube.TubeThickness
        };
    }
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    getAnodeData(data) {
        if (InputConverterService.isEmpty(data.Anode.AnodeType)) {
            return null;
        }
        return Object.assign({}, data.Anode);
    }
    /**
     * @return {?}
     */
    reset() {
        if (this.form == null) {
            return;
        }
        if (!this.isFromAutoComplete) {
            this.saved = false;
            this.resetFormData();
            this.refreshAllLists();
            this.initFormControlState();
        }
    }
    /**
     * @private
     * @return {?}
     */
    resetFormData() {
        /** @type {?} */
        const formData = this.getFormDataFromInspection();
        this.form.reset(formData);
        this.resetNewAssetImage();
        this.resetNewReportDoc();
    }
    /**
     * @private
     * @return {?}
     */
    refreshAllLists() {
        if (this.inspection != null && this.inspection.CustomerID != null) {
            this.fetchCustomerReps(this.inspection.CustomerID);
            this.fetchCustomerRoutes(this.inspection.CustomerID);
        }
        else {
            this.clearCustomerReps();
            this.clearRoutes();
        }
        if (this.inspection != null && this.inspection.RouteID != null) {
            this.fetchRouteWells(this.inspection.RouteID);
        }
        else {
            this.clearWells();
        }
    }
    /**
     * @private
     * @return {?}
     */
    initFormControlState() {
        /** @type {?} */
        const customerDisabled = this.inspection.InspectionID != null;
        if (customerDisabled) {
            this.controls.CustomerID.disable();
            this.controls.RouteID.disable();
            this.controls.WellID.disable();
            this.show_autocompl = false;
        }
        else {
            this.controls.CustomerID.enable();
            this.controls.RouteID.enable();
            this.controls.WellID.enable();
            this.show_autocompl = true;
        }
    }
    /**
     * @private
     * @param {?} hasHwl
     * @return {?}
     */
    updateHwlControlState(hasHwl) {
        /** @type {?} */
        const hwlCtrl = this.controls.FireTube.get('HWL');
        /** @type {?} */
        const whtCtrl = this.controls.FireTube.get('IsWhiteProtocol');
        if (hasHwl) {
            hwlCtrl.setValidators([Validators.required, Validators.min(HWLRange.Min), Validators.max(HWLRange.Max)]);
            hwlCtrl.enable();
            whtCtrl.enable();
        }
        else {
            hwlCtrl.setValidators([]);
            hwlCtrl.disable();
            whtCtrl.setValue(YesNo.No);
            whtCtrl.disable();
        }
    }
    /**
     * @private
     * @param {?} hasTemperature
     * @return {?}
     */
    updateTemperatureControlState(hasTemperature) {
        /** @type {?} */
        const temperatureCtrl = this.controls.FireTube.get('Temperature');
        if (hasTemperature) {
            temperatureCtrl.setValidators([Validators.required]);
            temperatureCtrl.enable();
        }
        else {
            temperatureCtrl.setValidators([]);
            temperatureCtrl.disable();
        }
    }
    /**
     * @private
     * @param {?} replacedGasket
     * @return {?}
     */
    updateReplacedGasketIsBillableControlState(replacedGasket) {
        /** @type {?} */
        const ctrl = this.controls.FireTube.get('ReplacedGasketIsBillable');
        if (replacedGasket) {
            ctrl.enable();
        }
        else {
            ctrl.setValue(YesNo.No);
            ctrl.disable();
        }
    }
    /**
     * @private
     * @return {?}
     */
    getFormDataFromInspection() {
        /** @type {?} */
        const fireTube = this.inspection != null ? this.inspection.FireTube : null;
        /** @type {?} */
        const anode = this.inspection != null ? this.inspection.Anode : null;
        /** @type {?} */
        const fieldNote = this.inspection != null ? this.inspection.FieldNote : null;
        /** @type {?} */
        const hwl = (fireTube != null && fireTube.HWL != null) ? fireTube.HWL * 100 : null;
        /** @type {?} */
        const condCategory = (fireTube != null && fireTube.ConditionCategory != null) ? fireTube.ConditionCategory : ConditionCategory.NA;
        /** @type {?} */
        const isWhite = fireTube != null ? fireTube.IsWhiteProtocol : false;
        /** @type {?} */
        const temperature = fireTube != null ? fireTube.Temperature : null;
        /** @type {?} */
        const hasTemperature = temperature != null;
        /** @type {?} */
        var today = new Date();
        /** @type {?} */
        var date;
        /** @type {?} */
        var inspection_date;
        /////////////////////////////////////////////////
        //////////// FOR FIELD TECH ONLY/////////////////
        /////////////////////////////////////////////////
        //if (this.isFromTech) {
        //	date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        //}
        //else {
        //	date = this.inspection.InspectionDate;
        //}
        //inspection_date = this._inputConverterService.formatDate(this.inspection != null ? date : null);
        ////////////////////////////////////////////////////////////////////
        //const replacedGasket = fireTube != null ? fireTube.ReplacedGasket : false;
        //const replacedGasketIsBillable = fireTube != null ? fireTube.ReplacedGasketIsBillable : false;
        /////////////////////////////////////////////////
        //////////// FOR ADMIN ONLY/////////////////
        /////////////////////////////////////////////////
        if (this.isFromAdmin) {
            inspection_date = this._inputConverterService.formatDate(this.inspection != null ? this.inspection.InspectionDate : null);
        }
        else {
            inspection_date = this._inputConverterService.formatDate(this.inspection != null ? date : null);
        }
        /** @type {?} */
        const formData = {
            InspectionID: this.inspection != null ? this.inspection.InspectionID : null,
            InspectionDate: inspection_date,
            //InspectionDate: this._inputConverterService.formatDate(this.inspection != null ? this.inspection.InspectionDate : null),
            //InspectionDate: this._inputConverterService.formatDate(this.inspection != null ? date : null),
            CustomerID: InputConverterService.numberToString(this.inspection != null ? this.inspection.CustomerID : null),
            RouteID: InputConverterService.numberToString(this.inspection != null ? this.inspection.RouteID : null),
            WellID: InputConverterService.numberToString(this.inspection != null ? this.inspection.WellID : null),
            searchedWell: '',
            CustomerRepID: InputConverterService.numberToString(this.inspection != null ? this.inspection.CustomerRepID : null),
            VesselID: this.inspection != null ? this.inspection.VesselID : null,
            ScanTechnicianID: this.inspection != null ? this.inspection.ScanTechnicianID : null,
            ReportID: this.inspection != null ? this.inspection.ReportID : null,
            ReportName: '',
            FireTube: {
                HWL: hwl,
                ConditionCategory: condCategory,
                IsWhiteProtocol: isWhite ? YesNo.Yes : YesNo.No,
                Orientation: fireTube != null ? fireTube.Orientation : null,
                //ReplacedGasket: replacedGasket ? YesNo.Yes : YesNo.No,
                //ReplacedGasketIsBillable: replacedGasketIsBillable ? YesNo.Yes : YesNo.No,
                HasTemperature: hasTemperature ? YesNo.Yes : YesNo.No,
                Temperature: temperature,
                TubeDiameter: fireTube != null ? fireTube.TubeDiameter : '',
                TubeThickness: fireTube != null && fireTube.TubeThickness != null ? fireTube.TubeThickness : ''
            },
            Anode: {
                AnodeReading: anode != null ? anode.AnodeReading : null,
                AnodeReadingType: anode != null ? anode.AnodeReadingType : '',
                AnodeType: anode != null ? anode.AnodeType : ''
            },
            FieldNote: {
                AssetID: fieldNote != null ? fieldNote.AssetID : null,
                AssetName: '',
                Note: fieldNote != null ? fieldNote.Note : ''
            }
        };
        this.isFromAutoComplete = false;
        return formData;
    }
    /**
     * @return {?}
     */
    get assetImage() {
        return this._assetImageSrc$ || this.controls.FieldNote.get('AssetID').value;
    }
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    refreshNewAssetImage(file) {
        if (!this.controls.FieldNote.get('AssetName').errors) {
            this._assetImageSrc$ = of(file);
            this._assetImageFile = file;
        }
        else {
            this._assetImageSrc$ = of(null);
            this._assetImageFile = null;
        }
    }
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    refreshReportDoc(file) {
        if (!this.controls.ReportName.errors) {
            this._reportFile = file;
        }
        else {
            this._reportFile = null;
        }
    }
    /**
     * @private
     * @return {?}
     */
    resetNewAssetImage() {
        this._assetImageSrc$ = null;
        this._assetImageFile = null;
        this.controls.FieldNote.get('AssetName').setValue('');
    }
    /**
     * @private
     * @return {?}
     */
    resetNewReportDoc() {
        this._reportFile = null;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onAssetChanged(event) {
        if (!event.target.files || event.target.files.length === 0) {
            return;
        }
        // if the user first removes the asset and then decides to add a file to replace it,
        // then make sure the existing asset is updated by restoring the asset ID
        /** @type {?} */
        const selectedFile = event.target.files[0];
        this.refreshNewAssetImage(selectedFile);
        this.resetAssetImageID();
    }
    /**
     * @private
     * @return {?}
     */
    resetAssetImageID() {
        /** @type {?} */
        const currentAssetImageID = this.inspection.FieldNote != null ? this.inspection.FieldNote.AssetID : null;
        this.controls.FieldNote.get('AssetID').reset(currentAssetImageID);
    }
    /**
     * @private
     * @return {?}
     */
    clearAssetImageID() {
        this.controls.FieldNote.get('AssetID').setValue(null);
    }
    /**
     * @return {?}
     */
    onRemoveAssetImage() {
        this.resetNewAssetImage();
        this.clearAssetImageID();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onReportChanged(event) {
        if (!event.target.files || event.target.files.length === 0) {
            return;
        }
        /** @type {?} */
        const selectedFile = event.target.files[0];
        this.refreshReportDoc(selectedFile);
    }
    /**
     * @param {?} item
     * @return {?}
     */
    getItemName(item) {
        this.selectedWell = item;
        this.isFromAutoComplete = true;
        this._wellService.getWell(parseInt(this.selectedWell)).subscribe((/**
         * @param {?} selectedWell
         * @return {?}
         */
        selectedWell => {
            this.fetchWellRoute(parseInt(this.selectedWell));
            this.controls.RouteID.setValue(selectedWell.RouteID);
            this._routeService.getRoute(selectedWell.RouteID).subscribe((/**
             * @param {?} selectedRoute
             * @return {?}
             */
            selectedRoute => {
                this.controls.CustomerID.setValue(selectedRoute.CustomerID);
                this.fetchCustomerReps(selectedRoute.CustomerID);
            }));
        }));
    }
}
EditInspectionFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-edit-inspection-form',
                template: "<form [formGroup]=\"form\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div class=\"form-group\">\n                <label for=\"InspectionDate\">Inspection Date</label>\n                <input id=\"InspectionDate\" formControlName=\"InspectionDate\" type=\"date\" class=\"form-control\" placeholder=\"Enter inspection date\"\n                       [ngClass]=\"{ 'is-invalid': saved && controls.InspectionDate.errors }\"/>\n        \n                <div *ngIf=\"saved && controls.InspectionDate.errors\" class=\"invalid-feedback\">\n                    <div *ngIf=\"controls.InspectionDate.errors.required\">Inspection date is required</div>\n                </div>\n            </div>\n        \n            <div class=\"form-group\">\n                <label for=\"CustomerID\">Oil Company</label>\n                <select id=\"CustomerID\" formControlName=\"CustomerID\" class=\"form-control\"\n                       [ngClass]=\"{ 'is-invalid': saved && controls.CustomerID.errors }\" \n                       (change)=\"onCustomerIDChanged($event.target.value)\">\n                    <option disabled selected hidden value=\"\">Select oil company</option>\n                    <option *ngFor=\"let customer of customers; trackBy: getCustomerID\" [value]=\"customer.CustomerID\">\n                        {{customer.Code}}\n                    </option>\n                </select>\n        \n                <div *ngIf=\"saved && controls.CustomerID.errors\" class=\"invalid-feedback\">\n                    <div *ngIf=\"controls.CustomerID.errors.required\">Oil company is required</div>\n                </div>\n            </div>\n        \n            <div class=\"form-group\">\n                <label for=\"RouteID\">Route</label>\n                <select id=\"RouteID\" formControlName=\"RouteID\" class=\"form-control\"\n                       [ngClass]=\"{ 'is-invalid': saved && controls.RouteID.errors }\"\n                       (change)=\"onRouteIDChanged($event.target.value)\">\n                    <option disabled selected hidden value=\"\">Select route</option>\n                    <option *ngFor=\"let route of routes$ | async; trackBy: getRouteID\" [value]=\"route.RouteID\">\n                        {{route.Name}}\n                    </option>\n                </select>\n        \n                <div *ngIf=\"saved && controls.RouteID.errors\" class=\"invalid-feedback\">\n                    <div *ngIf=\"controls.RouteID.errors.required\">Route is required</div>\n                </div>\n            </div>\n        \n            <div class=\"form-group\">\n                <label for=\"WellID\">Location</label>\n                <select *ngIf=\"!show_autocompl\" id=\"WellID\" formControlName=\"WellID\" class=\"form-control\">\n                        <!--[ngClass]=\"{ 'is-invalid': saved && controls.WellID.errors }\"-->\n                    \n                    <option disabled selected hidden value=\"\">Select location</option>\n                    <option *ngFor=\"let well of wells$ | async; trackBy: getWellID\" [value]=\"well.WellID\">\n                        {{well.Name}}\n                    </option>\n                </select>\n                <eec-autocomplete-inspection *ngIf=\"show_autocompl\" (itemName)=\"getItemName($event)\" class=\"mm-mew_class\" style=\"width:100% !important\" ></eec-autocomplete-inspection>\n                <input type=\"hidden\" style=\"width:100% !important\"  class=\"form-control mx-2\" value=\"{{selectedWell}}\"\n                       placeholder=\"Enter Well Name\"\n                       title=\"Search By Well Name\" />\n\n                <!--<div *ngIf=\"saved && controls.WellID.errors\" class=\"invalid-feedback\">\n                    <div *ngIf=\"controls.WellID.errors.required\">Location is required</div>\n                </div>-->\n            </div>\n        \n            <div class=\"form-group\">\n                <label for=\"CustomerRepID\">Company Rep</label>\n                <select id=\"CustomerRepID\" formControlName=\"CustomerRepID\" class=\"form-control\"\n                       [ngClass]=\"{ 'is-invalid': saved && controls.CustomerRepID.errors }\">\n                       <option disabled selected hidden value=\"\">Select company rep</option>\n                    <option *ngFor=\"let customerRep of filteredCustomerReps; trackBy: getCustomerRepID\" [value]=\"customerRep.UserID\">\n                        {{customerRep.Name || customerRep.LoginID}}\n                    </option>\n                </select>\n        \n                <div *ngIf=\"saved && controls.CustomerRepID.errors\" class=\"invalid-feedback\">\n                    <div *ngIf=\"controls.CustomerRepID.errors.required\">Company Rep is required</div>\n                </div>\n            </div>\n        \n            <div class=\"form-group\">\n                <label for=\"VesselID\">Vessel ID</label>\n                <input id=\"VesselID\" formControlName=\"VesselID\" type=\"text\" class=\"form-control\" placeholder=\"Enter vessel ID\"\n                       [ngClass]=\"{ 'is-invalid': saved && controls.VesselID.errors }\"/>\n        \n                <div *ngIf=\"saved && controls.VesselID.errors\" class=\"invalid-feedback\">\n                    <div *ngIf=\"controls.VesselID.errors.required\">Vessel ID is required</div>\n                    <div *ngIf=\"controls.VesselID.errors.maxlength\">Vessel ID cannot exceed 100 characters</div>\n                </div>\n            </div>\n        \n            <div formGroupName=\"FireTube\">\n                <div class=\"form-group\">\n                    <label for=\"HWL\">HWL</label>\n                    <div class=\"form-check\">\n                        <input type=\"radio\" class=\"form-check-input\" formControlName=\"ConditionCategory\" value=\"HWL\" />\n                        <div class=\"input-group\">\n                            <input id=\"HWL\" formControlName=\"HWL\" type=\"number\" class=\"form-control\" placeholder=\"Enter HWL\"\n                                   [ngClass]=\"{ 'is-invalid': saved && controls.FireTube.get('HWL').errors }\" />\n                            <div class=\"input-group-append\">\n                                <span class=\"input-group-text\">%</span>\n                            </div>\n                            <div *ngIf=\"saved && controls.FireTube.get('HWL').errors\" class=\"invalid-feedback\">\n                                <div *ngIf=\"controls.FireTube.get('HWL').errors.min ||\n                                    controls.FireTube.get('HWL').errors.max ||\n                                    controls.FireTube.get('HWL').errors.required\">\n                                    HWL must be between 10 and 100\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <!--White Protocol-->\n                    <div class=\"form-group ml-4\">\n                        <label class=\"mr-2\">White Protocol</label>\n                        <div class=\"form-check form-check-inline\">\n                            <input formControlName=\"IsWhiteProtocol\" type=\"radio\" value=\"Yes\" class=\"form-check-input\" />\n                            <label class=\"form-check-label\">Yes</label>\n                        </div>\n                        <div class=\"form-check form-check-inline\">\n                            <input formControlName=\"IsWhiteProtocol\" type=\"radio\" value=\"No\" class=\"form-check-input\" />\n                            <label class=\"form-check-label\">No</label>\n                        </div>\n                    </div>\n\n                    <div class=\"form-check\">\n                        <input type=\"radio\" class=\"form-check-input\" formControlName=\"ConditionCategory\" value=\"BLU\" />\n                        <label>Blue</label>\n                    </div>\n                    <div class=\"form-check mt-1\">\n                        <input type=\"radio\" class=\"form-check-input\" formControlName=\"ConditionCategory\" value=\"NA\" />\n                        <label>N/A</label>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"Temperature\">Temperature</label>\n                    <div class=\"form-check\">\n                        <input type=\"radio\" class=\"form-check-input\" [(ngModel)]=\"flag\" formControlName=\"HasTemperature\" value=\"Yes\" />\n                        <div class=\"input-group\">\n                            <input id=\"Temperature\" formControlName=\"Temperature\" type=\"number\" class=\"form-control\" placeholder=\"Enter temperature\"\n                                   [ngClass]=\"{ 'is-invalid': saved && controls.FireTube.get('Temperature').errors }\" />\n\n                            <div *ngIf=\"saved && controls.FireTube.get('Temperature').errors\" class=\"invalid-feedback\">\n                                <div *ngIf=\"controls.FireTube.get('Temperature').errors.required\">Temperature is required</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-check mt-1\">\n                        <input type=\"radio\" class=\"form-check-input\" [(ngModel)]=\"flag\" formControlName=\"HasTemperature\" value=\"No\" />\n                        <label>N/A</label>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"TubeDiameter\">Tube Diameter</label>\n                    <select id=\"TubeDiameter\" formControlName=\"TubeDiameter\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': saved && controls.FireTube.get('TubeDiameter').errors }\">\n                        <option disabled selected hidden value=\"\">Select tube diameter</option>\n                        <option *ngFor=\"let tubeDiameter of tubeDiameters\" [value]=\"tubeDiameter.Index\">\n                            {{tubeDiameter.Description}}\n                        </option>\n                    </select>\n\n                    <div *ngIf=\"saved && controls.FireTube.get('TubeDiameter').errors\" class=\"invalid-feedback\">\n                        <div *ngIf=\"controls.FireTube.get('TubeDiameter').errors.required\">Tube diameter is required</div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"TubeThickness\">Tube Thickness</label>\n                    <select id=\"TubeThickness\" formControlName=\"TubeThickness\" class=\"form-control\" >\n                        <option disabled selected hidden value=\"\">Select tube Thickness</option>\n                        <option value='1/4\"'>1/4&quot;</option>\n                        <option value='3/8\"'>3/8&quot;</option>\n                        <option value='1/2\"'>1/2&quot;</option>\n                    </select>\n\n                   \n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"Orientation\">Horizontal/Vertical</label>\n                    <select id=\"Orientation\" formControlName=\"Orientation\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': saved && controls.FireTube.get('Orientation').errors }\">\n                        <option disabled selected hidden value=\"\">Select orientation</option>\n                        <option *ngFor=\"let orientation of orientations\" [value]=\"orientation.Index\">\n                            {{orientation.Description}}\n                        </option>\n                    </select>\n\n                    <div *ngIf=\"saved && controls.FireTube.get('Orientation').errors\" class=\"invalid-feedback\">\n                        <div *ngIf=\"controls.FireTube.get('Orientation').errors.required\">Orientation is required</div>\n                    </div>\n                </div>\n\n                <!--<div class=\"form-group mb-0\">\n                    <label class=\"mr-2\">Replaced Gasket?</label>\n                    <div class=\"form-check form-check-inline\">\n                        <input formControlName=\"ReplacedGasket\" type=\"radio\" value=\"Yes\" class=\"form-check-input\" aria-label=\"Replaced Gasket\" />\n                        <label class=\"form-check-label\">Yes</label>\n                    </div>\n                    <div class=\"form-check form-check-inline\">\n                        <input formControlName=\"ReplacedGasket\" type=\"radio\" value=\"No\" class=\"form-check-input\" aria-label=\"Did Not Replace Gasket\" />\n                        <label class=\"form-check-label\">No</label>\n                    </div>\n                </div>\n\n                <div class=\"form-group ml-4\">\n                    <label class=\"mr-2\">Billable?</label>\n                    <div class=\"form-check form-check-inline\">\n                        <input formControlName=\"ReplacedGasketIsBillable\" type=\"radio\" value=\"Yes\" class=\"form-check-input\" aria-label=\"Replaced Gasket Is Billable\" />\n                        <label class=\"form-check-label\">Yes</label>\n                    </div>\n                    <div class=\"form-check form-check-inline\">\n                        <input formControlName=\"ReplacedGasketIsBillable\" type=\"radio\" value=\"No\" class=\"form-check-input\" aria-label=\"Replaced Gasket Is Not Billable\" />\n                        <label class=\"form-check-label\">No</label>\n                    </div>\n                </div>-->\n            </div>\n\n            <div formGroupName=\"Anode\">\n                <div class=\"form-group\">\n                    <label for=\"AnodeType\">Anode Type</label>\n                    <select id=\"AnodeType\" formControlName=\"AnodeType\" class=\"form-control\"\n                           [ngClass]=\"{ 'is-invalid': saved && controls.Anode.get('AnodeType').errors }\">\n                        <option disabled selected hidden value=\"\">Select anode type</option>\n                        <option *ngFor=\"let anodeType of anodeTypes\" [value]=\"anodeType.Index\">\n                            {{anodeType.Description}}\n                        </option>\n                    </select>\n            \n                    <div *ngIf=\"saved && controls.Anode.get('AnodeType').errors\" class=\"invalid-feedback\">\n                        <div *ngIf=\"controls.Anode.get('AnodeType').errors.required\">Anode type is required</div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"AnodeReading\">Anode Reading</label>\n                    <input id=\"AnodeReading\" formControlName=\"AnodeReading\" type=\"number\" class=\"form-control\" placeholder=\"Enter anode reading\"\n                           [ngClass]=\"{ 'is-invalid': saved && controls.Anode.get('AnodeReading').errors }\"/>\n            \n                    <div *ngIf=\"saved && controls.Anode.get('AnodeReading').errors\" class=\"invalid-feedback\">\n                        <div *ngIf=\"controls.Anode.get('AnodeReading').errors.required\">Anode reading is required</div>\n                    </div>\n                </div>\n            \n                <div class=\"form-group\">\n                    <label for=\"AnodeReadingType\">Anode Reading Type</label>\n                    <select id=\"AnodeReadingType\" formControlName=\"AnodeReadingType\" class=\"form-control\"\n                           [ngClass]=\"{ 'is-invalid': saved && controls.Anode.get('AnodeReading').errors }\">\n                        <option disabled selected hidden value=\"\">Select anode reading type</option>\n                        <option *ngFor=\"let anodeReadingType of anodeReadingTypes\" [value]=\"anodeReadingType.Index\">\n                            {{anodeReadingType.Description}}\n                        </option>\n                    </select>\n            \n                    <div *ngIf=\"saved && controls.Anode.get('AnodeReadingType').errors\" class=\"invalid-feedback\">\n                        <div *ngIf=\"controls.Anode.get('AnodeReadingType').errors.required\">Anode reading type is required</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-6\">\n            <div formGroupName=\"FieldNote\">\n                <div class=\"form-group\">\n                    <eec-edit-asset-image \n                        [asset]=\"assetImage\" \n                        (remove)=\"onRemoveAssetImage()\">\n                    </eec-edit-asset-image>\n                    \n                    <textarea id=\"Note\" formControlName=\"Note\" class=\"form-control mt-2\" placeholder=\"Additional Notes\"\n                        [ngClass]=\"{ 'is-invalid': saved && controls.FieldNote.get('Note').errors }\"\n                        rows=\"10\">\n                    </textarea>\n            \n                    <div *ngIf=\"saved && controls.FieldNote.get('Note').errors\" class=\"invalid-feedback\">\n                        <div *ngIf=\"controls.FieldNote.get('Note').errors.required\">Field Note is required</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"card border-primary\">\n                <h4 class=\"card-header text-white bg-primary\">Report</h4>\n                <div class=\"card-body\">\n                    <h6 class=\"card-title\">\n                        Upload Report\n                    </h6>\n                    <div class=\"form-group\">\n                        <input formControlName=\"ReportName\" aria-label=\"Upload Report\"\n                            class=\"form-control-file\" type=\"file\" [accept]=\"supportedReportExtensions.join(',')\" \n                            (change)=\"onReportChanged($event)\"\n                            [ngClass]=\"{ 'is-invalid': controls.ReportName.errors }\"/>\n                        <div *ngIf=\"controls.ReportName.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"controls.ReportName.errors.fileExt\">\n                                Only the following document extensions are supported: {{controls.FieldNote.get('AssetName').errors.fileExt}}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"card-footer border-primary bg-transparent\" *ngIf=\"inspection.ReportID\">\n                    <eec-download-report-button class=\"my-2 mr-2\" \n                        [reportID]=\"inspection.ReportID\" [reportName]=\"inspection.ReportName\">\n                    </eec-download-report-button>\n                </div>\n            </div>\n            <div class=\"card border-secondary mt-3\" formGroupName=\"FieldNote\">\n                <div class=\"card-body\">\n                    <h6 class=\"card-title\">\n                        Attach Image (optional)\n                    </h6>\n                    <div class=\"form-group\">\n                        <input formControlName=\"AssetName\" class=\"form-control-file\" type=\"file\"\n                            aria-label=\"Attach Image (optional)\" \n                            [accept]=\"supportedAssetExtensions.join(',')\" (change)=\"onAssetChanged($event)\"\n                            [ngClass]=\"{ 'is-invalid': controls.FieldNote.get('AssetName').errors }\"/>\n                        <div *ngIf=\"controls.FieldNote.get('AssetName').errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"controls.FieldNote.get('AssetName').errors.fileExt\">\n                                Only the following image extensions are supported: {{controls.FieldNote.get('AssetName').errors.fileExt}}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"saved && form.invalid\" class=\"text-danger my-1\">\n        <span>Please correct all input errors before continuing.</span>\n    </div>\n    <ngb-alert *ngIf=\"showErrorMsg\" type=\"danger\" class=\"my-1\" role=\"alert\" dismissable=\"true\" (close)=\"showErrorMsg = false\">\n        {{errorMsg}}\n    </ngb-alert>\n    <ngb-alert *ngIf=\"showSuccessMsg\" type=\"success\" class=\"my-1\" role=\"alert\" dismissable=\"true\" (close)=\"showSuccessMsg = false\">\n        {{successMsg}}\n    </ngb-alert>\n    <button [disabled]=\"saving\" class=\"btn btn-secondary my-2 mr-2\" (click)=\"onCancel()\">Cancel</button>\n    <button [disabled]=\"saving\" class=\"btn btn-primary my-2 mr-2\" type=\"submit\" (click)=\"onSubmit()\">\n        <eec-spinner [hidden]=\"!saving\" small=\"true\" class=\"m-1\"></eec-spinner>\n        {{saveButtonLabel}}\n    </button>\n</form>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
EditInspectionFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: CustomerService },
    { type: RouteService },
    { type: WellService },
    { type: InputConverterService }
];
EditInspectionFormComponent.propDecorators = {
    inspection: [{ type: Input }],
    customers: [{ type: Input }],
    anodeReadingTypes: [{ type: Input }],
    anodeTypes: [{ type: Input }],
    tubeDiameters: [{ type: Input }],
    orientations: [{ type: Input }],
    supportedAssetExtensions: [{ type: Input }],
    supportedReportExtensions: [{ type: Input }],
    isFromAdmin: [{ type: Input }],
    isFromTech: [{ type: Input }],
    errorMsg: [{ type: Input }],
    successMsg: [{ type: Input }],
    saving: [{ type: Input }],
    saveButtonLabel: [{ type: Input }],
    componentType: [{ type: Input }],
    save: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    EditInspectionFormComponent.prototype.form;
    /** @type {?} */
    EditInspectionFormComponent.prototype.inspection;
    /** @type {?} */
    EditInspectionFormComponent.prototype.customers;
    /** @type {?} */
    EditInspectionFormComponent.prototype.anodeReadingTypes;
    /** @type {?} */
    EditInspectionFormComponent.prototype.anodeTypes;
    /** @type {?} */
    EditInspectionFormComponent.prototype.tubeDiameters;
    /** @type {?} */
    EditInspectionFormComponent.prototype.orientations;
    /** @type {?} */
    EditInspectionFormComponent.prototype.supportedAssetExtensions;
    /** @type {?} */
    EditInspectionFormComponent.prototype.supportedReportExtensions;
    /** @type {?} */
    EditInspectionFormComponent.prototype.isFromAdmin;
    /** @type {?} */
    EditInspectionFormComponent.prototype.isFromTech;
    /** @type {?} */
    EditInspectionFormComponent.prototype.errorMsg;
    /** @type {?} */
    EditInspectionFormComponent.prototype.showErrorMsg;
    /** @type {?} */
    EditInspectionFormComponent.prototype.successMsg;
    /** @type {?} */
    EditInspectionFormComponent.prototype.showSuccessMsg;
    /** @type {?} */
    EditInspectionFormComponent.prototype.isFromAutoComplete;
    /** @type {?} */
    EditInspectionFormComponent.prototype.saved;
    /** @type {?} */
    EditInspectionFormComponent.prototype.show_autocompl;
    /** @type {?} */
    EditInspectionFormComponent.prototype.selectedWell;
    /** @type {?} */
    EditInspectionFormComponent.prototype.saving;
    /** @type {?} */
    EditInspectionFormComponent.prototype.saveButtonLabel;
    /** @type {?} */
    EditInspectionFormComponent.prototype.componentType;
    /** @type {?} */
    EditInspectionFormComponent.prototype.save;
    /** @type {?} */
    EditInspectionFormComponent.prototype.routes$;
    /** @type {?} */
    EditInspectionFormComponent.prototype.wells$;
    /** @type {?} */
    EditInspectionFormComponent.prototype.well;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._customerReps;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._customerRepsSub;
    /** @type {?} */
    EditInspectionFormComponent.prototype.filteredCustomerReps;
    /** @type {?} */
    EditInspectionFormComponent.prototype.flag;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._assetImageSrc$;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._assetImageFile;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._reportFile;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._formBuilder;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._customerService;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._routeService;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._wellService;
    /**
     * @type {?}
     * @private
     */
    EditInspectionFormComponent.prototype._inputConverterService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/export.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ExportService {
    /**
     * @param {?} _http
     * @param {?} _fileService
     * @param {?} _appConfig
     */
    constructor(_http, _fileService, _appConfig) {
        this._http = _http;
        this._fileService = _fileService;
        this._appConfig = _appConfig;
    }
    /**
     * @param {?} inspectionIDs
     * @param {?} exportAction
     * @param {?=} fileName
     * @return {?}
     */
    exportInspections(inspectionIDs, exportAction, fileName) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/export/${exportAction}`;
        /** @type {?} */
        const requestBody = {
            InspectionIDs: inspectionIDs,
            FileName: fileName
        };
        return this.requestExport(requestUrl, requestBody);
    }
    /**
     * @param {?} keyword
     * @param {?} numDays
     * @param {?=} fileName
     * @return {?}
     */
    exportInspectionSearch(keyword, numDays, fileName) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/export/inspectionsearch`;
        /** @type {?} */
        const requestBody = {
            SearchParams: {
                Keyword: keyword,
                NumDays: numDays,
                VesselID: ''
            },
            FileName: fileName
        };
        return this.requestExport(requestUrl, requestBody);
    }
    /**
     * @param {?} customerID
     * @param {?} routeID
     * @param {?=} fileName
     * @return {?}
     */
    exportWellSearch(customerID, routeID, fileName) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/export/wellsearch`;
        /** @type {?} */
        const requestBody = {
            SearchParams: {
                CustomerID: customerID,
                RouteID: routeID
            },
            FileName: fileName
        };
        return this.requestExport(requestUrl, requestBody);
    }
    /**
     * @param {?} customerID
     * @param {?} keyword
     * @param {?} numDays
     * @param {?=} fileName
     * @return {?}
     */
    exportCustomerInspectionSearch(customerID, keyword, numDays, fileName) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/export/inspectionsearch`;
        /** @type {?} */
        const requestBody = {
            SearchParams: {
                Keyword: keyword,
                NumDays: numDays,
                VesselID: ''
            },
            FileName: fileName
        };
        return this.requestExport(requestUrl, requestBody);
    }
    /**
     * @param {?} wellID
     * @param {?=} numDays
     * @param {?=} fileName
     * @return {?}
     */
    exportWellInspections(wellID, numDays, fileName) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/export/wellinspections`;
        /** @type {?} */
        const requestBody = {
            WellID: wellID,
            NumDays: numDays,
            FileName: fileName
        };
        return this.requestExport(requestUrl, requestBody);
    }
    /**
     * @private
     * @param {?} requestUrl
     * @param {?} requestBody
     * @return {?}
     */
    requestExport(requestUrl, requestBody) {
        /** @type {?} */
        const fileRequestOptions = this._fileService.getFileRequestOptions();
        /** @type {?} */
        const request = this._http.post(requestUrl, requestBody, fileRequestOptions);
        return this._fileService.getFileInfoFromRequest(request);
    }
}
ExportService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ExportService.ctorParameters = () => [
    { type: HttpClient },
    { type: FileService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ ExportService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ExportService_Factory() { return new ExportService(ɵɵinject(HttpClient), ɵɵinject(FileService), ɵɵinject(APP_CONFIG)); }, token: ExportService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ExportService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    ExportService.prototype._fileService;
    /**
     * @type {?}
     * @private
     */
    ExportService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/export-inspection-search-button/export-inspection-search-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ExportInspectionSearchButtonComponent {
    /**
     * @param {?} _exportService
     */
    constructor(_exportService) {
        this._exportService = _exportService;
        this.exportFailed = new EventEmitter();
        this.requestInspectionSearchExport = (/**
         * @return {?}
         */
        () => {
            if (this.customerID != null) {
                return this._exportService.exportCustomerInspectionSearch(this.customerID, this.keyword, this.numDays, this.fileName);
            }
            else {
                return this._exportService.exportInspectionSearch(this.keyword, this.numDays, this.fileName);
            }
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} error
     * @return {?}
     */
    onDownloadFailed(error) {
        this.exportFailed.emit(error);
    }
}
ExportInspectionSearchButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-export-inspection-search-button',
                template: "<eec-download-file-button\n    [disabled]=\"disabled\"\n    label=\"Export\"\n    [request]=\"requestInspectionSearchExport\"\n    (downloadFailed)=\"onDownloadFailed($event)\">\n</eec-download-file-button>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ExportInspectionSearchButtonComponent.ctorParameters = () => [
    { type: ExportService }
];
ExportInspectionSearchButtonComponent.propDecorators = {
    customerID: [{ type: Input }],
    keyword: [{ type: Input }],
    searchTerm: [{ type: Input }],
    numDays: [{ type: Input }],
    disabled: [{ type: Input }],
    fileName: [{ type: Input }],
    exportFailed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ExportInspectionSearchButtonComponent.prototype.customerID;
    /** @type {?} */
    ExportInspectionSearchButtonComponent.prototype.keyword;
    /** @type {?} */
    ExportInspectionSearchButtonComponent.prototype.searchTerm;
    /** @type {?} */
    ExportInspectionSearchButtonComponent.prototype.numDays;
    /** @type {?} */
    ExportInspectionSearchButtonComponent.prototype.disabled;
    /** @type {?} */
    ExportInspectionSearchButtonComponent.prototype.fileName;
    /** @type {?} */
    ExportInspectionSearchButtonComponent.prototype.exportFailed;
    /** @type {?} */
    ExportInspectionSearchButtonComponent.prototype.requestInspectionSearchExport;
    /**
     * @type {?}
     * @private
     */
    ExportInspectionSearchButtonComponent.prototype._exportService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-alerts/form-alerts.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormAlertsComponent {
    constructor() { }
}
FormAlertsComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-form-alerts',
                template: "<div *ngIf=\"formInvalid\" class=\"text-danger my-1\">\n    <span>Please correct all input errors before continuing.</span>\n</div>\n<eec-page-alerts [errorMsg]=\"errorMsg\" [successMsg]=\"successMsg\"></eec-page-alerts>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
FormAlertsComponent.ctorParameters = () => [];
FormAlertsComponent.propDecorators = {
    formInvalid: [{ type: Input }],
    errorMsg: [{ type: Input }],
    successMsg: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    FormAlertsComponent.prototype.formInvalid;
    /** @type {?} */
    FormAlertsComponent.prototype.errorMsg;
    /** @type {?} */
    FormAlertsComponent.prototype.successMsg;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/monthly-inspection-calendar/monthly-inspection-calendar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MonthlyInspectionCalendarComponent {
    constructor() {
        this.showCustomer = true;
        this.currentMonthChanged = new EventEmitter();
        this.inspectionDateFormat = MONTH_YEAR_DATE_FORMAT;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    get hasInspections() {
        return this.inspections && this.inspections.length > 0;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCurrentMonthChanged(event) {
        this.currentMonthChanged.emit(event);
    }
}
MonthlyInspectionCalendarComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-monthly-inspection-calendar',
                template: "<ng-template #noInspections>\n    <p>\n        <i>No inspections scheduled</i>\n    </p>\n</ng-template>\n\n<div class=\"mb-4\">\n    <eec-calendar-pagination\n        [currentMonth]=\"currentMonth\" \n        (currentMonthChanged)=\"onCurrentMonthChanged($event)\">\n    </eec-calendar-pagination>\n</div>\n\n<div [hidden]=\"hideInspections\">    \n    <eec-inspection-table *ngIf=\"hasInspections; else noInspections\" \n        [inspections]=\"inspections\"\n        [showCustomer]=\"showCustomer\"\n        [showPrevScanDate]=\"true\"\n        [showPrevHWL]=\"true\"\n        [showInspectionDetails]=\"false\"\n        [customInspectionActions]=\"customInspectionActions\"\n        [dateFormat]=\"inspectionDateFormat\">\n    </eec-inspection-table>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
MonthlyInspectionCalendarComponent.ctorParameters = () => [];
MonthlyInspectionCalendarComponent.propDecorators = {
    showCustomer: [{ type: Input }],
    hideInspections: [{ type: Input }],
    inspections: [{ type: Input }],
    currentMonth: [{ type: Input }],
    customInspectionActions: [{ type: Input }],
    currentMonthChanged: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MonthlyInspectionCalendarComponent.prototype.showCustomer;
    /** @type {?} */
    MonthlyInspectionCalendarComponent.prototype.hideInspections;
    /** @type {?} */
    MonthlyInspectionCalendarComponent.prototype.inspections;
    /** @type {?} */
    MonthlyInspectionCalendarComponent.prototype.currentMonth;
    /** @type {?} */
    MonthlyInspectionCalendarComponent.prototype.customInspectionActions;
    /** @type {?} */
    MonthlyInspectionCalendarComponent.prototype.inspectionDateFormat;
    /** @type {?} */
    MonthlyInspectionCalendarComponent.prototype.currentMonthChanged;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/inspection-details/inspection-details.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InspectionDetailsComponent {
    constructor() {
        this.dateFormat = MONTH_DAY_YEAR_DATE_FORMAT;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
InspectionDetailsComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-inspection-details',
                template: "<ng-template #noNotes>\n    <div class=\"mb-2\"><i>N/A</i></div>\n</ng-template>\n\n<div class=\"d-flex d-flex-row\">\n    <div class=\"d-flex-col pr-5\">\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Inspection Date:</span>\n            <span>{{inspection.InspectionDate | date:dateFormat}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Oil Company:</span>\n            <span>{{inspection.CustomerCode}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Route:</span>\n            <span>{{inspection.RouteName}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Location:</span>\n            <span>{{inspection.WellName}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Company Rep:</span>\n            <span>{{inspection.CustomerRepName | notany}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Vessel ID:</span>\n            <span>{{inspection.VesselID | notany}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">HWL:</span>\n            <span>{{inspection.FireTube | null:'HWL' | percent | notany}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Condition:</span>\n            <eec-condition-text\n                [condition]=\"inspection.FireTube | null:'Condition'\" \n                [description]=\"inspection.FireTube | null:'ConditionDescription'\">\n            </eec-condition-text>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Temperature:</span>\n            <span>{{inspection.FireTube | null:'Temperature' | temp | notany}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Tube Diameter:</span>\n            <span>{{inspection.FireTube | null:'TubeDiameterDescription' | notany}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Horizontal/Vertical:</span>\n            <span>{{inspection.FireTube | null:'OrientationDescription' | notany}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <div>\n                <span class=\"font-weight-bold mr-2\">Replaced Gasket?</span>\n                <span>{{inspection.FireTube | null:'ReplacedGasket' | yesno}}</span>\n            </div>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Billable?</span>\n            <span>{{inspection.FireTube | null:'ReplacedGasketIsBillable' | yesno}}</span>\n        </div>\n\n        <div class=\"mb-2\">\n            <span class=\"font-weight-bold mr-2\">Anode Type:</span>\n            <span>{{inspection.Anode | null:'AnodeTypeDescription' | notany}}</span>\n        </div>\n\n        <div class=\"bm-2\">\n            <span class=\"font-weight-bold mr-2\">Anode Reading:</span>\n            <span>{{inspection.Anode | null:'AnodeReading' | units:(inspection.Anode | null:'AnodeReadingTypeDescription') | notany}}</span>\n        </div>\n    </div>\n    <div class=\"d-flex-col pr-5\">\n        <span class=\"font-weight-bold\">Additional Notes:</span>\n        <div class=\"my-2\">\n            <eec-asset-img *ngIf=\"inspection?.FieldNote?.AssetID\" \n                [asset]=\"inspection.FieldNote.AssetID\"\n                aria-label=\"Field Note Image\">\n            </eec-asset-img>\n        </div>\n        \n        <p *ngIf=\"inspection?.FieldNote?.Note; else noNotes\">\n            {{inspection.FieldNote.Note}}\n        </p>\n\n        <eec-download-report-button *ngIf=\"inspection?.ReportID\" \n            [reportID]=\"inspection.ReportID\" \n            [reportName]=\"inspection.ReportName\">\n        </eec-download-report-button>\n    </div>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
InspectionDetailsComponent.ctorParameters = () => [];
InspectionDetailsComponent.propDecorators = {
    inspection: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    InspectionDetailsComponent.prototype.inspection;
    /** @type {?} */
    InspectionDetailsComponent.prototype.dateFormat;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/search.constant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const DEFAULT_INSPECTION_SEARCH_DAYS_BEFORE = 30;
/** @type {?} */
const DEFAULT_WELL_SEARCH_REPORT_NAME = 'Well Inspections';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/inspection-search-table/inspection-search-table.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFormData$3() { }
if (false) {
    /** @type {?} */
    IFormData$3.prototype.NumDays;
    /** @type {?} */
    IFormData$3.prototype.Keyword;
    /** @type {?} */
    IFormData$3.prototype.SearchTerm;
    /** @type {?} */
    IFormData$3.prototype.CustomerID;
}
class InspectionSearchTableComponent {
    /**
     * @param {?} _formBuilder
     */
    constructor(_formBuilder) {
        this._formBuilder = _formBuilder;
        this.search = new EventEmitter();
        this.pageChanged = new EventEmitter();
        this.showCustomer = true;
    }
    /**
     * @return {?}
     */
    get searchForm() {
        return this._searchForm;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._searchForm = this._formBuilder.group({
            NumDays: ['', [Validators.min(1), Validators.required]],
            Keyword: [''],
            CustomerID: [''],
            SearchTerm: ['']
        });
        this.updateFormFromSearchParams();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes == null || this.searchForm == null) {
            return;
        }
        if (changes.searchParams != null && changes.searchParams.currentValue !== changes.searchParams.previousValue) {
            this.updateFormFromSearchParams();
        }
    }
    /**
     * @return {?}
     */
    get hasNumDays() {
        /** @type {?} */
        const numDays = InputConverterService.parseInt(this.searchForm.controls.NumDays.value);
        return numDays >= 1;
    }
    /**
     * @private
     * @return {?}
     */
    updateFormFromSearchParams() {
        /** @type {?} */
        const formData = {
            NumDays: InputConverterService.numberToString(this.numDays),
            Keyword: this.keyword,
            SearchTerm: this.searchTerm,
            CustomerID: InputConverterService.numberToString(this.customerID)
        };
        this.searchForm.setValue(formData);
    }
    /**
     * @return {?}
     */
    reset() {
        /** @type {?} */
        const formData = {
            NumDays: DEFAULT_INSPECTION_SEARCH_DAYS_BEFORE.toString(),
            Keyword: '',
            SearchTerm: '',
            CustomerID: ''
        };
        this.searchForm.reset(formData);
    }
    /**
     * @param {?} item
     * @return {?}
     */
    getItemName(item) {
        this.selectedWell = item;
        this.searching = false;
        this.keyword = item;
        document.getElementById("btnSearch").focus();
    }
    /**
     * @return {?}
     */
    onSearch() {
        if (this.searchForm.invalid) {
            return;
        }
        /** @type {?} */
        const searchParams = this.getCurrentSearchParams();
        this.search.emit(searchParams);
    }
    /**
     * @param {?} page
     * @return {?}
     */
    onPageChanged(page) {
        if (this.inspectionPage == null || this.inspectionPage.Page !== page) {
            this.pageChanged.emit(page);
        }
    }
    /**
     * @private
     * @return {?}
     */
    getCurrentSearchParams() {
        return {
            Keyword: InputConverterService.trim(this.selectedWell),
            NumDays: InputConverterService.parseInt(this.searchForm.controls.NumDays.value),
            CustomerID: InputConverterService.parseInt(this.searchForm.controls.CustomerID.value),
            VesselID: InputConverterService.trim(this.searchForm.controls.SearchTerm.value)
        };
    }
    /**
     * @param {?} customer
     * @return {?}
     */
    getCustomerID(customer) {
        return customer.CustomerID;
    }
}
InspectionSearchTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-inspection-search-table',
                template: "<form [formGroup]=\"searchForm\" class=\"form-inline\">\n    <div class=\"mr-2 my-2\">\n        <select class=\"form-control\" formControlName=\"CustomerID\">\n            <option value=\"\">All Producers</option>\n            <option *ngFor=\"let customer of customers; trackBy: getCustomerID\" [value]=\"customer.CustomerID\">\n                {{customer.Code}}\n            </option>\n        </select>\n    </div>\n\n    <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n            <span class=\"input-group-text\">Last</span>\n        </div>\n        <input class=\"form-control\" formControlName=\"NumDays\" type=\"number\" min=\"1\" aria-label=\"Last number of days\" />\n        <div class=\"input-group-append\">\n            <span class=\"input-group-text\">Days</span>\n        </div>\n    </div>\n    <eec-autocomplete (itemName)=\"getItemName($event)\" style=\"width:410px;\"></eec-autocomplete>\n    <input formControlName=\"Keyword\" type=\"hidden\" class=\"form-control mx-2\" value=\"{{selectedWell}}\"\n           placeholder=\"Enter Well Name\"\n           title=\"Search by Well Name\" />\n    <input formControlName=\"SearchTerm\" type=\"text\" class=\"form-control\"\n           placeholder=\"Enter Vessel ID\"\n           title=\"Search by Vessel ID\" />\n    <button id=\"btnSearch\" [disabled]=\"searching || !hasNumDays\" class=\"btn btn-primary mx-2\" type=\"submit\" (click)=\"onSearch()\">\n        <eec-spinner [hidden]=\"!searching\" small=\"true\" class=\"m-1\"></eec-spinner>\n        Search\n    </button>\n</form>\n\n<div class=\"my-4\">\n    <eec-inspection-table\n        [inspections]=\"inspectionPage?.Items\"\n        [showCustomer]=\"showCustomer\"\n        showAnode=\"true\"\n        showNote=\"true\"\n        [customInspectionActions]=\"customInspectionActions\">    \n    </eec-inspection-table>\n</div>\n\n<ngb-pagination\n    class=\"d-flex justify-content-center my-3\"\n    [page]=\"inspectionPage?.Page\"\n    [pageSize]=\"inspectionPage?.PageSize\"\n    [collectionSize]=\"inspectionPage?.TotalItemCount\"\n    (pageChange)=\"onPageChanged($event)\">\n</ngb-pagination>\n\n\n",
                styles: [""]
            }] }
];
/** @nocollapse */
InspectionSearchTableComponent.ctorParameters = () => [
    { type: FormBuilder }
];
InspectionSearchTableComponent.propDecorators = {
    searching: [{ type: Input }],
    inspectionPage: [{ type: Input }],
    customerID: [{ type: Input }],
    keyword: [{ type: Input }],
    searchTerm: [{ type: Input }],
    numDays: [{ type: Input }],
    customInspectionActions: [{ type: Input }],
    showCustomer: [{ type: Input }],
    customers: [{ type: Input }],
    search: [{ type: Output }],
    pageChanged: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InspectionSearchTableComponent.prototype.searching;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.inspectionPage;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.customerID;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.keyword;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.searchTerm;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.numDays;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.customInspectionActions;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.showCustomer;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.customers;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.search;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.pageChanged;
    /** @type {?} */
    InspectionSearchTableComponent.prototype.selectedWell;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchTableComponent.prototype._searchForm;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchTableComponent.prototype._formBuilder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/edit-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IEditInspection() { }
if (false) {
    /** @type {?} */
    IEditInspection.prototype.CustomerID;
    /** @type {?} */
    IEditInspection.prototype.RouteID;
    /** @type {?} */
    IEditInspection.prototype.ReportName;
    /** @type {?} */
    IEditInspection.prototype.WellID;
    /** @type {?} */
    IEditInspection.prototype.searchedWell;
    /** @type {?} */
    IEditInspection.prototype.InspectionID;
    /** @type {?} */
    IEditInspection.prototype.CustomerRepID;
}
class Inspection {
    /**
     * @private
     * @param {?} anode
     * @return {?}
     */
    static createAnode(anode) {
        return {
            AnodeReading: anode != null ? anode.AnodeReading : null,
            AnodeReadingType: anode != null ? anode.AnodeReadingType || '' : '',
            AnodeType: anode != null ? anode.AnodeType || '' : ''
        };
    }
    /**
     * @private
     * @param {?} fireTube
     * @return {?}
     */
    static createFireTube(fireTube) {
        return {
            HWL: fireTube != null ? fireTube.HWL : null,
            ConditionCategory: fireTube != null ? fireTube.ConditionCategory : null,
            IsWhiteProtocol: fireTube != null ? fireTube.IsWhiteProtocol : false,
            Orientation: fireTube != null ? fireTube.Orientation || '' : '',
            //ReplacedGasket: fireTube != null ? fireTube.ReplacedGasket : false,
            //ReplacedGasketIsBillable: fireTube != null ? fireTube.ReplacedGasketIsBillable : false,
            Temperature: fireTube != null ? fireTube.Temperature : null,
            TubeDiameter: fireTube != null ? fireTube.TubeDiameter || '' : '',
            TubeThickness: fireTube != null ? fireTube.TubeThickness : ''
        };
    }
    /**
     * @private
     * @param {?} fieldNote
     * @return {?}
     */
    static createFieldNote(fieldNote) {
        return {
            Note: fieldNote != null ? fieldNote.Note : null,
            AssetID: fieldNote != null ? fieldNote.AssetID : null
        };
    }
    /**
     * @param {?=} inspection
     * @return {?}
     */
    static createEditableInspection(inspection = null) {
        /** @type {?} */
        const anode = inspection != null ? inspection.Anode : null;
        /** @type {?} */
        const fireTube = inspection != null ? inspection.FireTube : null;
        /** @type {?} */
        const fieldNote = inspection != null ? inspection.FieldNote : null;
        return {
            Anode: Inspection.createAnode(anode),
            CustomerID: inspection != null ? inspection.CustomerID : null,
            CustomerRepID: inspection != null ? inspection.CustomerRepID : null,
            FieldNote: Inspection.createFieldNote(fieldNote),
            FireTube: Inspection.createFireTube(fireTube),
            InspectionDate: inspection != null ? inspection.InspectionDate : new Date(),
            InspectionID: inspection != null ? inspection.InspectionID : null,
            RouteID: inspection != null ? inspection.RouteID : null,
            ScanTechnicianID: inspection != null ? inspection.ScanTechnicianID : null,
            VesselID: inspection != null ? inspection.VesselID : '',
            WellID: inspection != null ? inspection.WellID : null,
            searchedWell: '',
            ReportID: inspection != null ? inspection.ReportID : null,
            ReportName: inspection != null ? inspection.ReportName : null
        };
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/inspection.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const YEARLY_SCHEDULED_INSPECTION_MONTHS = 13;
class InspectionService {
    /**
     * @param {?} _http
     * @param {?} _userService
     * @param {?} _assetSevice
     * @param {?} _reportService
     * @param {?} _appConfig
     */
    constructor(_http, _userService, _assetSevice, _reportService, _appConfig) {
        this._http = _http;
        this._userService = _userService;
        this._assetSevice = _assetSevice;
        this._reportService = _reportService;
        this._appConfig = _appConfig;
        this.onInspectionChanged = (/**
         * @param {?} inspection
         * @return {?}
         */
        (inspection) => {
            InspectionDateHydrator.processInspection(inspection);
            return inspection;
        });
    }
    /**
     * @param {?} wellID
     * @param {?} vesselID
     * @param {?} page
     * @param {?} pageSize
     * @param {?=} numDays
     * @return {?}
     */
    getWellInspections(wellID, vesselID, page, pageSize, numDays) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well/${wellID}/${vesselID}/inspections/page/${page}`;
        /** @type {?} */
        let requestParams = new HttpParams();
        requestParams = requestParams.set('pageSize', pageSize.toString());
        if (numDays != null) {
            requestParams = requestParams.set('numDays', numDays.toString());
        }
        return this._http.get(requestUrl, { params: requestParams })
            .pipe(map((/**
         * @param {?} inspectionPage
         * @return {?}
         */
        inspectionPage => {
            InspectionDateHydrator.processInspections(inspectionPage.Items);
            return inspectionPage;
        }), shareReplay(1)));
    }
    /**
     * @param {?} keyword
     * @param {?} numDays
     * @param {?} vesselID
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    getInspectionList(keyword, numDays, vesselID, page, pageSize) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspections/list/page/${page}`;
        /** @type {?} */
        const requestBody = {
            Keyword: keyword,
            NumDays: numDays,
            VesselID: vesselID
        };
        /** @type {?} */
        const requestParams = {
            pageSize: pageSize.toString()
        };
        return this._http.post(requestUrl, requestBody, { params: requestParams })
            .pipe(map((/**
         * @param {?} inspectionPage
         * @return {?}
         */
        inspectionPage => {
            InspectionDateHydrator.processInspectionList(inspectionPage.Items);
            return inspectionPage;
        }), shareReplay(1)));
    }
    /**
     * @param {?} customerID
     * @param {?} keyword
     * @param {?} numDays
     * @param {?} vesselID
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    getCustomerInspectionList(customerID, keyword, numDays, vesselID, page, pageSize) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/inspections/list/page/${page}`;
        /** @type {?} */
        const requestBody = {
            Keyword: keyword,
            NumDays: numDays,
            VesselID: vesselID
        };
        /** @type {?} */
        const requestParams = {
            pageSize: pageSize.toString()
        };
        return this._http.post(requestUrl, requestBody, { params: requestParams })
            .pipe(map((/**
         * @param {?} inspectionPage
         * @return {?}
         */
        inspectionPage => {
            InspectionDateHydrator.processInspectionList(inspectionPage.Items);
            return inspectionPage;
        }), shareReplay(1)));
    }
    /**
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    getRequestedInspectionsList(page, pageSize) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspections/requested/list/page/${page}`;
        /** @type {?} */
        const requestParams = {
            pageSize: pageSize.toString()
        };
        return this._http.get(requestUrl, { params: requestParams })
            .pipe(map((/**
         * @param {?} inspectionPage
         * @return {?}
         */
        inspectionPage => {
            InspectionDateHydrator.processInspectionList(inspectionPage.Items);
            return inspectionPage;
        }), shareReplay(1)));
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    approveInspection(inspectionID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/approve`;
        /** @type {?} */
        const requestData = {
            InspectionID: inspectionID
        };
        return this._http.post(requestUrl, requestData)
            .pipe(map((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            InspectionDateHydrator.processInspection(inspection);
            return inspection;
        }), shareReplay(1)));
    }
    /**
     * @param {?} inspectionID
     * @param {?} inspectionDate
     * @return {?}
     */
    scheduleExistingInspection(inspectionID, inspectionDate) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/schedule`;
        /** @type {?} */
        const requestData = {
            InspectionID: inspectionID,
            InspectionDate: inspectionDate
        };
        return this._http.post(requestUrl, requestData)
            .pipe(map((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            InspectionDateHydrator.processInspection(inspection);
            return inspection;
        }), shareReplay(1)));
    }
    /**
     * @param {?} customerID
     * @return {?}
     */
    getRecentCustomerInspectionsList(customerID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/inspections/recent/list`;
        return this._http.get(requestUrl)
            .pipe(map((/**
         * @param {?} inspectionList
         * @return {?}
         */
        inspectionList => {
            return InspectionDateHydrator.processInspectionList(inspectionList);
        }), shareReplay(1)));
    }
    /**
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    getRecentInspectionsList(page, pageSize) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspections/recent/list/page/${page}`;
        /** @type {?} */
        const requestParams = {
            pageSize: pageSize.toString()
        };
        return this._http.get(requestUrl, { params: requestParams })
            .pipe(map((/**
         * @param {?} inspectionsPage
         * @return {?}
         */
        inspectionsPage => {
            InspectionDateHydrator.processInspectionList(inspectionsPage.Items);
            return inspectionsPage;
        })), shareReplay(1));
    }
    /**
     * @param {?} year
     * @param {?} month
     * @param {?=} keyword
     * @param {?=} customer
     * @return {?}
     */
    getScheduledInspectionsListByMonth(year, month, keyword = null, customer = -1) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspections/scheduled/${year}/${month}/list`;
        /** @type {?} */
        let queryParams = null;
        if (keyword != null && keyword.length > 0) {
            queryParams = {
                keyword: keyword,
                customer_ID: customer
            };
        }
        else if (customer != -1) {
            queryParams = {
                keyword: '',
                customer_ID: customer
            };
        }
        else {
            queryParams = {
                keyword: '',
                customer_ID: customer
            };
        }
        return this._http.get(requestUrl, { params: queryParams })
            .pipe(map((/**
         * @param {?} inspectionList
         * @return {?}
         */
        inspectionList => {
            return InspectionDateHydrator.processInspectionList(inspectionList);
        })), shareReplay(1));
    }
    /**
     * @param {?=} keyword
     * @param {?=} customer
     * @return {?}
     */
    getYearlyScheduledInspectionsList(keyword = null, customer = -1) {
        /** @type {?} */
        const yearlyInspectionsSubject = new ReplaySubject(1);
        /** @type {?} */
        const yearlyScheduledInspectionMonths = this.getYearlyScheduledInspectionMonths();
        /** @type {?} */
        const requests = [];
        for (const calendarMonth of yearlyScheduledInspectionMonths) {
            /** @type {?} */
            const inspectionRequest = this.getScheduledInspectionsListByMonth(calendarMonth.year, calendarMonth.month, keyword, customer);
            requests.push(inspectionRequest);
        }
        forkJoin(requests).pipe(map((/**
         * @param {?} results
         * @return {?}
         */
        results => {
            return results.map((/**
             * @param {?} inspections
             * @param {?} i
             * @return {?}
             */
            (inspections, i) => {
                /** @type {?} */
                const inspectionMonth = {
                    calendarMonth: yearlyScheduledInspectionMonths[i],
                    inspections
                };
                return inspectionMonth;
            }));
        }))).subscribe({
            next: (/**
             * @param {?} inspectionsByMonth
             * @return {?}
             */
            inspectionsByMonth => {
                yearlyInspectionsSubject.next(inspectionsByMonth);
                yearlyInspectionsSubject.complete();
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                yearlyInspectionsSubject.error(error);
            })
        });
        return yearlyInspectionsSubject.asObservable();
    }
    /**
     * @private
     * @return {?}
     */
    getYearlyScheduledInspectionMonths() {
        // get the months from the current month for one year
        /** @type {?} */
        const months = [];
        /** @type {?} */
        const date = new Date();
        for (let i = 0; i < YEARLY_SCHEDULED_INSPECTION_MONTHS; ++i) {
            /** @type {?} */
            const calendarMonth = {
                month: date.getMonth() + 1,
                year: date.getFullYear()
            };
            months.push(calendarMonth);
            // move to the next month
            date.setMonth(date.getMonth() + 1);
        }
        return months;
    }
    /**
     * @param {?} numDays
     * @param {?} unbilledOnly
     * @param {?=} customerID
     * @return {?}
     */
    getUnbilledInspectionsList(numDays, unbilledOnly, customerID = null) {
        /** @type {?} */
        let requestUrl;
        if (customerID != null) {
            requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/inspections/unbilled/list`;
        }
        else {
            requestUrl = `${this._appConfig.apiBaseUrl}/inspections/unbilled/list`;
        }
        /** @type {?} */
        const queryParams = {
            numDays: numDays.toString(),
            unbilledOnly: unbilledOnly.toString()
        };
        return this._http.get(requestUrl, { params: queryParams })
            .pipe(map((/**
         * @param {?} inspectionList
         * @return {?}
         */
        inspectionList => {
            InspectionDateHydrator.processInspectionList(inspectionList);
            return inspectionList;
        })), shareReplay(1));
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    getInspection(inspectionID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/${inspectionID}`;
        /** @type {?} */
        const request = this._http.get(requestUrl).pipe(map((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            InspectionDateHydrator.processInspection(inspection);
            return inspection;
        })));
        return request;
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    getRecentInspectionForWell(wellID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well/${wellID}/inspections/recent`;
        /** @type {?} */
        const request = this._http.get(requestUrl).pipe(map((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            InspectionDateHydrator.processInspection(inspection);
            return inspection;
        })));
        return request;
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    getNextInspectionForWell(wellID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/well/${wellID}/inspections/next`;
        /** @type {?} */
        const request = this._http.get(requestUrl).pipe(map((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            InspectionDateHydrator.processInspection(inspection);
            return inspection;
        })));
        return request;
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    getPreviousCompletedInspection(inspectionID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/${inspectionID}/previous`;
        /** @type {?} */
        const request = this._http.get(requestUrl).pipe(map((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            if (inspection != null) {
                //	alert('inspection exist');
                InspectionDateHydrator.processInspection(inspection);
            }
            //alert('null exist');
            return inspection;
        })));
        return request;
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    getPreviousCompletedHWL(inspectionID) {
        /** @type {?} */
        var prevHwl;
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/${inspectionID}/previous/hwl`;
        //this._http.get(requestUrl).subscribe(data => {
        //	console.log(data);
        //	prevHwl = data;
        //});
        //return prevHwl;
        prevHwl = this._http.get(requestUrl)
            .subscribe((/**
         * @param {?} hwl
         * @return {?}
         */
        (hwl) => prevHwl = hwl));
        //const request = this._http.get<IInspection>(requestUrl).pipe(take(1).map(inspection => {
        //	if (inspection != null) {
        //		InspectionDateHydrator.processInspection(inspection);
        //	}
        //	return inspection;
        //}));
        return prevHwl;
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    getPreviousCompletedInspectionDate(inspectionID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/${inspectionID}/previousdate`;
        return this._http.get(requestUrl);
    }
    /**
     * @param {?} newInspection
     * @param {?} fieldNoteAssetFile
     * @param {?} inspectionReportFile
     * @return {?}
     */
    createInspection(newInspection, fieldNoteAssetFile, inspectionReportFile) {
        // the user is creating a new inspection with associated files
        // 1. Upload the associated inspection files
        // 2. Assign the inspection files to the inspection
        // 3. Create the inspection
        /** @type {?} */
        let uploadFieldNoteAsset$ = of(null);
        if (fieldNoteAssetFile != null) {
            uploadFieldNoteAsset$ = this._assetSevice.uploadAsset(fieldNoteAssetFile, newInspection.WellID, newInspection.InspectionDate, newInspection.FieldNote.AssetID);
        }
        /** @type {?} */
        let uploadInspectionReport$ = of(null);
        if (inspectionReportFile != null) {
            uploadInspectionReport$ = this._reportService.uploadReport(inspectionReportFile, newInspection.WellID, newInspection.InspectionDate, newInspection.FireTube.HWL, newInspection.ReportID);
        }
        return forkJoin([uploadFieldNoteAsset$, uploadInspectionReport$])
            .pipe(flatMap((/**
         * @param {?} results
         * @return {?}
         */
        results => {
            /** @type {?} */
            const fieldNoteAsset = results[0];
            if (fieldNoteAsset != null) {
                newInspection.FieldNote.AssetID = fieldNoteAsset.AssetID;
            }
            /** @type {?} */
            const inspectionReport = results[1];
            if (inspectionReport != null) {
                newInspection.ReportID = inspectionReport.ReportID;
            }
            return this.requestCreateInspection(newInspection);
        })));
    }
    /**
     * @param {?} newInspection
     * @param {?} fieldNoteAssetFile
     * @param {?} inspectionReportFile
     * @return {?}
     */
    createInspectionFromWells(newInspection, fieldNoteAssetFile, inspectionReportFile) {
        // the user is creating a new inspection with associated files
        // 1. Upload the associated inspection files
        // 2. Assign the inspection files to the inspection
        // 3. Create the inspection
        /** @type {?} */
        let uploadFieldNoteAsset$ = of(null);
        if (fieldNoteAssetFile != null) {
            uploadFieldNoteAsset$ = this._assetSevice.uploadAsset(fieldNoteAssetFile, newInspection.WellID, newInspection.InspectionDate, newInspection.FieldNote.AssetID);
        }
        /** @type {?} */
        let uploadInspectionReport$ = of(null);
        if (inspectionReportFile != null) {
            uploadInspectionReport$ = this._reportService.uploadReport(inspectionReportFile, newInspection.WellID, newInspection.InspectionDate, newInspection.FireTube.HWL, newInspection.ReportID);
        }
        return forkJoin([uploadFieldNoteAsset$, uploadInspectionReport$])
            .pipe(flatMap((/**
         * @param {?} results
         * @return {?}
         */
        results => {
            /** @type {?} */
            const fieldNoteAsset = results[0];
            if (fieldNoteAsset != null) {
                newInspection.FieldNote.AssetID = fieldNoteAsset.AssetID;
            }
            /** @type {?} */
            const inspectionReport = results[1];
            if (inspectionReport != null) {
                newInspection.ReportID = inspectionReport.ReportID;
            }
            return this.requestCreateInspectionFromWell(newInspection);
        })));
    }
    /**
     * @private
     * @param {?} previousFieldNoteAssetID
     * @param {?} currentFieldNoteAssetID
     * @param {?} fieldNoteAssetFile
     * @return {?}
     */
    checkWhetherToDeleteExistingAsset(previousFieldNoteAssetID, currentFieldNoteAssetID, fieldNoteAssetFile) {
        return previousFieldNoteAssetID !== currentFieldNoteAssetID && fieldNoteAssetFile == null;
    }
    /**
     * @private
     * @param {?} newInspection
     * @return {?}
     */
    requestCreateInspection(newInspection) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection`;
        /** @type {?} */
        const request = this._http.post(requestUrl, newInspection).pipe(map(this.onInspectionChanged));
        return request;
    }
    /**
     * @private
     * @param {?} newInspection
     * @return {?}
     */
    requestCreateInspectionFromWell(newInspection) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/wells/inspection`;
        /** @type {?} */
        const request = this._http.post(requestUrl, newInspection).pipe(map(this.onInspectionChanged));
        return request;
    }
    /**
     * @param {?=} existingInspection
     * @return {?}
     */
    createEditableInspection(existingInspection = null) {
        // create an editable inspection out of an existing inspection
        /** @type {?} */
        const editableInspection = Inspection.createEditableInspection(existingInspection);
        // if the current user is a field tech, then make sure to assign the inspection to the current user
        if (this._userService.currentUserHasRole(UserRole.FieldTech)) {
            editableInspection.ScanTechnicianID = this._userService.currentUser.UserID;
        }
        return editableInspection;
    }
    /**
     * @param {?} wellID
     * @param {?} updatedInspection
     * @param {?} previousFieldNoteAssetID
     * @param {?} fieldNoteAssetFile
     * @param {?} inspectionReportFile
     * @return {?}
     */
    updateInspection(wellID, updatedInspection, previousFieldNoteAssetID, fieldNoteAssetFile, inspectionReportFile) {
        // Check to see if the previous field note asset needs to be deleted
        // Previous field note asset needs to be deleted if the previous field
        // note asset does not match the current field note asset and the caller is
        // not replacing the field note asset with a different image
        /** @type {?} */
        const deletePreviousFieldNoteAsset = this.checkWhetherToDeleteExistingAsset(previousFieldNoteAssetID, updatedInspection.FieldNote.AssetID, fieldNoteAssetFile);
        /** @type {?} */
        let deletePreviousFieldNoteAsset$ = of(null);
        if (deletePreviousFieldNoteAsset) {
            deletePreviousFieldNoteAsset$ = this._assetSevice.deleteAsset(previousFieldNoteAssetID);
        }
        // upload new field note asset if available
        /** @type {?} */
        let uploadFieldNoteAsset$ = of(null);
        if (fieldNoteAssetFile != null) {
            uploadFieldNoteAsset$ = this._assetSevice.uploadAsset(fieldNoteAssetFile, wellID, updatedInspection.InspectionDate, updatedInspection.FieldNote.AssetID);
        }
        // upload new inspection report if available
        /** @type {?} */
        let uploadInspectionReport$ = of(null);
        if (inspectionReportFile != null) {
            uploadInspectionReport$ = this._reportService.uploadReport(inspectionReportFile, wellID, updatedInspection.InspectionDate, updatedInspection.FireTube.HWL, updatedInspection.ReportID);
        }
        // delete the previous field note asset first, then upload the new field note asset and report
        // once those have completed successfully, update the inspection
        return deletePreviousFieldNoteAsset$.pipe(flatMap((/**
         * @return {?}
         */
        () => forkJoin([uploadFieldNoteAsset$, uploadInspectionReport$]))), flatMap((/**
         * @param {?} fileUploadResults
         * @return {?}
         */
        fileUploadResults => {
            /** @type {?} */
            const fieldNoteAsset = fileUploadResults[0];
            if (fieldNoteAsset != null) {
                updatedInspection.FieldNote.AssetID = fieldNoteAsset.AssetID;
            }
            /** @type {?} */
            const inspectionReport = fileUploadResults[1];
            if (inspectionReport != null) {
                updatedInspection.ReportID = inspectionReport.ReportID;
            }
            return this.requestUpdateInspection(updatedInspection);
        })));
    }
    /**
     * @private
     * @param {?} updatedInspection
     * @return {?}
     */
    requestUpdateInspection(updatedInspection) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection`;
        /** @type {?} */
        const request = this._http.put(requestUrl, updatedInspection).pipe(map(this.onInspectionChanged));
        return request;
    }
    /**
     * @return {?}
     */
    getInspectionConstants() {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/constants`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} invoicedInspections
     * @return {?}
     */
    updateInvoicedInspections(invoicedInspections) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspections/invoice`;
        return this._http.put(requestUrl, invoicedInspections).pipe(map((/**
         * @param {?} updatedInspections
         * @return {?}
         */
        updatedInspections => {
            InspectionDateHydrator.processInspections(updatedInspections);
            return updatedInspections;
        })));
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    deleteInspection(inspectionID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/${inspectionID}`;
        return this._http.delete(requestUrl);
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    getScheduledInspection(wellID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspection/${wellID}/sched`;
        return this._http.get(requestUrl);
    }
    /**
     * @param {?} val
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    getInspectionsList(val, page, pageSize) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/inspections/search/page/${page}`;
        /** @type {?} */
        const requestParams = {
            keyword: val,
            pageSize: pageSize.toString()
        };
        return this._http.get(requestUrl, { params: requestParams }).pipe(shareReplay(1));
    }
}
InspectionService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
InspectionService.ctorParameters = () => [
    { type: HttpClient },
    { type: UserService },
    { type: AssetService },
    { type: ReportService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ InspectionService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InspectionService_Factory() { return new InspectionService(ɵɵinject(HttpClient), ɵɵinject(UserService), ɵɵinject(AssetService), ɵɵinject(ReportService), ɵɵinject(APP_CONFIG)); }, token: InspectionService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    InspectionService.prototype.onInspectionChanged;
    /**
     * @type {?}
     * @private
     */
    InspectionService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    InspectionService.prototype._userService;
    /**
     * @type {?}
     * @private
     */
    InspectionService.prototype._assetSevice;
    /**
     * @type {?}
     * @private
     */
    InspectionService.prototype._reportService;
    /**
     * @type {?}
     * @private
     */
    InspectionService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/inspection-table/inspection-table.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IActionTemplateContext() { }
if (false) {
    /** @type {?} */
    IActionTemplateContext.prototype.inspection;
}
class InspectionTableComponent {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        this._inspectionService = _inspectionService;
        this.prevHWL = '';
        this._inspectionSelectedMap = new Map();
        this.showCustomer = true;
        this.showRoute = true;
        this.showWell = true;
        this.showInspectionDetails = true;
        this.showActions = true;
        this.isFromCustomerPortal = false;
        this.isFromAdminPortal = false;
        this.dateFormat = MONTH_DAY_YEAR_DATE_FORMAT;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        let main = document.querySelector("#main_content");
        main.classList.add("col-lg-12");
    }
    /**
     * @param {?} inspection
     * @return {?}
     */
    getTrackByID(inspection) {
        return inspection.InspectionID;
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    getPreviousInsDate(inspectionID) {
        /** @type {?} */
        var prevDate = inspectionID.toString();
        //this._inspectionService.getPreviousCompletedInspection(inspectionID).subscribe({
        //	next: inspection => {
        //		if (inspection == null) {
        //			prevDate = 'NA';
        //		} else {
        //			prevDate = inspection.InspectionDate.toString();
        //		}
        //	},
        //	error: (error: IError) => {
        //		prevDate = 'NA';
        //	}
        //});
        return prevDate;
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    isSelected(inspectionID) {
        return this._inspectionSelectedMap.has(inspectionID) && this._inspectionSelectedMap.get(inspectionID);
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    toggleSelected(inspectionID) {
        /** @type {?} */
        const isSelected = this.isSelected(inspectionID);
        this.setSelected(inspectionID, !isSelected);
    }
    /**
     * @param {?} inspectionID
     * @param {?} isSelected
     * @return {?}
     */
    setSelected(inspectionID, isSelected) {
        this._inspectionSelectedMap.set(inspectionID, isSelected);
    }
    /**
     * @return {?}
     */
    get selectionState() {
        /** @type {?} */
        const selectionState = this.inspections.map((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            /** @type {?} */
            const state = {
                item: inspection,
                checked: this.isSelected(inspection.InspectionID)
            };
            return state;
        }));
        return selectionState;
    }
    /**
     * @param {?} inspectionID
     * @return {?}
     */
    getPrevHWL(inspectionID) {
        this.prevHWL = '';
        /** @type {?} */
        var req = this._inspectionService.getPreviousCompletedInspection(inspectionID).pipe(take(1)).subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                this.prevHWL = '';
                if (inspection == null) {
                    this.prevHWL = '';
                    this.isPrevInspExists = false;
                }
                else {
                    this.isPrevInspExists = true;
                    if (inspection.FireTube.HWL != null) {
                        this.prevHWL = inspection.FireTube.HWL;
                    }
                    else {
                        this.prevHWL = 'NA';
                    }
                }
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                console.log(error);
            })
        });
        //req.unsubscribe();
        return this.prevHWL;
    }
    /**
     * @return {?}
     */
    get selectedInspections() {
        return this.inspections.filter((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            return this.isSelected(inspection.InspectionID);
        }));
    }
}
InspectionTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-inspection-table',
                template: "<table class=\"table table-striped\" [ngClass]=\"{ 'table-hover': allowMultiselect }\">\n    <thead>\n        <tr>\n            <th *ngIf=\"allowMultiselect\"></th>\n            <th [ngClass]=\"{ 'width-7': isFromScheduledInspections }\">Date</th>\n            <th [ngClass]=\"{ 'width-15': isFromScheduledInspections }\" *ngIf=\"showCustomer\">Producer</th>\n            <th [ngClass]=\"{ 'width-25': isFromScheduledInspections }\" *ngIf=\"showWell\">Well Name</th>\n            <th [ngClass]=\"{ 'width-20': isFromScheduledInspections }\" *ngIf=\"showRoute\">Route</th>\n            <th [ngClass]=\"{ 'width-8': isFromScheduledInspections }\" *ngIf=\"showPrevScanDate\">Previous Scan Date</th>\n            <th [ngClass]=\"{ 'width-5': isFromScheduledInspections }\" *ngIf=\"showPrevHWL\">Previous HWL</th>\n            <th *ngIf=\"showInspectionDetails\">Vessel ID</th>\n            <th *ngIf=\"showInspectionDetails\">Condition</th>\n            <th *ngIf=\"showInspectionDetails\">HWL</th>\n            <th *ngIf=\"isFromCustomerPortal || isFromAdminPortal\">PHWL</th>\n            <th *ngIf=\"showInspectionDetails\">Temp</th>\n            <th *ngIf=\"showInspectionDetails\">Tube Size</th>\n            <th *ngIf=\"showInspectionDetails\">Tube Thickness</th>\n            <th *ngIf=\"showAnode\">Anode Type</th>\n            <th *ngIf=\"showInspectionDetails || showAnode\">Anode</th>\n            <th *ngIf=\"showAnode\">Anode Color</th>\n            <th *ngIf=\"showNote\">Notes</th>\n            <th [ngClass]=\"{ 'width-20': isFromScheduledInspections }\" *ngIf=\"showActions\"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr *ngFor=\"let inspection of inspections; trackBy: getTrackByID\"\n            [ngClass]=\"{ 'selectable-row': allowMultiselect }\"\n            (click)=\"toggleSelected(inspection.InspectionID)\">\n            <td *ngIf=\"allowMultiselect\">\n                <input class=\"form-check\" type=\"checkbox\"\n                       [checked]=\"isSelected(inspection.InspectionID)\" />\n            </td>\n            <td>\n                <span>{{inspection.InspectionDate | date: dateFormat}}</span>\n            </td>\n            <td *ngIf=\"showCustomer\">\n                <span>{{inspection.CustomerCode}}</span>\n            </td>\n            <td *ngIf=\"showWell\">\n                <eec-inpection-well-name [inspectionID]=\"inspection.InspectionID\" [wellName]=\"inspection.WellName\"></eec-inpection-well-name><span *ngIf=\"inspection.IsH2s\" style=\"color:red\"><b>&nbsp;*</b></span>\n</td>\n\n            <td *ngIf=\"showRoute\">\n                <span>{{inspection.RouteName}}</span>\n            </td>\n            <td *ngIf=\"showPrevScanDate\">\n                <eec-previous-inspection-date [inspectionID]=\"inspection.InspectionID\">\n                </eec-previous-inspection-date>\n            </td>\n            <td *ngIf=\"showPrevHWL\">\n                <eec-previous-inspection-hwl [inspectionID]=\"inspection.InspectionID\">\n                </eec-previous-inspection-hwl>\n\n\n            </td>\n            <td *ngIf=\"showInspectionDetails\">\n                <span>{{inspection.VesselID | notany}}</span>\n            </td>\n            <td *ngIf=\"showInspectionDetails\">\n                <eec-condition-text [condition]=\"inspection.FireTube | null:'Condition'\"\n                                    [description]=\"inspection.FireTube | null:'ConditionDescription'\">\n                </eec-condition-text>\n            </td>\n            <td *ngIf=\"showInspectionDetails\">\n                <span>{{inspection.FireTube | null:'HWL' | percent | notany}}</span>\n            </td>\n            <td *ngIf=\"isFromCustomerPortal || isFromAdminPortal\">\n                <eec-previous-inspection-hwl [inspectionID]=\"inspection.InspectionID\">\n                </eec-previous-inspection-hwl>\n\n            </td>\n            <td *ngIf=\"showInspectionDetails\">\n                <span>{{inspection.FireTube | null:'Temperature' | temp | notany}}</span>\n            </td>\n            <td *ngIf=\"showInspectionDetails\">\n                <span>{{inspection.FireTube | null:'TubeDiameterDescription' | notany}}</span>\n            </td>\n            <td *ngIf=\"showInspectionDetails\">\n                <span>{{inspection.FireTube | null:'TubeThickness' | notany}}</span>\n            </td>\n            <td *ngIf=\"showAnode\">\n                <span>{{inspection.Anode | null:\"AnodeTypeDescription\" | notany }}</span>\n            </td>\n            <td *ngIf=\"showInspectionDetails || showAnode\">\n                <span>{{((inspection.Anode | null:\"AnodeReading\") | units:(inspection.Anode | null:\"AnodeReadingTypeDescription\")) | notany }}</span>\n            </td>\n            <td *ngIf=\"showAnode\">\n                <eec-condition-text [condition]=\"inspection.Anode | null:'Condition'\"\n                                    [description]=\"inspection.Anode | null:'ConditionDescription'\">\n                </eec-condition-text>\n            </td>\n            <td *ngIf=\"showNote\">\n                <div class=\"text-truncate field-note\">{{inspection.FieldNote | null:\"Note\" | notany }}</div>\n            </td>\n            <td *ngIf=\"showActions\">\n                <eec-download-report-button *ngIf=\"inspection.ReportID\" class=\"m-1\"\n                                            [reportID]=\"inspection.ReportID\" [wellID]=\"inspection.WellID\">\n                </eec-download-report-button>\n                <span *ngIf=\"customInspectionActions\" class=\"m-1\">\n                    <ng-container *ngTemplateOutlet=\"customInspectionActions; context: {inspection: inspection}\">\n                    </ng-container>\n\n                </span>\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n",
                styles: [".selectable-row{cursor:pointer}.field-note{max-width:10ch}.width-10{width:10%}.width-20{width:20%}.width-25{width:25%}"]
            }] }
];
/** @nocollapse */
InspectionTableComponent.ctorParameters = () => [
    { type: InspectionService }
];
InspectionTableComponent.propDecorators = {
    inspections: [{ type: Input }],
    showCustomer: [{ type: Input }],
    showRoute: [{ type: Input }],
    showWell: [{ type: Input }],
    showPrevScanDate: [{ type: Input }],
    showPrevHWL: [{ type: Input }],
    isPrevInspExists: [{ type: Input }],
    showInspectionDetails: [{ type: Input }],
    showAnode: [{ type: Input }],
    showNote: [{ type: Input }],
    showActions: [{ type: Input }],
    customInspectionActions: [{ type: Input }],
    allowMultiselect: [{ type: Input }],
    dateFormat: [{ type: Input }],
    isFromScheduledInspections: [{ type: Input }],
    isFromCustomerPortal: [{ type: Input }],
    isFromAdminPortal: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    InspectionTableComponent.prototype.inspections;
    /** @type {?} */
    InspectionTableComponent.prototype.showCustomer;
    /** @type {?} */
    InspectionTableComponent.prototype.showRoute;
    /** @type {?} */
    InspectionTableComponent.prototype.showWell;
    /** @type {?} */
    InspectionTableComponent.prototype.showPrevScanDate;
    /** @type {?} */
    InspectionTableComponent.prototype.showPrevHWL;
    /** @type {?} */
    InspectionTableComponent.prototype.isPrevInspExists;
    /** @type {?} */
    InspectionTableComponent.prototype.showInspectionDetails;
    /** @type {?} */
    InspectionTableComponent.prototype.showAnode;
    /** @type {?} */
    InspectionTableComponent.prototype.showNote;
    /** @type {?} */
    InspectionTableComponent.prototype.showActions;
    /** @type {?} */
    InspectionTableComponent.prototype.customInspectionActions;
    /** @type {?} */
    InspectionTableComponent.prototype.allowMultiselect;
    /** @type {?} */
    InspectionTableComponent.prototype.dateFormat;
    /** @type {?} */
    InspectionTableComponent.prototype.isFromScheduledInspections;
    /** @type {?} */
    InspectionTableComponent.prototype.isFromCustomerPortal;
    /** @type {?} */
    InspectionTableComponent.prototype.isFromAdminPortal;
    /** @type {?} */
    InspectionTableComponent.prototype.prevHWL;
    /** @type {?} */
    InspectionTableComponent.prototype.errorMsg;
    /** @type {?} */
    InspectionTableComponent.prototype.successMsg;
    /**
     * @type {?}
     * @private
     */
    InspectionTableComponent.prototype._inspectionSelectedMap;
    /**
     * @type {?}
     * @private
     */
    InspectionTableComponent.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/keyword-search-form/keyword-search-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFormData$4() { }
if (false) {
    /** @type {?} */
    IFormData$4.prototype.SearchTerm;
}
/**
 * @record
 */
function IKeywordSearchFormResult() { }
if (false) {
    /** @type {?} */
    IKeywordSearchFormResult.prototype.SearchTerm;
    /** @type {?} */
    IKeywordSearchFormResult.prototype.CustomerID;
}
class KeywordSearchFormComponent {
    /**
     * @param {?} _formBuilder
     */
    constructor(_formBuilder) {
        this._formBuilder = _formBuilder;
        this.searchTermChanged = new EventEmitter();
        this.customerPlaceholder = 'All Customers';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.form = this._formBuilder.group({
            SearchTerm: ['', Validators.required],
            CustomerID: ['-1']
        });
        //this.selectInitialCustomer();
        this._searchTermChangedSub = this.form.controls.SearchTerm.valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        (value) => {
            this._hasSearchTerm = value != null && value.length > 0;
        }));
        this.reset();
        this.selectedValue = "All Producers";
        this.selectInitialCustomer();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._searchTermChangedSub.unsubscribe();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!changes) {
            return;
        }
        /** @type {?} */
        const searchTermChanges = changes.searchTerm;
        if (searchTermChanges && searchTermChanges.currentValue !== searchTermChanges.previousValue) {
            this.reset();
        }
    }
    /**
     * @param {?} customer
     * @return {?}
     */
    getCustomerID(customer) {
        return customer.CustomerID;
    }
    /**
     * @return {?}
     */
    onCustomerIDChanged() {
        /** @type {?} */
        const customerID = InputConverterService.parseInt(this.controls.CustomerID.value);
        this.searchTermChanged.emit({
            CustomerID: customerID,
            SearchTerm: null
        });
    }
    /**
     * @return {?}
     */
    get controls() {
        return this.form.controls;
    }
    /**
     * @return {?}
     */
    onClear() {
        this.clear();
    }
    /**
     * @return {?}
     */
    get hasSearchTerm() {
        return this._hasSearchTerm;
    }
    /**
     * @param {?=} formData
     * @return {?}
     */
    reset(formData = null) {
        if (this.form == null) {
            return;
        }
        if (formData == null) {
            formData = {
                SearchTerm: this.searchTerm
            };
        }
        this.form.reset(formData);
        this.submitted = false;
    }
    /**
     * @return {?}
     */
    clear() {
        /** @type {?} */
        const formData = {
            SearchTerm: ''
        };
        this.reset(formData);
        this.onSearchTermChanged();
    }
    /**
     * @return {?}
     */
    onSubmit() {
        this.submitted = true;
        if (this.form.invalid) {
            return;
        }
        this.onSearchTermChanged();
    }
    /**
     * @private
     * @return {?}
     */
    onSearchTermChanged() {
        /** @type {?} */
        const result = {
            SearchTerm: InputConverterService.trim(this.controls.SearchTerm.value),
            CustomerID: this.controls.CustomerID.value
        };
        this.searchTermChanged.emit(result);
    }
    /**
     * @private
     * @return {?}
     */
    selectInitialCustomer() {
        /** @type {?} */
        let customerID = '-1';
        if (this.autoSelectCustomer && this.customers != null && this.customers.length > 0) {
            customerID = this.customers[0].CustomerID.toString();
        }
        this.controls.CustomerID.setValue(customerID);
    }
}
KeywordSearchFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-keyword-search-form',
                template: "<form class=\"form-inline\" [formGroup]=\"form\">\n    <select formControlName=\"CustomerID\" class=\"form-control mr-2\"\n            (change)=\"onCustomerIDChanged()\" [value]=\"-1\" >\n        <option value=\"-1\">{{customerPlaceholder}}</option>\n        <option *ngFor=\"let customer of customers; trackBy: getCustomerID\" [value]=\"customer.CustomerID\">\n            {{customer.Code}}\n        </option>\n    </select>\n    <input formControlName=\"SearchTerm\" type=\"text\" class=\"form-control\"\n           placeholder=\"Enter Well/Vessel ID\"\n           title=\"Search by Well Name or Vessel ID\"\n           [ngClass]=\"{ 'is-invalid': submitted && controls.SearchTerm.errors }\" />\n    <div class=\"button-group\">\n        <button [disabled]=\"searching\" class=\"btn btn-secondary my-2 mx-2\" type=\"reset\" (click)=\"onClear()\">Clear</button>\n        <button [disabled]=\"searching || !hasSearchTerm\" class=\"btn btn-primary my-2 mr-2\" type=\"submit\" (click)=\"onSubmit()\">\n            <eec-spinner [hidden]=\"!submitted || !searching\" small=\"true\" class=\"m-1\"></eec-spinner>\n            Find\n        </button>\n    </div>\n</form>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
KeywordSearchFormComponent.ctorParameters = () => [
    { type: FormBuilder }
];
KeywordSearchFormComponent.propDecorators = {
    searchTerm: [{ type: Input }],
    customerPlaceholder: [{ type: Input }],
    autoSelectCustomer: [{ type: Input }],
    searching: [{ type: Input }],
    customers: [{ type: Input }],
    searchTermChanged: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    KeywordSearchFormComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    KeywordSearchFormComponent.prototype._hasSearchTerm;
    /** @type {?} */
    KeywordSearchFormComponent.prototype.selectedValue;
    /**
     * @type {?}
     * @private
     */
    KeywordSearchFormComponent.prototype._searchTermChangedSub;
    /** @type {?} */
    KeywordSearchFormComponent.prototype.searchTerm;
    /** @type {?} */
    KeywordSearchFormComponent.prototype.customerPlaceholder;
    /** @type {?} */
    KeywordSearchFormComponent.prototype.autoSelectCustomer;
    /** @type {?} */
    KeywordSearchFormComponent.prototype.submitted;
    /** @type {?} */
    KeywordSearchFormComponent.prototype.searching;
    /** @type {?} */
    KeywordSearchFormComponent.prototype.customers;
    /** @type {?} */
    KeywordSearchFormComponent.prototype.searchTermChanged;
    /**
     * @type {?}
     * @private
     */
    KeywordSearchFormComponent.prototype._formBuilder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/login/login.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFormData$5() { }
if (false) {
    /** @type {?} */
    IFormData$5.prototype.username;
    /** @type {?} */
    IFormData$5.prototype.password;
}
class LoginComponent {
    /**
     * @param {?} _formBuilder
     * @param {?} _userService
     * @param {?} _router
     * @param {?} _route
     */
    constructor(_formBuilder, _userService, _router, _route) {
        this._formBuilder = _formBuilder;
        this._userService = _userService;
        this._router = _router;
        this._route = _route;
        this.loading = false;
        this.submitted = false;
        if (this._userService.currentUserIsAuthenticated) {
            this._router.navigate(['/']);
        }
    }
    /**
     * @return {?}
     */
    get controls() {
        return this.loginForm.controls;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.loginForm = this._formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });
    }
    /**
     * @return {?}
     */
    onSubmit() {
        this.submitted = true;
        this.errorMsg = '';
        if (this.loginForm.invalid) {
            return;
        }
        /** @type {?} */
        const username = this.loginForm.controls.username.value;
        /** @type {?} */
        const password = this.loginForm.controls.password.value;
        this.loading = true;
        this._userService.login(username, password)
            .subscribe({
            next: (/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const routeSnapshot = this._route.snapshot;
                /** @type {?} */
                let returnUrl = '';
                if (routeSnapshot.queryParamMap.has('returnUrl')) {
                    returnUrl = routeSnapshot.queryParamMap.get('returnUrl');
                }
                if (returnUrl == null || returnUrl.length === 0) {
                    returnUrl = '/';
                }
                this.reset(true);
                this._router.navigateByUrl(returnUrl);
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.errorMsg = error != null ? error.Message : '';
                this.loading = false;
                this.reset(false);
            })
        });
    }
    /**
     * @param {?} clearUsername
     * @return {?}
     */
    reset(clearUsername) {
        this.submitted = false;
        /** @type {?} */
        const formData = this.loginForm.value;
        formData.password = '';
        if (clearUsername) {
            formData.username = '';
        }
        this.loginForm.reset(formData);
    }
}
LoginComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-login',
                template: "<div>\r\n\t<h3>Login</h3>\r\n\t<form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit()\">\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<label for=\"username\">Username</label>\r\n\t\t\t<input id=\"username\" formControlName=\"username\" type=\"email\" class=\"form-control\" placeholder=\"Enter username\"\r\n\t\t\t\t   [ngClass]=\"{ 'is-invalid': submitted && controls.username.errors }\"/>\r\n\r\n\t\t\t<div *ngIf=\"submitted && controls.username.errors\" class=\"invalid-feedback\">\r\n\t\t\t\t<div *ngIf=\"controls.username.errors.required\">Username is required</div>\r\n\t\t\t\t<div *ngIf=\"controls.username.errors.email\">Username must be an email address</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<label for=\"password\">Password</label>\r\n\t\t\t<input id=\"password\" formControlName=\"password\" type=\"password\" class=\"form-control\" placeholder=\"Enter password\"\r\n\t\t\t\t   [ngClass]=\"{ 'is-invalid': submitted && controls.password.errors }\"/>\r\n\r\n\t\t\t<div *ngIf=\"submitted && controls.password.errors\" class=\"invalid-feedback\">\r\n\t\t\t\t<div *ngIf=\"controls.password.errors.required\">Password is required</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<eec-form-alerts\r\n\t\t\t[formInvalid]=\"submitted && loginForm.invalid\" \r\n\t\t\t[errorMsg]=\"errorMsg\" \r\n\t\t\t[successMsg]=\"successMsg\">\r\n\t\t</eec-form-alerts>\r\n\r\n\t\t<button [disabled]=\"loading\" class=\"btn btn-primary my-2 mr-2\">\r\n\t\t\t<eec-spinner [hidden]=\"!loading\" small=\"true\" class=\"mr-1\"></eec-spinner>\r\n\t\t\tLogin\r\n\t\t</button>\r\n\t</form>\r\n</div>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
LoginComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: UserService },
    { type: Router },
    { type: ActivatedRoute }
];
if (false) {
    /** @type {?} */
    LoginComponent.prototype.loginForm;
    /** @type {?} */
    LoginComponent.prototype.loading;
    /** @type {?} */
    LoginComponent.prototype.submitted;
    /** @type {?} */
    LoginComponent.prototype.errorMsg;
    /** @type {?} */
    LoginComponent.prototype.successMsg;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype._formBuilder;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype._userService;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype._router;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype._route;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/logout-button/logout-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LogoutButtonComponent {
    /**
     * @param {?} _userService
     */
    constructor(_userService) {
        this._userService = _userService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    onLogout() {
        this._userService.logoutAndRedirectToLoginPage();
    }
}
LogoutButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-logout-button',
                template: "<button type=\"button\" class=\"btn btn-primary\" (click)=\"onLogout()\">Logout</button>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
LogoutButtonComponent.ctorParameters = () => [
    { type: UserService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    LogoutButtonComponent.prototype._userService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/page-alerts/page-alerts.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PageAlertsComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes == null) {
            return;
        }
        /** @type {?} */
        const errorMsgChange = changes.errorMsg;
        if (errorMsgChange != null && errorMsgChange.currentValue !== errorMsgChange.previousValue) {
            this._showError = !InputConverterService.isEmpty(errorMsgChange.currentValue);
        }
        /** @type {?} */
        const successMsgChange = changes.successMsg;
        if (successMsgChange != null && successMsgChange.currentValue !== successMsgChange.previousValue) {
            this._showSuccess = !InputConverterService.isEmpty(successMsgChange.currentValue);
        }
    }
    /**
     * @return {?}
     */
    get showError() {
        return this._showError;
    }
    /**
     * @return {?}
     */
    get showSuccess() {
        return this._showSuccess;
    }
    /**
     * @return {?}
     */
    onCloseErrorMsg() {
        this._showError = false;
    }
    /**
     * @return {?}
     */
    onCloseSuccessMsg() {
        this._showSuccess = false;
    }
}
PageAlertsComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-page-alerts',
                template: "<ngb-alert *ngIf=\"showError\" type=\"danger\" class=\"my-1\" role=\"alert\" dismissable=\"true\" (close)=\"onCloseErrorMsg()\">\n    {{errorMsg}}\n</ngb-alert>\n<ngb-alert *ngIf=\"showSuccess\" type=\"success\" class=\"my-1\" role=\"alert\" dismissable=\"true\" (close)=\"onCloseSuccessMsg()\">\n    {{successMsg}}\n</ngb-alert>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
PageAlertsComponent.ctorParameters = () => [];
PageAlertsComponent.propDecorators = {
    formInvalid: [{ type: Input }],
    errorMsg: [{ type: Input }],
    successMsg: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PageAlertsComponent.prototype.formInvalid;
    /** @type {?} */
    PageAlertsComponent.prototype.errorMsg;
    /** @type {?} */
    PageAlertsComponent.prototype.successMsg;
    /**
     * @type {?}
     * @private
     */
    PageAlertsComponent.prototype._showSuccess;
    /**
     * @type {?}
     * @private
     */
    PageAlertsComponent.prototype._showError;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/previous-inspection-button/previous-inspection-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreviousInspectionButtonComponent {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        this._inspectionService = _inspectionService;
        this.inspectionRequested = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    onRequestInspection() {
        this.requesting = true;
        this._inspectionService.getPreviousCompletedInspection(this.inspectionID).subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                this.requesting = false;
                if (inspection == null) {
                    alert('No previous inspection found.');
                }
                else {
                    this.inspectionRequested.emit(inspection);
                }
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.requesting = false;
            })
        });
    }
}
PreviousInspectionButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-previous-inspection-button',
                template: "<button class=\"btn btn-secondary\" type=\"button\" (click)=\"onRequestInspection()\" [disabled]=\"requesting\">\n    <eec-spinner [hidden]=\"!requesting\" small=\"true\" class=\"mr-1\"></eec-spinner>\n    View Previous\n</button>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
PreviousInspectionButtonComponent.ctorParameters = () => [
    { type: InspectionService }
];
PreviousInspectionButtonComponent.propDecorators = {
    inspectionID: [{ type: Input }],
    inspectionRequested: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    PreviousInspectionButtonComponent.prototype.inspectionID;
    /** @type {?} */
    PreviousInspectionButtonComponent.prototype.inspectionRequested;
    /** @type {?} */
    PreviousInspectionButtonComponent.prototype.requesting;
    /**
     * @type {?}
     * @private
     */
    PreviousInspectionButtonComponent.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/spinner/spinner.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpinnerComponent {
    constructor() { }
}
SpinnerComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-spinner',
                template: "<span [ngClass]=\"{\n    'spinner-border': true, \n    'spinner-border-sm': small\n}\" title=\"Loading...\" aria-label=\"Loading...\"></span>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
SpinnerComponent.ctorParameters = () => [];
SpinnerComponent.propDecorators = {
    small: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    SpinnerComponent.prototype.small;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/update-inspection/update-inspection.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUpdateInspectionRouteData() { }
if (false) {
    /** @type {?} */
    IUpdateInspectionRouteData.prototype.editInspection;
}
class UpdateInspectionComponent {
    /**
     * @param {?} _route
     * @param {?} _location
     * @param {?} _inspectionService
     */
    constructor(_route, _location, _inspectionService) {
        this._route = _route;
        this._location = _location;
        this._inspectionService = _inspectionService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._routeDataSub = this._route.data.subscribe((/**
         * @param {?} routeData
         * @return {?}
         */
        (routeData) => {
            this.inspection = routeData.editInspection.Inspection;
            this.customers = routeData.editInspection.Customers;
            this.constants = routeData.editInspection.InspectionConstants;
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._routeDataSub.unsubscribe();
    }
    /**
     * @param {?} result
     * @return {?}
     */
    onSave(result) {
        this.successMsg = '';
        this.errorMsg = '';
        this.updatingInspection = true;
        this._inspectionService.updateInspection(this.inspection.WellID, result.Inspection, this.inspection.FieldNote.AssetID, result.FieldNoteAssetFile, result.InspectionReportFile)
            .pipe(map((/**
         * @param {?} inspection
         * @return {?}
         */
        inspection => {
            return this._inspectionService.createEditableInspection(inspection);
        })))
            .subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            (inspection) => {
                this.successMsg = 'Inspection updated successfully. Redirecting...';
                this.updatingInspection = false;
                this.inspection = inspection;
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    this._location.back();
                }), 3000);
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.errorMsg = error.Message;
                this.updatingInspection = false;
            })
        });
    }
}
UpdateInspectionComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-update-inspection',
                template: "<h2>Edit Inspection</h2>\n<eec-edit-inspection-form\n    [saving]=\"updatingInspection\"\n    [saveButtonLabel]=\"'Update Inspection'\"\n    [errorMsg]=\"errorMsg\"\n    [successMsg]=\"successMsg\"\n    (save)=\"onSave($event)\"\n\n    [inspection]=\"inspection\"\n    [isFromAdmin]=\"true\"\n    [isFromTech]=\"true\"\n    [customers]=\"customers\"\n    [anodeReadingTypes]=\"constants?.AnodeReadingTypes\"\n    [anodeTypes]=\"constants?.AnodeTypes\"\n    [tubeDiameters]=\"constants?.TubeDiameters\"\n    [orientations]=\"constants?.Orientations\"\n    [supportedAssetExtensions]=\"constants?.SupportedAssetExtensions\"\n    [supportedReportExtensions]=\"constants?.SupportedReportExtensions\">\n</eec-edit-inspection-form>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
UpdateInspectionComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Location },
    { type: InspectionService }
];
if (false) {
    /** @type {?} */
    UpdateInspectionComponent.prototype.inspection;
    /** @type {?} */
    UpdateInspectionComponent.prototype.customers;
    /** @type {?} */
    UpdateInspectionComponent.prototype.constants;
    /** @type {?} */
    UpdateInspectionComponent.prototype.updatingInspection;
    /** @type {?} */
    UpdateInspectionComponent.prototype.errorMsg;
    /** @type {?} */
    UpdateInspectionComponent.prototype.successMsg;
    /**
     * @type {?}
     * @private
     */
    UpdateInspectionComponent.prototype._routeDataSub;
    /**
     * @type {?}
     * @private
     */
    UpdateInspectionComponent.prototype._route;
    /**
     * @type {?}
     * @private
     */
    UpdateInspectionComponent.prototype._location;
    /**
     * @type {?}
     * @private
     */
    UpdateInspectionComponent.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/view-or-download-file-button/view-or-download-file-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewOrDownloadFileButtonComponent {
    constructor() {
        this.downloaded = new EventEmitter();
        this.downloadFailed = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    onDownload() {
        this.downloadFile(FileDownloadAction.PromptForDownload);
    }
    /**
     * @return {?}
     */
    onViewPrevious() {
        //alert("report viewp");
        this.downloadPrevFile(FileDownloadAction.ShowInNewTab);
    }
    /**
     * @return {?}
     */
    onView() {
        //alert("report view");
        this.downloadFile(FileDownloadAction.ShowInNewTab);
    }
    /**
     * @private
     * @param {?} action
     * @return {?}
     */
    downloadFile(action) {
        this.downloading = true;
        this._downloadFileComponent.startDownload(action).subscribe({
            next: (/**
             * @param {?} result
             * @return {?}
             */
            result => {
                this.downloading = false;
                this.downloaded.emit(result);
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.downloading = false;
                this.downloadFailed.emit(error);
            }),
            complete: (/**
             * @return {?}
             */
            () => {
                this.downloading = false;
            })
        });
    }
    /**
     * @private
     * @param {?} action
     * @return {?}
     */
    downloadPrevFile(action) {
        this.downloading = true;
        this._downloadFileComponent.startPrevDownload(action).subscribe({
            next: (/**
             * @param {?} result
             * @return {?}
             */
            result => {
                this.downloading = false;
                this.downloaded.emit(result);
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                alert('No Previous Report exists for this Well.');
                this.downloading = false;
                this.downloadFailed.emit(error);
            }),
            complete: (/**
             * @return {?}
             */
            () => {
                this.downloading = false;
            })
        });
    }
}
ViewOrDownloadFileButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-view-or-download-file-button',
                template: "<div class=\"btn-group\">\n    <button class=\"btn btn-secondary\" type=\"button\" (click)=\"onView()\" [disabled]=\"downloading\">\n        <eec-spinner [hidden]=\"!downloading\" small=\"true\" class=\"mr-1\"></eec-spinner>\n        <span>{{label}}</span>\n    </button>\n    <button class=\"btn btn-secondary\" type=\"button\" (click)=\"onViewPrevious()\" [disabled]=\"downloading\" title=\"View Previous Report\">\n        <i class=\"fa fa-history\"></i>\n    </button>\n    <button class=\"btn btn-secondary\" type=\"button\" (click)=\"onDownload()\" [disabled]=\"downloading\" title=\"Download File\">\n        <i class=\"fa fa-download\"></i>\n    </button>\n\n</div>\n<eec-download-file [request]=\"request\" [requestPrev]=\"requestPrev\"></eec-download-file>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ViewOrDownloadFileButtonComponent.ctorParameters = () => [];
ViewOrDownloadFileButtonComponent.propDecorators = {
    _downloadFileComponent: [{ type: ViewChild, args: [DownloadFileComponent, { static: false },] }],
    request: [{ type: Input }],
    requestPrev: [{ type: Input }],
    label: [{ type: Input }],
    downloaded: [{ type: Output }],
    downloadFailed: [{ type: Output }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ViewOrDownloadFileButtonComponent.prototype._downloadFileComponent;
    /** @type {?} */
    ViewOrDownloadFileButtonComponent.prototype.request;
    /** @type {?} */
    ViewOrDownloadFileButtonComponent.prototype.requestPrev;
    /** @type {?} */
    ViewOrDownloadFileButtonComponent.prototype.label;
    /** @type {?} */
    ViewOrDownloadFileButtonComponent.prototype.downloaded;
    /** @type {?} */
    ViewOrDownloadFileButtonComponent.prototype.downloadFailed;
    /** @type {?} */
    ViewOrDownloadFileButtonComponent.prototype.downloading;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/yearly-inspection-calendar/yearly-inspection-calendar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class YearlyInspectionCalendarComponent {
    constructor() {
        this.inspectionDateFormat = MONTH_YEAR_DATE_FORMAT;
        this.monthDateFormat = ABBREV_MONTH_YEAR_DATE_FORMAT;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} calendarMonth
     * @return {?}
     */
    getDateFromCalendarMonth(calendarMonth) {
        return InputConverterService.getDateFromCalendarMonth(calendarMonth);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCurrentMonthChanged(event) {
        this.currentMonthChanged.emit(event);
    }
}
YearlyInspectionCalendarComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-yearly-inspection-calendar',
                template: "<ng-template #noInspections>\n    <p>\n        <i>No inspections scheduled</i>\n    </p>\n</ng-template>\n\n\n<div *ngFor=\"let inspectionMonth of inspectionsByMonth\">\n    <!--<div class=\"mb-4\">\n        <eec-calendar-pagination [currentMonth]=\"currentMonth\"\n                                 (currentMonthChanged)=\"onCurrentMonthChanged($event)\">\n        </eec-calendar-pagination>\n    </div>-->\n\n    <h3>{{getDateFromCalendarMonth(inspectionMonth.calendarMonth) | date:monthDateFormat}}</h3>\n\n    <eec-inspection-table *ngIf=\"inspectionMonth.inspections.length > 0; else noInspections\"\n                          [inspections]=\"inspectionMonth.inspections\"\n                          [showCustomer]=\"showCustomer\"\n                          [showPrevScanDate]=\"true\"\n                          [showPrevHWL]=\"true\"\n                          [customInspectionActions]=\"customInspectionActions\"\n                          [showInspectionDetails]=\"false\"\n                          [isFromScheduledInspections]=\"true\"\n                          [dateFormat]=\"inspectionDateFormat\">\n    </eec-inspection-table>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
YearlyInspectionCalendarComponent.ctorParameters = () => [];
YearlyInspectionCalendarComponent.propDecorators = {
    inspectionsByMonth: [{ type: Input }],
    showCustomer: [{ type: Input }],
    customInspectionActions: [{ type: Input }],
    inspectionDateFormat: [{ type: Input }],
    currentMonth: [{ type: Input }],
    currentMonthChanged: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    YearlyInspectionCalendarComponent.prototype.inspectionsByMonth;
    /** @type {?} */
    YearlyInspectionCalendarComponent.prototype.showCustomer;
    /** @type {?} */
    YearlyInspectionCalendarComponent.prototype.customInspectionActions;
    /** @type {?} */
    YearlyInspectionCalendarComponent.prototype.inspectionDateFormat;
    /** @type {?} */
    YearlyInspectionCalendarComponent.prototype.currentMonth;
    /** @type {?} */
    YearlyInspectionCalendarComponent.prototype.currentMonthChanged;
    /** @type {?} */
    YearlyInspectionCalendarComponent.prototype.monthDateFormat;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/bll/action-button.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template TActionResult
 */
class ActionButton {
    constructor() {
        this.executing = new EventEmitter();
        this.succeeded = new EventEmitter();
        this.failed = new EventEmitter();
    }
    /**
     * @protected
     * @return {?}
     */
    get canExecute() {
        return true;
    }
    /**
     * @return {?}
     */
    get isExecuting() {
        return this._isExecuting;
    }
    /**
     * @return {?}
     */
    onExecute() {
        if (this.isExecuting || !this.canExecute) {
            return;
        }
        if (!this.confirmExecute()) {
            return;
        }
        this.setIsExecuting(true);
        this.execute().subscribe({
            next: (/**
             * @param {?} result
             * @return {?}
             */
            (result) => {
                this.setIsExecuting(false);
                this.succeeded.emit(result);
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.failed.emit(error);
            }),
            complete: (/**
             * @return {?}
             */
            () => {
                this.setIsExecuting(false);
            })
        });
    }
    /**
     * @protected
     * @return {?}
     */
    confirmExecute() {
        return true;
    }
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    setIsExecuting(value) {
        if (this._isExecuting !== value) {
            this._isExecuting = value;
            this.executing.emit(value);
        }
    }
}
ActionButton.propDecorators = {
    executing: [{ type: Output }],
    succeeded: [{ type: Output }],
    failed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ActionButton.prototype.executing;
    /** @type {?} */
    ActionButton.prototype.succeeded;
    /** @type {?} */
    ActionButton.prototype.failed;
    /**
     * @type {?}
     * @private
     */
    ActionButton.prototype._isExecuting;
    /**
     * @abstract
     * @protected
     * @return {?}
     */
    ActionButton.prototype.execute = function () { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/anode-type.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const AnodeType = {
    Block: "BLOCK",
    Redhead: "REDHD",
    Greenhead: "GRNHD",
    Bluehead: "BLUHD",
    Other: "OTHER",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/inspection-export-action.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const InspectionExportAction = {
    Inspections: "inspections",
    BillableInspections: "billableinspections",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/shared-app-settings.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const SharedAppSettings = Object.freeze({
    eeWebsiteUrl: 'http://www.eliteenergyservices.org/'
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/guards/auth.guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthGuard {
    /**
     * @param {?} _userService
     */
    constructor(_userService) {
        this._userService = _userService;
    }
    /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    canActivate(next, state) {
        /** @type {?} */
        const isAuthenticated = this._userService.currentUserIsAuthenticated;
        if (!isAuthenticated) {
            this._userService.logoutAndRedirectToLoginPage(state.url);
            return false;
        }
        /** @type {?} */
        const authData = (/** @type {?} */ (state.root.data));
        /** @type {?} */
        const allowedRoles = authData != null ? authData.roles : [];
        /** @type {?} */
        const isAuthorized = this._userService.currentUserIsAuthorized(allowedRoles);
        // TODO: redirect to not authorized page
        return isAuthorized;
    }
}
AuthGuard.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AuthGuard.ctorParameters = () => [
    { type: UserService }
];
/** @nocollapse */ AuthGuard.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(ɵɵinject(UserService)); }, token: AuthGuard, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthGuard.prototype._userService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/interceptors/error.interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ErrorInterceptor {
    /**
     * @param {?} _router
     * @param {?} _userService
     */
    constructor(_router, _userService) {
        this._router = _router;
        this._userService = _userService;
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    intercept(request, next) {
        return next.handle(request)
            .pipe(catchError((/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            if (err.status === UNAUTHORIZED) {
                this._userService.logoutAndRedirectToLoginPage(this._router.url);
            }
            /** @type {?} */
            let errorMsg = (/** @type {?} */ (err.error));
            if (errorMsg == null || errorMsg.Message == null) {
                errorMsg = {
                    Message: `Server encountered an unexpected error`
                };
            }
            return throwError(errorMsg);
        })));
    }
}
ErrorInterceptor.decorators = [
    { type: Injectable, args: [{ providedIn: 'root' },] }
];
/** @nocollapse */
ErrorInterceptor.ctorParameters = () => [
    { type: Router },
    { type: UserService }
];
/** @nocollapse */ ErrorInterceptor.ngInjectableDef = ɵɵdefineInjectable({ factory: function ErrorInterceptor_Factory() { return new ErrorInterceptor(ɵɵinject(Router), ɵɵinject(UserService)); }, token: ErrorInterceptor, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ErrorInterceptor.prototype._router;
    /**
     * @type {?}
     * @private
     */
    ErrorInterceptor.prototype._userService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/interceptors/jwt.interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class JwtInterceptor {
    /**
     * @param {?} _userService
     */
    constructor(_userService) {
        this._userService = _userService;
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    intercept(request, next) {
        // add authorization header with jwt token if available
        if (this._userService.currentUserIsAuthenticated) {
            /** @type {?} */
            const authToken = this._userService.currentUser.AuthToken;
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authToken}`
                }
            });
        }
        return next.handle(request);
    }
}
JwtInterceptor.decorators = [
    { type: Injectable, args: [{ providedIn: 'root' },] }
];
/** @nocollapse */
JwtInterceptor.ctorParameters = () => [
    { type: UserService }
];
/** @nocollapse */ JwtInterceptor.ngInjectableDef = ɵɵdefineInjectable({ factory: function JwtInterceptor_Factory() { return new JwtInterceptor(ɵɵinject(UserService)); }, token: JwtInterceptor, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    JwtInterceptor.prototype._userService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/anode.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAnode() { }
if (false) {
    /** @type {?} */
    IAnode.prototype.AnodeID;
    /** @type {?} */
    IAnode.prototype.AnodeReading;
    /** @type {?} */
    IAnode.prototype.AnodeReadingType;
    /** @type {?} */
    IAnode.prototype.AnodeReadingTypeDescription;
    /** @type {?} */
    IAnode.prototype.Condition;
    /** @type {?} */
    IAnode.prototype.ConditionDescription;
    /** @type {?} */
    IAnode.prototype.AnodeType;
    /** @type {?} */
    IAnode.prototype.AnodeTypeDescription;
    /** @type {?} */
    IAnode.prototype.InspectionID;
    /** @type {?} */
    IAnode.prototype.InspectionDate;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/asset.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAsset() { }
if (false) {
    /** @type {?} */
    IAsset.prototype.AssetID;
    /** @type {?} */
    IAsset.prototype.Name;
    /** @type {?} */
    IAsset.prototype.MimeType;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/auth-data.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAuthData() { }
if (false) {
    /** @type {?} */
    IAuthData.prototype.roles;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/authenticate-user.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAuthenticateUser() { }
if (false) {
    /** @type {?} */
    IAuthenticateUser.prototype.LoginID;
    /** @type {?} */
    IAuthenticateUser.prototype.Password;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/base-contact.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IBaseContact() { }
if (false) {
    /** @type {?} */
    IBaseContact.prototype.EmailAddress;
    /** @type {?} */
    IBaseContact.prototype.LastName;
    /** @type {?} */
    IBaseContact.prototype.FirstName;
    /** @type {?} */
    IBaseContact.prototype.MobilePhone;
    /** @type {?} */
    IBaseContact.prototype.WorkPhone;
    /** @type {?} */
    IBaseContact.prototype.Address;
    /** @type {?} */
    IBaseContact.prototype.Address2;
    /** @type {?} */
    IBaseContact.prototype.City;
    /** @type {?} */
    IBaseContact.prototype.StateCode;
    /** @type {?} */
    IBaseContact.prototype.Zip;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/base-edit-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IBaseEditInspection() { }
if (false) {
    /** @type {?} */
    IBaseEditInspection.prototype.InspectionDate;
    /** @type {?} */
    IBaseEditInspection.prototype.VesselID;
    /** @type {?} */
    IBaseEditInspection.prototype.ScanTechnicianID;
    /** @type {?} */
    IBaseEditInspection.prototype.CustomerRepID;
    /** @type {?} */
    IBaseEditInspection.prototype.FireTube;
    /** @type {?} */
    IBaseEditInspection.prototype.Anode;
    /** @type {?} */
    IBaseEditInspection.prototype.FieldNote;
    /** @type {?} */
    IBaseEditInspection.prototype.ReportID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/base-edit-route.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IBaseEditRoute() { }
if (false) {
    /** @type {?} */
    IBaseEditRoute.prototype.CustomerID;
    /** @type {?} */
    IBaseEditRoute.prototype.Name;
    /** @type {?} */
    IBaseEditRoute.prototype.Description;
    /** @type {?} */
    IBaseEditRoute.prototype.StatesServed;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/base-edit-well.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IBaseEditWell() { }
if (false) {
    /** @type {?} */
    IBaseEditWell.prototype.RouteID;
    /** @type {?} */
    IBaseEditWell.prototype.Description;
    /** @type {?} */
    IBaseEditWell.prototype.State;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/base-export-inspections.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IBaseExportInspections() { }
if (false) {
    /** @type {?} */
    IBaseExportInspections.prototype.FileName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/base-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IBaseInspection() { }
if (false) {
    /** @type {?} */
    IBaseInspection.prototype.InspectionDate;
    /** @type {?} */
    IBaseInspection.prototype.VesselID;
    /** @type {?} */
    IBaseInspection.prototype.ReportID;
    /** @type {?} */
    IBaseInspection.prototype.ReportName;
    /** @type {?} */
    IBaseInspection.prototype.CustomerRepID;
    /** @type {?} */
    IBaseInspection.prototype.CustomerRepName;
    /** @type {?} */
    IBaseInspection.prototype.ScanTechnicianID;
    /** @type {?} */
    IBaseInspection.prototype.CustomerID;
    /** @type {?} */
    IBaseInspection.prototype.CustomerName;
    /** @type {?} */
    IBaseInspection.prototype.CustomerCode;
    /** @type {?} */
    IBaseInspection.prototype.RouteID;
    /** @type {?} */
    IBaseInspection.prototype.RouteName;
    /** @type {?} */
    IBaseInspection.prototype.WellID;
    /** @type {?} */
    IBaseInspection.prototype.WellName;
    /** @type {?} */
    IBaseInspection.prototype.CurrentStatus;
    /** @type {?} */
    IBaseInspection.prototype.CurrentStatusDescription;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/calendar-month.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICalendarMonth() { }
if (false) {
    /** @type {?} */
    ICalendarMonth.prototype.year;
    /** @type {?} */
    ICalendarMonth.prototype.month;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/change-password.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IChangePassword() { }
if (false) {
    /** @type {?} */
    IChangePassword.prototype.CurrentPassword;
    /** @type {?} */
    IChangePassword.prototype.NewPassword;
    /** @type {?} */
    IChangePassword.prototype.ConfirmNewPassword;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/create-anode.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICreateAnode() { }
if (false) {
    /** @type {?} */
    ICreateAnode.prototype.AnodeReading;
    /** @type {?} */
    ICreateAnode.prototype.AnodeReadingType;
    /** @type {?} */
    ICreateAnode.prototype.AnodeType;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/create-asset.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICreateAsset() { }
if (false) {
    /** @type {?} */
    ICreateAsset.prototype.WellID;
    /** @type {?} */
    ICreateAsset.prototype.InspectionDate;
    /** @type {?} */
    ICreateAsset.prototype.File;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/create-customer.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICreateCustomer() { }
if (false) {
    /** @type {?} */
    ICreateCustomer.prototype.Code;
    /** @type {?} */
    ICreateCustomer.prototype.Name;
    /** @type {?} */
    ICreateCustomer.prototype.StatesServed;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/create-field-note.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICreateFieldNote() { }
if (false) {
    /** @type {?} */
    ICreateFieldNote.prototype.Note;
    /** @type {?} */
    ICreateFieldNote.prototype.AssetID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/create-fire-tube.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICreateFireTube() { }
if (false) {
    /** @type {?} */
    ICreateFireTube.prototype.HWL;
    /** @type {?} */
    ICreateFireTube.prototype.ConditionCategory;
    /** @type {?} */
    ICreateFireTube.prototype.IsWhiteProtocol;
    /** @type {?} */
    ICreateFireTube.prototype.Temperature;
    /** @type {?} */
    ICreateFireTube.prototype.TubeDiameter;
    /** @type {?} */
    ICreateFireTube.prototype.TubeThickness;
    /** @type {?} */
    ICreateFireTube.prototype.Orientation;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/create-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICreateInspection() { }
if (false) {
    /** @type {?} */
    ICreateInspection.prototype.WellID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/create-report.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICreateReport() { }
if (false) {
    /** @type {?} */
    ICreateReport.prototype.WellID;
    /** @type {?} */
    ICreateReport.prototype.InspectionDate;
    /** @type {?} */
    ICreateReport.prototype.HWL;
    /** @type {?} */
    ICreateReport.prototype.File;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/customer-inspection-search.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICustomerInspectionSearch() { }
if (false) {
    /** @type {?} */
    ICustomerInspectionSearch.prototype.CustomerID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/customer-list-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICustomerListItem() { }
if (false) {
    /** @type {?} */
    ICustomerListItem.prototype.WellCount;
    /** @type {?} */
    ICustomerListItem.prototype.CustomerRepName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/customer-rep.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICustomerRep() { }
if (false) {
    /** @type {?} */
    ICustomerRep.prototype.CustomerID;
    /** @type {?} */
    ICustomerRep.prototype.CustomerName;
    /** @type {?} */
    ICustomerRep.prototype.CustomerLogoAssetPath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/customer.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICustomer() { }
if (false) {
    /** @type {?} */
    ICustomer.prototype.CustomerID;
    /** @type {?} */
    ICustomer.prototype.Name;
    /** @type {?} */
    ICustomer.prototype.Code;
    /** @type {?} */
    ICustomer.prototype.ContactID;
    /** @type {?} */
    ICustomer.prototype.IsInactive;
    /** @type {?} */
    ICustomer.prototype.StatesServed;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/edit-customer.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IEditCustomer() { }
if (false) {
    /** @type {?} */
    IEditCustomer.prototype.Code;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/edit-well.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IEditWell() { }
if (false) {
    /** @type {?} */
    IEditWell.prototype.WellID;
    /** @type {?} */
    IEditWell.prototype.CustomerID;
    /** @type {?} */
    IEditWell.prototype.Name;
    /** @type {?} */
    IEditWell.prototype.IsH2s;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/error.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IError() { }
if (false) {
    /** @type {?} */
    IError.prototype.Message;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/export-inspection-search.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IExportInspectionSearch() { }
if (false) {
    /** @type {?} */
    IExportInspectionSearch.prototype.SearchParams;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/export-inspections.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IExportInspections() { }
if (false) {
    /** @type {?} */
    IExportInspections.prototype.InspectionIDs;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/export-well-inspections.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IExportWellInspections() { }
if (false) {
    /** @type {?} */
    IExportWellInspections.prototype.WellID;
    /** @type {?} */
    IExportWellInspections.prototype.NumDays;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/field-note.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFieldNote() { }
if (false) {
    /** @type {?} */
    IFieldNote.prototype.FieldNoteID;
    /** @type {?} */
    IFieldNote.prototype.Note;
    /** @type {?} */
    IFieldNote.prototype.AssetID;
    /** @type {?} */
    IFieldNote.prototype.InspectionID;
    /** @type {?} */
    IFieldNote.prototype.InspectionDate;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/file-info.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFileInfo() { }
if (false) {
    /** @type {?} */
    IFileInfo.prototype.FileName;
    /** @type {?} */
    IFileInfo.prototype.FileData;
    /** @type {?} */
    IFileInfo.prototype.MimeType;
}
/**
 * @record
 */
function IFileInfo1() { }
if (false) {
    /** @type {?} */
    IFileInfo1.prototype.FileName;
    /** @type {?} */
    IFileInfo1.prototype.FileData;
    /** @type {?} */
    IFileInfo1.prototype.MimeType;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/fire-tube.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFireTube() { }
if (false) {
    /** @type {?} */
    IFireTube.prototype.FireTubeID;
    /** @type {?} */
    IFireTube.prototype.InspectionID;
    /** @type {?} */
    IFireTube.prototype.InspectionDate;
    /** @type {?} */
    IFireTube.prototype.ReportID;
    /** @type {?} */
    IFireTube.prototype.HWL;
    /** @type {?} */
    IFireTube.prototype.ConditionCategory;
    /** @type {?} */
    IFireTube.prototype.IsWhiteProtocol;
    /** @type {?} */
    IFireTube.prototype.Temperature;
    /** @type {?} */
    IFireTube.prototype.ReplacedGasket;
    /** @type {?} */
    IFireTube.prototype.ReplacedGasketIsBillable;
    /** @type {?} */
    IFireTube.prototype.TubeDiameter;
    /** @type {?} */
    IFireTube.prototype.TubeThickness;
    /** @type {?} */
    IFireTube.prototype.TubeDiameterDescription;
    /** @type {?} */
    IFireTube.prototype.Condition;
    /** @type {?} */
    IFireTube.prototype.ConditionDescription;
    /** @type {?} */
    IFireTube.prototype.Orientation;
    /** @type {?} */
    IFireTube.prototype.OrientationDescription;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/identifiable-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IIdentifiableInspection() { }
if (false) {
    /** @type {?} */
    IIdentifiableInspection.prototype.InspectionID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/inspection-constants.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInspectionConstants() { }
if (false) {
    /** @type {?} */
    IInspectionConstants.prototype.AnodeReadingTypes;
    /** @type {?} */
    IInspectionConstants.prototype.AnodeTypes;
    /** @type {?} */
    IInspectionConstants.prototype.TubeDiameters;
    /** @type {?} */
    IInspectionConstants.prototype.Orientations;
    /** @type {?} */
    IInspectionConstants.prototype.SupportedAssetExtensions;
    /** @type {?} */
    IInspectionConstants.prototype.SupportedReportExtensions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/inspection-list-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInspectionListItem() { }
if (false) {
    /** @type {?} */
    IInspectionListItem.prototype.InspectionID;
    /** @type {?} */
    IInspectionListItem.prototype.FireTube;
    /** @type {?} */
    IInspectionListItem.prototype.Anode;
    /** @type {?} */
    IInspectionListItem.prototype.FieldNode;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/inspection-month.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInspectionMonth() { }
if (false) {
    /** @type {?} */
    IInspectionMonth.prototype.calendarMonth;
    /** @type {?} */
    IInspectionMonth.prototype.inspections;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/inspection-search.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInspectionSearch() { }
if (false) {
    /** @type {?} */
    IInspectionSearch.prototype.NumDays;
    /** @type {?} */
    IInspectionSearch.prototype.Keyword;
    /** @type {?} */
    IInspectionSearch.prototype.VesselID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInspection() { }
if (false) {
    /** @type {?} */
    IInspection.prototype.FireTube;
    /** @type {?} */
    IInspection.prototype.Anode;
    /** @type {?} */
    IInspection.prototype.FieldNote;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/invoiced-inspection-list-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInvoicedInspectionListItem() { }
if (false) {
    /** @type {?} */
    IInvoicedInspectionListItem.prototype.IsInvoiced;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/invoiced-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInvoicedInspection() { }
if (false) {
    /** @type {?} */
    IInvoicedInspection.prototype.IsInvoiced;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/item-check-state.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template TItem
 */
function IItemCheckState() { }
if (false) {
    /** @type {?} */
    IItemCheckState.prototype.item;
    /** @type {?} */
    IItemCheckState.prototype.checked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/lookup-table-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ILookupTableItem() { }
if (false) {
    /** @type {?} */
    ILookupTableItem.prototype.Index;
    /** @type {?} */
    ILookupTableItem.prototype.Description;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/page.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template T
 */
function IPage() { }
if (false) {
    /** @type {?} */
    IPage.prototype.Page;
    /** @type {?} */
    IPage.prototype.PageSize;
    /** @type {?} */
    IPage.prototype.PageCount;
    /** @type {?} */
    IPage.prototype.TotalItemCount;
    /** @type {?} */
    IPage.prototype.Items;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/report.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IReport() { }
if (false) {
    /** @type {?} */
    IReport.prototype.ReportID;
    /** @type {?} */
    IReport.prototype.Name;
    /** @type {?} */
    IReport.prototype.MimeType;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/request-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IRequestInspection() { }
if (false) {
    /** @type {?} */
    IRequestInspection.prototype.RequestFollowUp;
    /** @type {?} */
    IRequestInspection.prototype.NumMonthsFromLastInspection;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/route-list-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IRouteListItem() { }
if (false) {
    /** @type {?} */
    IRouteListItem.prototype.CustomerName;
    /** @type {?} */
    IRouteListItem.prototype.CustomerRepName;
    /** @type {?} */
    IRouteListItem.prototype.WellCount;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/route-tree.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IRouteTree() { }
if (false) {
    /** @type {?} */
    IRouteTree.prototype.Wells;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/route.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IRoute() { }
if (false) {
    /** @type {?} */
    IRoute.prototype.RouteID;
    /** @type {?} */
    IRoute.prototype.CustomerID;
    /** @type {?} */
    IRoute.prototype.Name;
    /** @type {?} */
    IRoute.prototype.Description;
    /** @type {?} */
    IRoute.prototype.StatesServed;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/set-invoiced-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ISetInvoicedInspection() { }
if (false) {
    /** @type {?} */
    ISetInvoicedInspection.prototype.InspectionID;
    /** @type {?} */
    ISetInvoicedInspection.prototype.IsInvoiced;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/update-asset.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUpdateAsset() { }
if (false) {
    /** @type {?} */
    IUpdateAsset.prototype.AssetID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/update-customer.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUpdateCustomer() { }
if (false) {
    /** @type {?} */
    IUpdateCustomer.prototype.CustomerID;
    /** @type {?} */
    IUpdateCustomer.prototype.Name;
    /** @type {?} */
    IUpdateCustomer.prototype.StatesServed;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/update-inspection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUpdateInspection() { }
if (false) {
    /** @type {?} */
    IUpdateInspection.prototype.InspectionID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/update-report.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUpdateReport() { }
if (false) {
    /** @type {?} */
    IUpdateReport.prototype.ReportID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/update-route.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUpdateRoute() { }
if (false) {
    /** @type {?} */
    IUpdateRoute.prototype.RouteID;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/update-well.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUpdateWell() { }
if (false) {
    /** @type {?} */
    IUpdateWell.prototype.WellID;
    /** @type {?} */
    IUpdateWell.prototype.Name;
    /** @type {?} */
    IUpdateWell.prototype.IsH2s;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/user.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUser() { }
if (false) {
    /** @type {?} */
    IUser.prototype.UserID;
    /** @type {?} */
    IUser.prototype.LoginID;
    /** @type {?} */
    IUser.prototype.AuthToken;
    /** @type {?} */
    IUser.prototype.Roles;
    /** @type {?} */
    IUser.prototype.ContactID;
    /** @type {?} */
    IUser.prototype.Name;
    /** @type {?} */
    IUser.prototype.IsInactive;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/well-list-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IWellListItem() { }
if (false) {
    /** @type {?} */
    IWellListItem.prototype.CustomerID;
    /** @type {?} */
    IWellListItem.prototype.CustomerName;
    /** @type {?} */
    IWellListItem.prototype.CustomerRepID;
    /** @type {?} */
    IWellListItem.prototype.CustomerRepName;
    /** @type {?} */
    IWellListItem.prototype.RouteName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/well.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IWell() { }
if (false) {
    /** @type {?} */
    IWell.prototype.WellID;
    /** @type {?} */
    IWell.prototype.RouteID;
    /** @type {?} */
    IWell.prototype.CustomerID;
    /** @type {?} */
    IWell.prototype.Name;
    /** @type {?} */
    IWell.prototype.Description;
    /** @type {?} */
    IWell.prototype.State;
    /** @type {?} */
    IWell.prototype.IsH2s;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/not-applicable.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const NOT_APPLICABLE_DISPLAY_VALUE = 'N/A';
class NotApplicablePipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        /** @type {?} */
        let transformValue = value;
        if (value == null) {
            transformValue = NOT_APPLICABLE_DISPLAY_VALUE;
        }
        else if (typeof (value) === 'string' && value.trim().length === 0) {
            transformValue = NOT_APPLICABLE_DISPLAY_VALUE;
        }
        else if (typeof (value) === 'number' && isNaN(value)) {
            transformValue = NOT_APPLICABLE_DISPLAY_VALUE;
        }
        return transformValue;
    }
}
NotApplicablePipe.decorators = [
    { type: Pipe, args: [{ name: 'notany' },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/null-coalescing.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NullCoalescingPipe {
    /**
     * @param {?} value
     * @param {?} propName
     * @return {?}
     */
    transform(value, propName) {
        if (value == null) {
            return null;
        }
        return value[propName];
    }
}
NullCoalescingPipe.decorators = [
    { type: Pipe, args: [{ name: 'null' },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/states.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StatesPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        if (value == null || value.length === 0) {
            return null;
        }
        /** @type {?} */
        let stateListText = value[0].Index;
        for (let i = 1; i < value.length; ++i) {
            stateListText += '/' + value[i].Index;
        }
        return stateListText;
    }
}
StatesPipe.decorators = [
    { type: Pipe, args: [{
                name: 'states'
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/temperature.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TemperaturePipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        if (value == null) {
            return null;
        }
        /** @type {?} */
        let transformValue = null;
        if (typeof (value) === 'string') {
            transformValue = value;
        }
        else {
            if (isNaN(value)) {
                return null;
            }
            transformValue = value.toString(10);
        }
        return transformValue + '\u00B0';
    }
}
TemperaturePipe.decorators = [
    { type: Pipe, args: [{ name: 'temp' },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/units.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UnitsPipe {
    /**
     * @param {?} value
     * @param {?} units
     * @return {?}
     */
    transform(value, units) {
        if (value == null) {
            return null;
        }
        if (units == null || units.length === 0) {
            return value;
        }
        return `${value} ${units}`;
    }
}
UnitsPipe.decorators = [
    { type: Pipe, args: [{ name: 'units' },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/yes-no.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class YesNoPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return value === true ? 'Yes' : 'No';
    }
}
YesNoPipe.decorators = [
    { type: Pipe, args: [{
                name: 'yesno'
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/constants.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConstantsService {
    /**
     * @param {?} _http
     * @param {?} _appConfig
     */
    constructor(_http, _appConfig) {
        this._http = _http;
        this._appConfig = _appConfig;
    }
    /**
     * @return {?}
     */
    getConditions() {
        return this.fetchByName('conditions');
    }
    /**
     * @return {?}
     */
    getInspectionStatuses() {
        return this.fetchByName('inspectionstatuses');
    }
    /**
     * @return {?}
     */
    getStates() {
        return this.fetchByName('states');
    }
    /**
     * @return {?}
     */
    getAnodeReadingTypes() {
        return this.fetchByName('anodereadingtypes');
    }
    /**
     * @return {?}
     */
    getAnodeTypes() {
        return this.fetchByName('anodetypes');
    }
    /**
     * @return {?}
     */
    getTubeDiameters() {
        return this.fetchByName('tubediameters');
    }
    /**
     * @return {?}
     */
    getOrientations() {
        return this.fetchByName('orientations');
    }
    /**
     * @private
     * @param {?} name
     * @return {?}
     */
    fetchByName(name) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/constants/${name}`;
        return this._http.get(requestUrl);
    }
}
ConstantsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ConstantsService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ ConstantsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ConstantsService_Factory() { return new ConstantsService(ɵɵinject(HttpClient), ɵɵinject(APP_CONFIG)); }, token: ConstantsService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ConstantsService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    ConstantsService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/anode-types-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnodeTypesResolverService {
    /**
     * @param {?} _constantsService
     */
    constructor(_constantsService) {
        this._constantsService = _constantsService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        return this._constantsService.getAnodeTypes();
    }
}
AnodeTypesResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AnodeTypesResolverService.ctorParameters = () => [
    { type: ConstantsService }
];
/** @nocollapse */ AnodeTypesResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnodeTypesResolverService_Factory() { return new AnodeTypesResolverService(ɵɵinject(ConstantsService)); }, token: AnodeTypesResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AnodeTypesResolverService.prototype._constantsService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/customer-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomerResolverService {
    /**
     * @param {?} _customerService
     */
    constructor(_customerService) {
        this._customerService = _customerService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        /** @type {?} */
        let customerID;
        if (route.paramMap.has('customerID')) {
            customerID = InputConverterService.parseInt(route.paramMap.get('customerID'));
        }
        else if (route.paramMap.has('producerID')) {
            customerID = InputConverterService.parseInt(route.paramMap.get('producerID'));
        }
        return this._customerService.getCustomer(customerID);
    }
}
CustomerResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CustomerResolverService.ctorParameters = () => [
    { type: CustomerService }
];
/** @nocollapse */ CustomerResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CustomerResolverService_Factory() { return new CustomerResolverService(ɵɵinject(CustomerService)); }, token: CustomerResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CustomerResolverService.prototype._customerService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/customers-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomersResolverService {
    /**
     * @param {?} _customerService
     */
    constructor(_customerService) {
        this._customerService = _customerService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        return this._customerService.getAllCustomers();
    }
}
CustomersResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CustomersResolverService.ctorParameters = () => [
    { type: CustomerService }
];
/** @nocollapse */ CustomersResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CustomersResolverService_Factory() { return new CustomersResolverService(ɵɵinject(CustomerService)); }, token: CustomersResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CustomersResolverService.prototype._customerService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/edit-inspection-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IEditInspectionData() { }
if (false) {
    /** @type {?} */
    IEditInspectionData.prototype.Inspection;
    /** @type {?} */
    IEditInspectionData.prototype.InspectionConstants;
    /** @type {?} */
    IEditInspectionData.prototype.Customers;
}
class EditInspectionResolverService {
    /**
     * @param {?} _inspectionService
     * @param {?} _customerService
     */
    constructor(_inspectionService, _customerService) {
        this._inspectionService = _inspectionService;
        this._customerService = _customerService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        /** @type {?} */
        const inspectionID = InputConverterService.parseInt(route.paramMap.get('inspectionID'));
        /** @type {?} */
        let inspection$;
        if (inspectionID != null) {
            inspection$ = this._inspectionService.getInspection(inspectionID).pipe(map((/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                return this._inspectionService.createEditableInspection(inspection);
            })));
        }
        else {
            inspection$ = of(this._inspectionService.createEditableInspection());
        }
        /** @type {?} */
        const inspectionConstants$ = this._inspectionService.getInspectionConstants();
        /** @type {?} */
        const customers$ = this._customerService.getAllCustomers();
        return forkJoin(inspection$, inspectionConstants$, customers$).pipe(map((/**
         * @param {?} value
         * @return {?}
         */
        value => {
            return {
                Inspection: value[0],
                InspectionConstants: value[1],
                Customers: value[2]
            };
        })));
    }
}
EditInspectionResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
EditInspectionResolverService.ctorParameters = () => [
    { type: InspectionService },
    { type: CustomerService }
];
/** @nocollapse */ EditInspectionResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function EditInspectionResolverService_Factory() { return new EditInspectionResolverService(ɵɵinject(InspectionService), ɵɵinject(CustomerService)); }, token: EditInspectionResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    EditInspectionResolverService.prototype._inspectionService;
    /**
     * @type {?}
     * @private
     */
    EditInspectionResolverService.prototype._customerService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/inspection-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InspectionResolverService {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        this._inspectionService = _inspectionService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        /** @type {?} */
        const inspectionID = InputConverterService.parseInt(route.paramMap.get('inspectionID'));
        return this._inspectionService.getInspection(inspectionID);
    }
}
InspectionResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
InspectionResolverService.ctorParameters = () => [
    { type: InspectionService }
];
/** @nocollapse */ InspectionResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InspectionResolverService_Factory() { return new InspectionResolverService(ɵɵinject(InspectionService)); }, token: InspectionResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    InspectionResolverService.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/monthly-scheduled-inspection-list-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MonthlyScheduledInspectionListResolverService {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        this._inspectionService = _inspectionService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        /** @type {?} */
        const year = InputConverterService.parseInt(route.paramMap.get('year'));
        /** @type {?} */
        const month = InputConverterService.parseInt(route.paramMap.get('month'));
        /** @type {?} */
        let keyword = null;
        if (route.queryParamMap.has('keyword')) {
            keyword = route.queryParamMap.get('keyword');
        }
        return this._inspectionService.getScheduledInspectionsListByMonth(year, month, keyword);
    }
}
MonthlyScheduledInspectionListResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MonthlyScheduledInspectionListResolverService.ctorParameters = () => [
    { type: InspectionService }
];
/** @nocollapse */ MonthlyScheduledInspectionListResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MonthlyScheduledInspectionListResolverService_Factory() { return new MonthlyScheduledInspectionListResolverService(ɵɵinject(InspectionService)); }, token: MonthlyScheduledInspectionListResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    MonthlyScheduledInspectionListResolverService.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/route-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RouteResolverService {
    /**
     * @param {?} _routeService
     */
    constructor(_routeService) {
        this._routeService = _routeService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        /** @type {?} */
        const routeID = InputConverterService.parseInt(route.paramMap.get('routeID'));
        return this._routeService.getRoute(routeID);
    }
}
RouteResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RouteResolverService.ctorParameters = () => [
    { type: RouteService }
];
/** @nocollapse */ RouteResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RouteResolverService_Factory() { return new RouteResolverService(ɵɵinject(RouteService)); }, token: RouteResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RouteResolverService.prototype._routeService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/route-tree.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RouteTreeService {
    /**
     * @param {?} _http
     * @param {?} _appConfig
     */
    constructor(_http, _appConfig) {
        this._http = _http;
        this._appConfig = _appConfig;
        this._selectedCustomerIDSource = new BehaviorSubject(null);
        this._selectedCustomerID$ = this._selectedCustomerIDSource.asObservable();
        this._selectedRouteIDSource = new BehaviorSubject(null);
        this._selectedRouteID$ = this._selectedRouteIDSource.asObservable();
        this._selectedWellIDSource = new BehaviorSubject(null);
        this._selectedWellID$ = this._selectedWellIDSource.asObservable();
        this._routesTreeCache = new Map();
    }
    /**
     * @param {?} customerID
     * @return {?}
     */
    getTree(customerID) {
        if (!this._routesTreeCache.has(customerID)) {
            /** @type {?} */
            const routesRequest = this.requestTree(customerID);
            this._routesTreeCache.set(customerID, routesRequest);
            routesRequest.subscribe({
                error: (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    this._routesTreeCache.delete(customerID);
                })
            });
        }
        return this._routesTreeCache.get(customerID);
    }
    /**
     * @param {?} customerID
     * @param {?} routeID
     * @return {?}
     */
    getTreeAll(customerID, routeID) {
        if (!this._routesTreeCache.has(customerID)) {
            /** @type {?} */
            const routesRequest = this.requestTreeGen(customerID, routeID);
            this._routesTreeCache.set(customerID, routesRequest);
            routesRequest.subscribe({
                error: (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    this._routesTreeCache.delete(customerID);
                })
            });
        }
        return this._routesTreeCache.get(customerID);
    }
    /**
     * @private
     * @param {?} customerID
     * @return {?}
     */
    requestTree(customerID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/routes/tree`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @private
     * @param {?} customerID
     * @param {?} routeID
     * @return {?}
     */
    requestTreeGen(customerID, routeID) {
        /** @type {?} */
        const requestUrl = `${this._appConfig.apiBaseUrl}/customer/${customerID}/routes/${routeID}/tree`;
        return this._http.get(requestUrl).pipe(shareReplay(1));
    }
    /**
     * @param {?} customerID
     * @param {?} routeID
     * @return {?}
     */
    getWells(customerID, routeID) {
        return this.getTree(customerID).pipe(map((/**
         * @param {?} routes
         * @return {?}
         */
        (routes) => {
            /** @type {?} */
            const wells = [];
            for (const route of routes) {
                if (route.RouteID === routeID) {
                    wells.concat(route.Wells);
                    break;
                }
            }
            return wells;
        })));
    }
    /**
     * @param {?} customerID
     * @param {?} wellID
     * @return {?}
     */
    getWell(customerID, wellID) {
        return this.getTree(customerID).pipe(map((/**
         * @param {?} routes
         * @return {?}
         */
        (routes) => {
            /** @type {?} */
            let matchingWell = null;
            for (const route of routes) {
                for (const well of route.Wells) {
                    if (well.WellID === wellID) {
                        matchingWell = well;
                    }
                }
            }
            return matchingWell;
        })));
    }
    /**
     * @return {?}
     */
    get selectedCustomerID$() {
        return this._selectedCustomerID$;
    }
    /**
     * @return {?}
     */
    get selectedCustomerID() {
        return this._selectedCustomerIDSource.value;
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    setSelectedCustomerID(wellID) {
        this._selectedCustomerIDSource.next(wellID);
    }
    /**
     * @return {?}
     */
    get selectedRouteID$() {
        return this._selectedRouteID$;
    }
    /**
     * @return {?}
     */
    get selectedRouteID() {
        return this._selectedRouteIDSource.value;
    }
    /**
     * @param {?} routeID
     * @return {?}
     */
    setSelectedRouteID(routeID) {
        this._selectedRouteIDSource.next(routeID);
    }
    /**
     * @return {?}
     */
    get selectedWellID$() {
        return this._selectedWellID$;
    }
    /**
     * @return {?}
     */
    get selectedWellID() {
        return this._selectedWellIDSource.value;
    }
    /**
     * @param {?} wellID
     * @return {?}
     */
    setSelectedWellID(wellID) {
        this._selectedWellIDSource.next(wellID);
    }
}
RouteTreeService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RouteTreeService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
/** @nocollapse */ RouteTreeService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RouteTreeService_Factory() { return new RouteTreeService(ɵɵinject(HttpClient), ɵɵinject(APP_CONFIG)); }, token: RouteTreeService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._selectedCustomerIDSource;
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._selectedCustomerID$;
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._selectedRouteIDSource;
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._selectedRouteID$;
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._selectedWellIDSource;
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._selectedWellID$;
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._routesTreeCache;
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._http;
    /**
     * @type {?}
     * @private
     */
    RouteTreeService.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/states-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StatesResolverService {
    /**
     * @param {?} _constantsService
     */
    constructor(_constantsService) {
        this._constantsService = _constantsService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        return this._constantsService.getStates();
    }
}
StatesResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
StatesResolverService.ctorParameters = () => [
    { type: ConstantsService }
];
/** @nocollapse */ StatesResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StatesResolverService_Factory() { return new StatesResolverService(ɵɵinject(ConstantsService)); }, token: StatesResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    StatesResolverService.prototype._constantsService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/well-resolver.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WellResolverService {
    /**
     * @param {?} _wellService
     */
    constructor(_wellService) {
        this._wellService = _wellService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        /** @type {?} */
        const wellID = InputConverterService.parseInt(route.paramMap.get('wellID'));
        return this._wellService.getWell(wellID);
    }
}
WellResolverService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
WellResolverService.ctorParameters = () => [
    { type: WellService }
];
/** @nocollapse */ WellResolverService.ngInjectableDef = ɵɵdefineInjectable({ factory: function WellResolverService_Factory() { return new WellResolverService(ɵɵinject(WellService)); }, token: WellResolverService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    WellResolverService.prototype._wellService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/autocomplete/autocomplete.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AutocompleteComponent {
    /**
     * @param {?} _wellService
     * @param {?} _appConfig
     */
    constructor(_wellService, _appConfig) {
        this._wellService = _wellService;
        this._appConfig = _appConfig;
        this.keyword = 'Name';
        this.itemName = new EventEmitter();
        this.page = 1;
        this.pageSize = this._appConfig.pageSize;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} item
     * @return {?}
     */
    selectEvent(item) {
        this.itemName.emit(item.Name);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    onChangeSearch(val) {
        /** @type {?} */
        let request;
        request = this._wellService.getWellsList(val, 1, 300);
        this._refreshWellsSub = request.subscribe({
            next: (/**
             * @param {?} pageData
             * @return {?}
             */
            pageData => {
                this.page = pageData.Page;
                this.pageSize = pageData.PageSize;
                this.data = pageData.Items;
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
            })
        });
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onFocused(e) {
        // do something when input is focused
    }
}
AutocompleteComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-autocomplete',
                template: "<div class=\"ng-autocomplete\">\r\n    <ng-autocomplete id=\"search_auto\" [data]=\"data\" [searchKeyword]=\"keyword\" (selected)='selectEvent($event)'\r\n                     (inputChanged)='onChangeSearch($event)' placeholder=\"Enter Well Name\" (inputFocused)='onFocused($event)' [itemTemplate]=\"itemTemplate\"\r\n                     [notFoundTemplate]=\"notFoundTemplate\">\r\n    </ng-autocomplete>\r\n\r\n    <ng-template #itemTemplate let-item>\r\n        <a [innerHTML]=\"item.Name\"></a>\r\n    </ng-template>\r\n\r\n    <ng-template #notFoundTemplate let-notFound>\r\n        <div [innerHTML]=\"notFound\"></div>\r\n    </ng-template>\r\n</div>\n",
                styles: [".ng-autocomplete ::ng-deep .autocomplete-container{width:390px;margin-left:10px}"]
            }] }
];
/** @nocollapse */
AutocompleteComponent.ctorParameters = () => [
    { type: WellService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
AutocompleteComponent.propDecorators = {
    wells: [{ type: Input }],
    itemName: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    AutocompleteComponent.prototype.keyword;
    /** @type {?} */
    AutocompleteComponent.prototype.wells;
    /** @type {?} */
    AutocompleteComponent.prototype.page;
    /** @type {?} */
    AutocompleteComponent.prototype.pageSize;
    /**
     * @type {?}
     * @private
     */
    AutocompleteComponent.prototype._refreshWellsSub;
    /** @type {?} */
    AutocompleteComponent.prototype.itemName;
    /** @type {?} */
    AutocompleteComponent.prototype.data;
    /**
     * @type {?}
     * @private
     */
    AutocompleteComponent.prototype._wellService;
    /**
     * @type {?}
     * @private
     */
    AutocompleteComponent.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/autocomplete-inspection/autocomplete-inspection.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AutocompleteInspectionComponent {
    /**
     * @param {?} _wellService
     * @param {?} _appConfig
     */
    constructor(_wellService, _appConfig) {
        this._wellService = _wellService;
        this._appConfig = _appConfig;
        this.keyword = 'Name';
        this.itemName = new EventEmitter();
        this.page = 1;
        this.pageSize = this._appConfig.pageSize;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} item
     * @return {?}
     */
    selectEvent(item) {
        this.itemName.emit(item.WellID);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    onChangeSearch(val) {
        /** @type {?} */
        let request;
        request = this._wellService.getWellsList(val, 1, 300);
        this._refreshWellsSub = request.subscribe({
            next: (/**
             * @param {?} pageData
             * @return {?}
             */
            pageData => {
                this.page = pageData.Page;
                this.pageSize = pageData.PageSize;
                this.data = pageData.Items;
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
            })
        });
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onFocused(e) {
        // do something when input is focused
    }
}
AutocompleteInspectionComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-autocomplete-inspection',
                template: "<div class=\"ng-autocomplete\">\r\n    <ng-autocomplete id=\"search_auto\" [data]=\"data\" [searchKeyword]=\"keyword\" (selected)='selectEvent($event)'\r\n                     (inputChanged)='onChangeSearch($event)' placeholder=\"Enter Location Name\" (inputFocused)='onFocused($event)' [itemTemplate]=\"itemTemplate\"\r\n                     [notFoundTemplate]=\"notFoundTemplate\">\r\n    </ng-autocomplete>\r\n\r\n    <ng-template #itemTemplate let-item>\r\n        <a [innerHTML]=\"item.Name\"></a>\r\n    </ng-template>\r\n\r\n    <ng-template #notFoundTemplate let-notFound>\r\n        <div [innerHTML]=\"notFound\"></div>\r\n    </ng-template>\r\n</div>\n",
                styles: [".ng-autocomplete ::ng-deep .autocomplete-container{width:100%!important;margin-left:0}.ng-autocomplete{height:36px;width:100%!important}.mm-mew_class .ng-autocomplete input{width:100%!important;height:100%}"]
            }] }
];
/** @nocollapse */
AutocompleteInspectionComponent.ctorParameters = () => [
    { type: WellService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
AutocompleteInspectionComponent.propDecorators = {
    wells: [{ type: Input }],
    itemName: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    AutocompleteInspectionComponent.prototype.keyword;
    /** @type {?} */
    AutocompleteInspectionComponent.prototype.wells;
    /** @type {?} */
    AutocompleteInspectionComponent.prototype.page;
    /** @type {?} */
    AutocompleteInspectionComponent.prototype.pageSize;
    /**
     * @type {?}
     * @private
     */
    AutocompleteInspectionComponent.prototype._refreshWellsSub;
    /** @type {?} */
    AutocompleteInspectionComponent.prototype.itemName;
    /** @type {?} */
    AutocompleteInspectionComponent.prototype.data;
    /**
     * @type {?}
     * @private
     */
    AutocompleteInspectionComponent.prototype._wellService;
    /**
     * @type {?}
     * @private
     */
    AutocompleteInspectionComponent.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/autocomplete-vessel/autocomplete-vessel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AutocompleteVesselComponent {
    /**
     * @param {?} _inspectionService
     * @param {?} _appConfig
     */
    constructor(_inspectionService, _appConfig) {
        this._inspectionService = _inspectionService;
        this._appConfig = _appConfig;
        this.keyword = 'VesselID';
        this.itemName = new EventEmitter();
        this.page = 1;
        this.pageSize = this._appConfig.pageSize;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} item
     * @return {?}
     */
    selectEvent(item) {
        this.itemName.emit(item.VesselID);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    onChangeSearch(val) {
        /** @type {?} */
        let request;
        if (val != null && val != "") {
            request = this._inspectionService.getInspectionsList(val, 1, 200);
            this._refreshInspectionsSub = request.subscribe({
                next: (/**
                 * @param {?} pageData
                 * @return {?}
                 */
                pageData => {
                    this.page = pageData.Page;
                    this.pageSize = pageData.PageSize;
                    this.data = pageData.Items;
                }),
                error: (/**
                 * @param {?} error
                 * @return {?}
                 */
                (error) => {
                    //alert(error.Message);
                })
            });
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onFocused(e) {
        // do something when input is focused
    }
}
AutocompleteVesselComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-autocomplete-vessel',
                template: "<div class=\"ng-autocomplete\">\r\n    <ng-autocomplete id=\"search_auto\" [data]=\"data\" [searchKeyword]=\"keyword\" (selected)='selectEvent($event)'\r\n                     (inputChanged)='onChangeSearch($event)' placeholder=\"Enter Vessel ID\" (inputFocused)='onFocused($event)' [itemTemplate]=\"itemTemplate\"\r\n                     [notFoundTemplate]=\"notFoundTemplate\">\r\n    </ng-autocomplete>\r\n\r\n    <ng-template #itemTemplate let-item>\r\n        <a [innerHTML]=\"item.VesselID\"></a>\r\n    </ng-template>\r\n\r\n    <ng-template #notFoundTemplate let-notFound>\r\n        <div [innerHTML]=\"notFound\"></div>\r\n    </ng-template>\r\n</div>\n",
                styles: [".ng-autocomplete ::ng-deep .autocomplete-container{width:390px;margin-left:10px}"]
            }] }
];
/** @nocollapse */
AutocompleteVesselComponent.ctorParameters = () => [
    { type: InspectionService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
AutocompleteVesselComponent.propDecorators = {
    vessels: [{ type: Input }],
    itemName: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    AutocompleteVesselComponent.prototype.keyword;
    /** @type {?} */
    AutocompleteVesselComponent.prototype.vessels;
    /** @type {?} */
    AutocompleteVesselComponent.prototype.page;
    /** @type {?} */
    AutocompleteVesselComponent.prototype.pageSize;
    /**
     * @type {?}
     * @private
     */
    AutocompleteVesselComponent.prototype._refreshInspectionsSub;
    /** @type {?} */
    AutocompleteVesselComponent.prototype.itemName;
    /** @type {?} */
    AutocompleteVesselComponent.prototype.data;
    /**
     * @type {?}
     * @private
     */
    AutocompleteVesselComponent.prototype._inspectionService;
    /**
     * @type {?}
     * @private
     */
    AutocompleteVesselComponent.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/delete-scheduled-inspection-button/delete-scheduled-inspection-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DeleteScheduledInspectionButtonComponent extends ActionButton {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        super();
        this._inspectionService = _inspectionService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @protected
     * @return {?}
     */
    get canExecute() {
        return this.inspection !== null;
    }
    /**
     * @protected
     * @return {?}
     */
    confirmExecute() {
        /** @type {?} */
        const confirmDelete = confirm('Delete inspection?');
        return confirmDelete;
    }
    /**
     * @protected
     * @return {?}
     */
    execute() {
        return this._inspectionService.deleteInspection(this.inspection.InspectionID).pipe(map((/**
         * @return {?}
         */
        () => {
            return this.inspection;
        })), catchError((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            /** @type {?} */
            const errorMsg = `Failed to delete inspection for well ${this.inspection.WellName}: ${error.Message}`;
            error = {
                Message: errorMsg
            };
            return throwError(error);
        })));
    }
}
DeleteScheduledInspectionButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-delete-scheduled-inspection-button',
                template: "<i [hidden]=\"isExecuting\" class=\"fa fa-times-circle fa-lg text-danger delete-scheduled-inspection-button\" \n    title=\"Delete Inspection\" role=\"button\"\n    (click)=\"onExecute()\">\n</i>\n<eec-spinner [hidden]=\"!isExecuting\" small=\"true\"></eec-spinner>\n",
                styles: [".delete-scheduled-inspection-button{cursor:pointer}"]
            }] }
];
/** @nocollapse */
DeleteScheduledInspectionButtonComponent.ctorParameters = () => [
    { type: InspectionService }
];
DeleteScheduledInspectionButtonComponent.propDecorators = {
    inspection: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    DeleteScheduledInspectionButtonComponent.prototype.inspection;
    /**
     * @type {?}
     * @private
     */
    DeleteScheduledInspectionButtonComponent.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/download-file-trigger/download-file-trigger.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DownloadFileTriggerComponent {
    constructor() {
        this.downloaded = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.downloadLink.nativeElement.click();
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.downloaded.emit();
        }));
    }
}
DownloadFileTriggerComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-download-file-trigger',
                template: "<a #downloadLink hidden=\"true\" aria-hidden=\"true\" [href]=\"fileObjectUrl\" [download]=\"fileName\"></a>",
                styles: [""]
            }] }
];
/** @nocollapse */
DownloadFileTriggerComponent.ctorParameters = () => [];
DownloadFileTriggerComponent.propDecorators = {
    fileObjectUrl: [{ type: Input }],
    fileName: [{ type: Input }],
    downloaded: [{ type: Output }],
    downloadLink: [{ type: ViewChild, args: ['downloadLink', { static: false },] }]
};
if (false) {
    /** @type {?} */
    DownloadFileTriggerComponent.prototype.fileObjectUrl;
    /** @type {?} */
    DownloadFileTriggerComponent.prototype.fileName;
    /** @type {?} */
    DownloadFileTriggerComponent.prototype.downloaded;
    /** @type {?} */
    DownloadFileTriggerComponent.prototype.downloadLink;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/view-file-trigger/view-file-trigger.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewFileTriggerComponent {
    constructor() {
        this.viewed = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.viewLink.nativeElement.click();
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.viewed.emit();
        }));
    }
}
ViewFileTriggerComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-view-file-trigger',
                template: "<a #viewLink hidden=\"true\" aria-hidden=\"true\" [href]=\"fileObjectUrl\" target=\"_blank\"></a>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ViewFileTriggerComponent.ctorParameters = () => [];
ViewFileTriggerComponent.propDecorators = {
    fileObjectUrl: [{ type: Input }],
    viewed: [{ type: Output }],
    viewLink: [{ type: ViewChild, args: ['viewLink', { static: false },] }]
};
if (false) {
    /** @type {?} */
    ViewFileTriggerComponent.prototype.fileObjectUrl;
    /** @type {?} */
    ViewFileTriggerComponent.prototype.viewed;
    /** @type {?} */
    ViewFileTriggerComponent.prototype.viewLink;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/edit-asset-image/edit-asset-image.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EditAssetImageComponent {
    constructor() {
        this.remove = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    onRemoveAsset() {
        this.remove.emit();
    }
}
EditAssetImageComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-edit-asset-image',
                template: "<eec-asset-img [asset]=\"asset\"></eec-asset-img>\n<i [hidden]=\"!asset\"\n    role=\"button\"\n    class=\"fa fa-times-circle fa-lg text-danger align-top remove-asset-btn mx-1\"\n    (click)=\"onRemoveAsset()\"></i>\n",
                styles: [".remove-asset-btn{cursor:pointer}"]
            }] }
];
/** @nocollapse */
EditAssetImageComponent.ctorParameters = () => [];
EditAssetImageComponent.propDecorators = {
    asset: [{ type: Input }],
    remove: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    EditAssetImageComponent.prototype.asset;
    /** @type {?} */
    EditAssetImageComponent.prototype.remove;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/well-overview-panel/well-overview-panel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WellOverviewPanelComponent {
    constructor() {
        this.pageChanged = new EventEmitter();
        this.activeIds = [];
        this.onInspectionsChanged = (/**
         * @param {?} page
         * @return {?}
         */
        (page) => {
            this.page = page.Page;
            this.pageSize = page.PageSize;
            this.pageCount = page.PageCount;
            this.totalInspectionCount = page.TotalItemCount;
            /** @type {?} */
            const inspections = page.Items;
            this.inspections = inspections;
            this.anodes = inspections.map((/**
             * @param {?} inspection
             * @return {?}
             */
            (inspection) => {
                /** @type {?} */
                let anode = inspection.Anode;
                if (anode == null) {
                    anode = {
                        AnodeID: null,
                        AnodeReading: null,
                        AnodeReadingType: null,
                        AnodeReadingTypeDescription: null,
                        AnodeType: null,
                        AnodeTypeDescription: null,
                        Condition: null,
                        ConditionDescription: null,
                        InspectionDate: inspection.InspectionDate,
                        InspectionID: inspection.InspectionID
                    };
                }
                return anode;
            }));
            this.fieldNotes = inspections.map((/**
             * @param {?} inspection
             * @return {?}
             */
            (inspection) => {
                /** @type {?} */
                let fieldNote = inspection.FieldNote;
                if (fieldNote == null) {
                    fieldNote = {
                        AssetID: null,
                        FieldNoteID: null,
                        InspectionDate: inspection.InspectionDate,
                        InspectionID: inspection.InspectionID,
                        Note: null
                    };
                }
                return fieldNote;
            }));
        });
        this._dataPanelState = {};
        this.activeIds = ['fireTubeDataPanel', 'anodeDataPanel', 'otherDataPanel'];
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.inspectionPage == null) {
            return;
        }
        /** @type {?} */
        const inspectionPage = changes.inspectionPage.currentValue;
        if (inspectionPage === changes.inspectionPage.previousValue) {
            return;
        }
        if (inspectionPage == null) {
            this.reset();
            return;
        }
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        this.onInspectionsChanged(changes.inspectionPage.currentValue);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        let main = document.querySelector("#main_content");
        main.classList.add("col-lg-9");
        main.classList.remove("col-lg-12");
    }
    /**
     * @private
     * @return {?}
     */
    reset() {
        this.inspections = [];
        this.anodes = [];
        this.fieldNotes = [];
        this.page = 0;
        this.pageCount = 0;
        this.pageSize = 0;
        this.totalInspectionCount = 0;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    dataPanelChanged(event) {
        this._dataPanelState[event.panelId] = event.nextState;
    }
    /**
     * @return {?}
     */
    get fireTubeDataExpanded() {
        return this._dataPanelState.fireTubeDataPanel;
    }
    /**
     * @return {?}
     */
    get anodeDataExpanded() {
        return this._dataPanelState.anodeDataPanel;
    }
    /**
     * @return {?}
     */
    get otherDataExpanded() {
        return this._dataPanelState.otherDataPanel;
    }
    /**
     * @param {?} page
     * @return {?}
     */
    onPageChanged(page) {
        this.pageChanged.emit(page);
    }
}
WellOverviewPanelComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-well-overview-panel',
                template: "<div class=\"row pb-4\">\n    <div class=\"col\">\n        <h2>\n            <eec-spinner [hidden]=\"!loading\" class=\"text-primary m-1\"></eec-spinner>\n            {{well?.Name}}\n        </h2>\n        <h4 class=\"text-secondary\">Data Overview</h4>\n    </div>\n</div>\n\n<ngb-accordion (panelChange)=\"dataPanelChanged($event)\" [activeIds]=\"activeIds\">\n    <ngb-panel id=\"fireTubeDataPanel\" type=\"dark\">\n        <ng-template ngbPanelHeader>\n            <div class=\"text-white\">\n                <button ngbPanelToggle class=\"btn btn-link text-white text-left w-100\">\n                    Fire Tube Data\n                    <span class=\"float-right text-white\">\n                        <i class=\"fa fa-lg\" [ngClass]=\"fireTubeDataExpanded ? 'fa-chevron-down' : 'fa-chevron-right'\"></i>\n                    </span>\n                </button>\n            </div>\n        </ng-template>\n        <ng-template ngbPanelContent>\n            <eec-inspection-table \n                [inspections]=\"inspections\"\n                [showCustomer]=\"false\"\n                [showWell]=\"false\"\n                [showRoute]=\"false\">\n            </eec-inspection-table>\n        </ng-template>\n    </ngb-panel>\n    <ngb-panel id=\"anodeDataPanel\" type=\"dark\">\n        <ng-template ngbPanelHeader>\n            <button ngbPanelToggle class=\"btn btn-link text-white text-left w-100\">\n                Anode Data\n                <span class=\"float-right text-white\">\n                    <i class=\"fa fa-lg\" [ngClass]=\"anodeDataExpanded ? 'fa-chevron-down' : 'fa-chevron-right'\"></i>\n                </span>\n            </button>\n        </ng-template>\n        <ng-template ngbPanelContent>\n            <eec-anodes-table [anodes]=\"anodes\"></eec-anodes-table>\n        </ng-template>\n    </ngb-panel>\n    <ngb-panel id=\"otherDataPanel\" type=\"dark\">\n        <ng-template ngbPanelHeader>\n            <button ngbPanelToggle class=\"btn btn-link text-white text-left w-100\">\n                Other Data\n                <span class=\"float-right text-white\">\n                    <i class=\"fa fa-lg\" [ngClass]=\"otherDataExpanded ? 'fa-chevron-down' : 'fa-chevron-right'\"></i>\n                </span>\n            </button>\n        </ng-template>\n        <ng-template ngbPanelContent>\n            <eec-field-notes-list [fieldNotes]=\"fieldNotes\"></eec-field-notes-list>\n        </ng-template>\n    </ngb-panel>\n</ngb-accordion>\n\n<ngb-pagination\n    *ngIf=\"pageCount > 1\"\n    class=\"d-flex justify-content-center mt-3\"\n    [page]=\"page\"\n    [pageSize]=\"pageSize\"\n    [collectionSize]=\"totalInspectionCount\"\n    (pageChange)=\"onPageChanged($event)\">\n</ngb-pagination>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
WellOverviewPanelComponent.ctorParameters = () => [];
WellOverviewPanelComponent.propDecorators = {
    well: [{ type: Input }],
    loading: [{ type: Input }],
    inspectionPage: [{ type: Input }],
    pageChanged: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    WellOverviewPanelComponent.prototype.well;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.loading;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.inspectionPage;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.pageChanged;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.inspections;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.anodes;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.fieldNotes;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.page;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.pageCount;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.pageSize;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.totalInspectionCount;
    /** @type {?} */
    WellOverviewPanelComponent.prototype.activeIds;
    /**
     * @type {?}
     * @private
     */
    WellOverviewPanelComponent.prototype._dataPanelState;
    /**
     * @type {?}
     * @private
     */
    WellOverviewPanelComponent.prototype.onInspectionsChanged;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/anodes-table/anodes-table.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnodesTableComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        let main = document.querySelector("#main_content");
        main.classList.add("col-lg-9");
        main.classList.remove("col-lg-12");
    }
    /**
     * @param {?} anode
     * @return {?}
     */
    getTrackByID(anode) {
        return anode.AnodeID;
    }
}
AnodesTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-anodes-table',
                template: "<table class=\"table table-striped\">\n    <thead>\n        <tr>\n            <th>Anode Type</th>\n            <th>Test Date</th>\n            <th>Test Result</th>\n            <th>Color</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr *ngFor=\"let anode of anodes; trackBy: getTrackByID\">\n            <td>\n                <span>{{anode.AnodeTypeDescription | notany}}</span>\n            </td>\n            <td>\n                <span>{{anode.InspectionDate | date:'MM/dd/yy'}}</span>\n            </td>\n            <td>\n                <span>{{anode.AnodeReading | units:anode.AnodeReadingTypeDescription | notany}}</span>\n            </td>\n            <td>\n                <eec-condition-text [condition]=\"anode.Condition\" [description]=\"anode.ConditionDescription\"></eec-condition-text>\n            </td>\n        </tr>\n    </tbody>\n</table>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
AnodesTableComponent.ctorParameters = () => [];
AnodesTableComponent.propDecorators = {
    anodes: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    AnodesTableComponent.prototype.anodes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/field-notes-list/field-notes-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FieldNotesListComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        let main = document.querySelector("#main_content");
        main.classList.add("col-lg-9");
        main.classList.remove("col-lg-12");
    }
    /**
     * @param {?} fieldNote
     * @return {?}
     */
    getTrackByID(fieldNote) {
        return fieldNote.FieldNoteID;
    }
}
FieldNotesListComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-field-notes-list',
                template: "<div class=\"row mb-2\" *ngFor=\"let fieldNote of fieldNotes; trackBy: getTrackByID\">\n    <div *ngIf=\"fieldNote.AssetID\" class=\"col-auto\">\n        <eec-asset-img [asset]=\"fieldNote.AssetID\"></eec-asset-img>\n    </div>\n    <div class=\"col\">\n        <div class=\"h6 text-primary\">{{fieldNote.InspectionDate | date:'MM/dd/yy'}}</div>  \n        <p>{{fieldNote.Note | notany}}</p>\n    </div>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
FieldNotesListComponent.ctorParameters = () => [];
FieldNotesListComponent.propDecorators = {
    fieldNotes: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    FieldNotesListComponent.prototype.fieldNotes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/inspection-search/inspection-search.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFormData$6() { }
if (false) {
    /** @type {?} */
    IFormData$6.prototype.NumDays;
    /** @type {?} */
    IFormData$6.prototype.Keyword;
    /** @type {?} */
    IFormData$6.prototype.SearchTerm;
}
class InspectionSearchComponent {
    /**
     * @param {?} _inspectionService
     * @param {?} _wellService
     * @param {?} _formBuilder
     * @param {?} route
     * @param {?} _appConfig
     */
    constructor(_inspectionService, _wellService, _formBuilder, route, _appConfig) {
        this._inspectionService = _inspectionService;
        this._wellService = _wellService;
        this._formBuilder = _formBuilder;
        this.route = route;
        this._appConfig = _appConfig;
        this.searchChanged = new EventEmitter();
        this.pageChanged = new EventEmitter();
        this.inspectionSearchExportFileName = DEFAULT_WELL_SEARCH_REPORT_NAME;
        this._currentSearchParams = { Keyword: '', NumDays: null, VesselID: '' };
    }
    /**
     * @return {?}
     */
    get hasNumDays() {
        if (this.searchForm == null) {
            return false;
        }
        /** @type {?} */
        const numDays = InputConverterService.parseInt(this.searchForm.controls.NumDays.value);
        return numDays >= 1;
    }
    /**
     * @return {?}
     */
    get hasKeyword() {
        if (this.searchForm == null) {
            return false;
        }
        /** @type {?} */
        const keyword = InputConverterService.trim(this.searchForm.controls.Keyword.value);
        return !InputConverterService.isEmpty(keyword);
    }
    /**
     * @return {?}
     */
    get hasVesselID() {
        if (this.searchForm == null) {
            return false;
        }
        /** @type {?} */
        const vesselID = InputConverterService.trim(this.searchForm.controls.SearchTerm.value);
        return !InputConverterService.isEmpty(vesselID);
    }
    /**
     * @return {?}
     */
    get searchForm() {
        return this._searchForm;
    }
    /**
     * @return {?}
     */
    get currentSearchParams() {
        return this._currentSearchParams;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._searchForm = this._formBuilder.group({
            NumDays: ['', [Validators.min(1), Validators.required]],
            Keyword: [''],
            SearchTerm: ['']
        });
        this.route.queryParams
            .subscribe((/**
         * @param {?} params
         * @return {?}
         */
        params => {
            this.paramKeyword = params.keyword;
        }));
        /** @type {?} */
        const pageChanged = true;
        this.updateFormFromInputParams();
        /** @type {?} */
        const searchParams = this.getSearchParamsFromForm();
        this.refresh(searchParams, pageChanged);
        /** @type {?} */
        const urlParams = new URLSearchParams(window.location.search);
        /** @type {?} */
        const myParam = urlParams.get('keyword');
        if (myParam != null && myParam != '') {
            searchParams.Keyword = myParam;
            searchParams.NumDays = 10000;
            //alert(searchParams.Keyword);
            this.refresh(searchParams, pageChanged);
            //this.searchChanged.emit(searchParams);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.cancelRefreshInspections();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (this.searchForm == null) {
            return;
        }
        /** @type {?} */
        const pageChanged = changes.page != null && changes.page.currentValue !== changes.page.previousValue;
        this.updateFormFromInputParams();
        /** @type {?} */
        const searchParams = this.getSearchParamsFromForm();
        this.refresh(searchParams, pageChanged);
    }
    /**
     * @private
     * @return {?}
     */
    updateFormFromInputParams() {
        if (this.searchForm == null) {
            return;
        }
        /** @type {?} */
        const formData = {
            NumDays: InputConverterService.numberToString(this.numDays) || DEFAULT_INSPECTION_SEARCH_DAYS_BEFORE.toString(),
            Keyword: InputConverterService.trim(this.keyword) || '',
            SearchTerm: InputConverterService.trim(this.vessel) || ''
        };
        this.searchForm.setValue(formData);
    }
    /**
     * @private
     * @param {?} searchParams
     * @param {?} pageChanged
     * @return {?}
     */
    refresh(searchParams, pageChanged) {
        this.cancelRefreshInspections();
        if (searchParams == null) {
            return;
        }
        /** @type {?} */
        const keywordChanged = this.currentSearchParams.Keyword !== searchParams.Keyword;
        /** @type {?} */
        const numDaysChanged = this.currentSearchParams.NumDays !== searchParams.NumDays;
        /** @type {?} */
        const vesselChanged = this.currentSearchParams.VesselID !== searchParams.VesselID;
        /** @type {?} */
        const refreshInspections = keywordChanged || numDaysChanged || pageChanged || vesselChanged;
        this.searching = refreshInspections;
        this.successMsg = '';
        this.errorMsg = '';
        // if anything changed that will affect the number of pages, then reset the inspection page
        if (keywordChanged || numDaysChanged || vesselChanged) {
            this.resetInspectionsPage();
        }
        this._inspectionsSub = this.requestWell(searchParams.Keyword, keywordChanged).pipe(mergeMap((/**
         * @param {?} well
         * @return {?}
         */
        well => {
            //alert(searchParams.Keyword + ': refresh ');
            this.well = well;
            if (this.hasVesselID) {
                return this.requestInspections(well, searchParams.VesselID, searchParams.NumDays, refreshInspections);
            }
            else {
                return this.requestInspections(well, 'NA', searchParams.NumDays, refreshInspections);
            }
        }))).subscribe({
            next: (/**
             * @param {?} page
             * @return {?}
             */
            page => {
                // since we successfully requested the latest inspections, set the current search params
                //	this._currentSearchParams = searchParams;
                this.inspectionPage = page;
                this.searching = false;
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                this.errorMsg = error.Message;
                this.searching = false;
            })
        });
    }
    /**
     * @private
     * @param {?} well
     * @param {?} vesselID
     * @param {?} numDays
     * @param {?} refreshInspections
     * @return {?}
     */
    requestInspections(well, vesselID, numDays, refreshInspections) {
        // if the keyword changed, the page changed, or the number of days changed, then refresh the inspections
        if (well != null && refreshInspections) {
            return this._inspectionService.getWellInspections(well.WellID, vesselID, this.page, this._appConfig.pageSize, numDays);
        }
        else {
            // inspections haven't changed: just return the current page
            /** @type {?} */
            const inspectionSubject = new ReplaySubject(1);
            inspectionSubject.next(this.inspectionPage);
            inspectionSubject.complete();
            return inspectionSubject.asObservable();
        }
    }
    /**
     * @private
     * @param {?} keyword
     * @param {?} keywordChanged
     * @return {?}
     */
    requestWell(keyword, keywordChanged) {
        // search for a new well if the keyword changed and is not empty
        /** @type {?} */
        const keywordEmpty = InputConverterService.isEmpty(keyword);
        if (keywordChanged && !keywordEmpty) {
            return this._wellService.findWell(keyword);
        }
        else {
            // keep the same well if the keyword has not changed
            // otherwise if the keyword is empty, then discard the well
            /** @type {?} */
            const wellSubject = new ReplaySubject(1);
            wellSubject.next(!keywordEmpty ? this.well : null);
            wellSubject.complete();
            return wellSubject.asObservable();
        }
    }
    /**
     * @private
     * @return {?}
     */
    resetInspectionsPage() {
        this.inspectionPage = {
            Items: [],
            Page: 1,
            PageCount: 0,
            PageSize: this._appConfig.pageSize,
            TotalItemCount: 0
        };
    }
    /**
     * @private
     * @return {?}
     */
    cancelRefreshInspections() {
        if (this._inspectionsSub != null) {
            this._inspectionsSub.unsubscribe();
            this._inspectionsSub = null;
        }
    }
    /**
     * @param {?} error
     * @return {?}
     */
    onInspectionSearchExportFailed(error) {
        this.errorMsg = `Export failed: ${error.Message}`;
    }
    /**
     * @param {?} item
     * @return {?}
     */
    getItemName(item) {
        this.selectedWell = item;
        this.searching = false;
        document.getElementById("btnSearch").focus();
    }
    /**
     * @param {?} item
     * @return {?}
     */
    getVesselId(item) {
        this.selectedVesselID = item;
        this.searching = false;
        document.getElementById("btnSearch").focus();
    }
    /**
     * @return {?}
     */
    onSearch() {
        /** @type {?} */
        const searchParams = this.getSearchParamsFromForm();
        this.searchChanged.emit(searchParams);
    }
    /**
     * @return {?}
     */
    resetSearch() {
        /** @type {?} */
        const formData = {
            NumDays: DEFAULT_INSPECTION_SEARCH_DAYS_BEFORE.toString(),
            Keyword: '',
            SearchTerm: ''
        };
        this.searchForm.reset(formData);
        this.onSearch();
    }
    /**
     * @param {?} page
     * @return {?}
     */
    onPageChanged(page) {
        this.pageChanged.emit(page);
    }
    /**
     * @private
     * @return {?}
     */
    getSearchParamsFromForm() {
        if (this.searchForm == null) {
            return null;
        }
        /** @type {?} */
        const formSearchParams = {
            Keyword: InputConverterService.trim(this.selectedWell),
            NumDays: InputConverterService.parseInt(this.searchForm.controls.NumDays.value),
            VesselID: InputConverterService.trim(this.searchForm.controls.SearchTerm.value)
        };
        return formSearchParams;
    }
}
InspectionSearchComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-inspection-search',
                template: "<h2>\n    Inspection Search\n</h2>\n<eec-page-alerts [errorMsg]=\"errorMsg\" [successMsg]=\"successMsg\"></eec-page-alerts>\n\n<form [formGroup]=\"searchForm\" class=\"form-inline\">\n    <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n            <span class=\"input-group-text\">Last</span>\n        </div>\n        <input class=\"form-control\" formControlName=\"NumDays\" type=\"number\" min=\"1\" aria-label=\"Last number of days\" />\n        <div class=\"input-group-append\">\n            <span class=\"input-group-text\">Days</span>\n        </div>\n    </div>\n    <eec-autocomplete (itemName)=\"getItemName($event)\" style=\"width:410px;\"></eec-autocomplete>\n    <input formControlName=\"Keyword\" type=\"hidden\" class=\"form-control mx-2\" value=\"{{selectedWell}}\"\n           placeholder=\"Enter Well Name\"\n           title=\"Search By Well Name\" />\n    <input formControlName=\"SearchTerm\" type=\"text\" class=\"form-control\" style=\"display:none;\"\n           placeholder=\"Enter Vessel ID\"\n           title=\"Search by Vessel ID\" />\n\n    <button [disabled]=\"searching\" class=\"btn btn-secondary mx-2\" type=\"button\" (click)=\"resetSearch()\">Reset</button>\n    <button id=\"btnSearch\" [disabled]=\"searching\" class=\"btn btn-primary mx-2\" type=\"submit\" (click)=\"onSearch()\">\n        <eec-spinner [hidden]=\"!searching\" small=\"true\" class=\"m-1\"></eec-spinner>\n        Search\n    </button>\n</form>\n\n<div class=\"my-4\">\n    <div class=\"float-right\">\n        <eec-export-well-inspections-button\n            [well]=\"well\"\n            [numDays]=\"numDays\"\n            (inspectionExportFailed)=\"onInspectionSearchExportFailed($event)\">\n        </eec-export-well-inspections-button>\n    </div>\n    \n    <eec-well-overview-panel\n        [well]=\"well\" \n        [inspectionPage]=\"inspectionPage\"\n        [loading]=\"searching\"\n        (pageChanged)=\"onPageChanged($event)\">\n    </eec-well-overview-panel>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
InspectionSearchComponent.ctorParameters = () => [
    { type: InspectionService },
    { type: WellService },
    { type: FormBuilder },
    { type: ActivatedRoute },
    { type: undefined, decorators: [{ type: Inject, args: [APP_CONFIG,] }] }
];
InspectionSearchComponent.propDecorators = {
    numDays: [{ type: Input }],
    keyword: [{ type: Input }],
    vessel: [{ type: Input }],
    page: [{ type: Input }],
    searchChanged: [{ type: Output }],
    pageChanged: [{ type: Output }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    InspectionSearchComponent.prototype._inspectionsSub;
    /** @type {?} */
    InspectionSearchComponent.prototype.numDays;
    /** @type {?} */
    InspectionSearchComponent.prototype.keyword;
    /** @type {?} */
    InspectionSearchComponent.prototype.vessel;
    /** @type {?} */
    InspectionSearchComponent.prototype.page;
    /** @type {?} */
    InspectionSearchComponent.prototype.searchChanged;
    /** @type {?} */
    InspectionSearchComponent.prototype.pageChanged;
    /** @type {?} */
    InspectionSearchComponent.prototype.selectedWell;
    /** @type {?} */
    InspectionSearchComponent.prototype.selectedVesselID;
    /** @type {?} */
    InspectionSearchComponent.prototype.searching;
    /** @type {?} */
    InspectionSearchComponent.prototype.well;
    /** @type {?} */
    InspectionSearchComponent.prototype.inspectionPage;
    /** @type {?} */
    InspectionSearchComponent.prototype.inspectionSearchExportFileName;
    /** @type {?} */
    InspectionSearchComponent.prototype.errorMsg;
    /** @type {?} */
    InspectionSearchComponent.prototype.successMsg;
    /** @type {?} */
    InspectionSearchComponent.prototype.paramKeyword;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchComponent.prototype._searchForm;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchComponent.prototype._currentSearchParams;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchComponent.prototype._inspectionService;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchComponent.prototype._wellService;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchComponent.prototype._formBuilder;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    InspectionSearchComponent.prototype._appConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/export-well-inspections-button/export-well-inspections-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ExportWellInspectionsButtonComponent {
    /**
     * @param {?} _exportService
     */
    constructor(_exportService) {
        this._exportService = _exportService;
        this.inspectionExportFailed = new EventEmitter();
        this.requestInspectionExport = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const inspectionReportName = `${this.well.Name} Inspection History`;
            return this._exportService.exportWellInspections(this.well.WellID, this.numDays, inspectionReportName);
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} error
     * @return {?}
     */
    onInspectionExportFailed(error) {
        this.inspectionExportFailed.emit(error);
    }
    /**
     * @return {?}
     */
    get hasWell() {
        return this.well != null;
    }
    /**
     * @return {?}
     */
    get hasNumDays() {
        return this.numDays > 0;
    }
}
ExportWellInspectionsButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-export-well-inspections-button',
                template: "<eec-download-file-button\n    [request]=\"requestInspectionExport\"\n    label=\"Export Inspections\"\n    [disabled]=\"!hasWell\"\n    (downloadFailed)=\"onInspectionExportFailed($event)\">\n</eec-download-file-button>",
                styles: [""]
            }] }
];
/** @nocollapse */
ExportWellInspectionsButtonComponent.ctorParameters = () => [
    { type: ExportService }
];
ExportWellInspectionsButtonComponent.propDecorators = {
    well: [{ type: Input }],
    numDays: [{ type: Input }],
    inspectionExportFailed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ExportWellInspectionsButtonComponent.prototype.well;
    /** @type {?} */
    ExportWellInspectionsButtonComponent.prototype.numDays;
    /** @type {?} */
    ExportWellInspectionsButtonComponent.prototype.inspectionExportFailed;
    /** @type {?} */
    ExportWellInspectionsButtonComponent.prototype.requestInspectionExport;
    /**
     * @type {?}
     * @private
     */
    ExportWellInspectionsButtonComponent.prototype._exportService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/prev-inspection-date.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrevInspectionDatePipe {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        this._inspectionService = _inspectionService;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return this.getPreviousInspectionDate(value);
    }
    /**
     * @param {?} inspectionId
     * @return {?}
     */
    getPreviousInspectionDate(inspectionId) {
        /** @type {?} */
        var prevDate = '';
        //this._inspectionService.getPreviousCompletedInspectionDate(inspectionId).subscribe({
        //	next: inspDate => {
        //		prevDate = inspDate;
        //		console.log(prevDate);
        //		return prevDate;
        //	},
        //	error: (error: IError) => {
        //		console.log("error:", error);
        //	}
        //});
        this._inspectionService.getPreviousCompletedInspectionDate(inspectionId).toPromise().then((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            return response;
        }));
    }
}
PrevInspectionDatePipe.decorators = [
    { type: Pipe, args: [{
                name: 'prevInspectionDate',
                pure: true
            },] }
];
/** @nocollapse */
PrevInspectionDatePipe.ctorParameters = () => [
    { type: InspectionService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    PrevInspectionDatePipe.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/previous-inspection-date/previous-inspection-date.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreviousInspectionDateComponent {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        this._inspectionService = _inspectionService;
        this.prevDate = '';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log('in init');
        this._inspectionService.getPreviousCompletedInspection(this.inspectionID).subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                if (inspection == null) {
                    //this.prevDate = 'NA';
                }
                else {
                    this.prevDate = inspection.InspectionDate;
                }
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                console.log(error);
            })
        });
    }
}
PreviousInspectionDateComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-previous-inspection-date',
                template: "<span>{{prevDate | date: 'M/d/yy'}}</span>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
PreviousInspectionDateComponent.ctorParameters = () => [
    { type: InspectionService }
];
PreviousInspectionDateComponent.propDecorators = {
    inspectionID: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PreviousInspectionDateComponent.prototype.inspectionID;
    /** @type {?} */
    PreviousInspectionDateComponent.prototype.prevDate;
    /**
     * @type {?}
     * @private
     */
    PreviousInspectionDateComponent.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/previous-inspection-hwl/previous-inspection-hwl.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreviousInspectionHWLComponent {
    /**
     * @param {?} _inspection_Service
     */
    constructor(_inspection_Service) {
        this._inspection_Service = _inspection_Service;
        this.prevHWL = '';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.prevHWL = '';
        this._inspection_Service.getPreviousCompletedInspection(this.inspectionID).subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                this.prevHWL = '';
                if (inspection == null) {
                    this.prevHWL = '';
                }
                else {
                    if (inspection.FireTube.HWL != null) {
                        this.prevHWL = inspection.FireTube.HWL;
                    }
                    else {
                        this.prevHWL = 'NA';
                    }
                }
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                console.log(error);
            })
        });
    }
}
PreviousInspectionHWLComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-previous-inspection-hwl',
                template: "<span *ngIf =\"prevHWL != 'NA'\">{{prevHWL | percent}}</span>\n<span *ngIf=\"prevHWL == 'NA'\">N/A</span>\n<span *ngIf=\"prevHWL == ''\"></span>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
PreviousInspectionHWLComponent.ctorParameters = () => [
    { type: InspectionService }
];
PreviousInspectionHWLComponent.propDecorators = {
    inspectionID: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PreviousInspectionHWLComponent.prototype.inspectionID;
    /** @type {?} */
    PreviousInspectionHWLComponent.prototype.prevHWL;
    /**
     * @type {?}
     * @private
     */
    PreviousInspectionHWLComponent.prototype._inspection_Service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/recent-inspection-date/recent-inspection-date.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RecentInspectionDateComponent {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        this._inspectionService = _inspectionService;
        this.recentDate = '';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._inspectionService.getRecentInspectionForWell(this.wellID).subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                if (inspection == null) {
                    this.recentDate = 'NA';
                }
                else {
                    this.recentDate = inspection.InspectionDate;
                }
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                console.log(error);
            })
        });
    }
}
RecentInspectionDateComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-recent-inspection-date',
                template: "<span>{{recentDate | date: 'M/d/yy'}}</span>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
RecentInspectionDateComponent.ctorParameters = () => [
    { type: InspectionService }
];
RecentInspectionDateComponent.propDecorators = {
    wellID: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    RecentInspectionDateComponent.prototype.wellID;
    /** @type {?} */
    RecentInspectionDateComponent.prototype.recentDate;
    /**
     * @type {?}
     * @private
     */
    RecentInspectionDateComponent.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/recent-inspection-hwl/recent-inspection-hwl.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RecentInspectionHwlComponent {
    /**
     * @param {?} _inspectionService
     */
    constructor(_inspectionService) {
        this._inspectionService = _inspectionService;
        this.recentHWL = '';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.apicallSub = this._inspectionService.getRecentInspectionForWell(this.wellID).subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                this.recentHWL = '';
                if (inspection == null) {
                    this.recentHWL = '';
                }
                else {
                    if (inspection.FireTube.HWL != null) {
                        this.recentHWL = inspection.FireTube.HWL;
                    }
                    else {
                        this.recentHWL = 'NA';
                    }
                }
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                console.log(error);
            })
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.apicallSub) {
            this.apicallSub.unsubscribe();
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        console.log(changes);
        this.apicallSub = this._inspectionService.getRecentInspectionForWell(this.wellID).subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                this.recentHWL = '';
                if (inspection == null) {
                    this.recentHWL = '';
                }
                else {
                    if (inspection.FireTube.HWL != null) {
                        this.recentHWL = inspection.FireTube.HWL;
                    }
                    else {
                        this.recentHWL = 'NA';
                    }
                }
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                console.log(error);
            })
        });
    }
}
RecentInspectionHwlComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-recent-inspection-hwl',
                template: "<span *ngIf=\"recentHWL != 'NA'\">{{recentHWL | percent}}</span>\r\n<span *ngIf=\"recentHWL == 'NA'\">N/A</span>\r\n<span *ngIf=\"recentHWL == ''\"></span>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
RecentInspectionHwlComponent.ctorParameters = () => [
    { type: InspectionService }
];
RecentInspectionHwlComponent.propDecorators = {
    wellID: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    RecentInspectionHwlComponent.prototype.wellID;
    /** @type {?} */
    RecentInspectionHwlComponent.prototype.recentHWL;
    /** @type {?} */
    RecentInspectionHwlComponent.prototype.apicallSub;
    /**
     * @type {?}
     * @private
     */
    RecentInspectionHwlComponent.prototype._inspectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/export-well-search-button/export-well-search-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ExportWellSearchButtonComponent {
    /**
     * @param {?} _exportService
     */
    constructor(_exportService) {
        this._exportService = _exportService;
        this.exportFailed = new EventEmitter();
        this.requestWellSearchExport = (/**
         * @return {?}
         */
        () => {
            //if (this.customerID != null) {
            //	return this._exportService.exportCustomerInspectionSearch(this.customerID, this.keyword,
            //		this.numDays, this.fileName);
            //} else {
            //	return this._exportService.exportInspectionSearch(this.keyword, this.numDays, this.fileName);
            //}
            return this._exportService.exportWellSearch(this.customerID, this.routeID, this.fileName);
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} error
     * @return {?}
     */
    onWellExportFailed(error) {
        this.exportFailed.emit(error);
    }
    /**
     * @return {?}
     */
    get hasWell() {
        return true;
    }
    /**
     * @param {?} error
     * @return {?}
     */
    onDownloadFailed(error) {
        this.exportFailed.emit(error);
    }
}
ExportWellSearchButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-export-well-search-button',
                template: "<eec-download-file-button [request]=\"requestWellSearchExport\"\n\t\t\t\t\t\t  label=\"Export Wells\"\n\t\t\t\t\t\t  [disabled]=\"!hasWell\"\n\t\t\t\t\t\t  (downloadFailed)=\"onDownloadFailed($event)\">\n</eec-download-file-button>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ExportWellSearchButtonComponent.ctorParameters = () => [
    { type: ExportService }
];
ExportWellSearchButtonComponent.propDecorators = {
    customerID: [{ type: Input }],
    routeID: [{ type: Input }],
    disabled: [{ type: Input }],
    fileName: [{ type: Input }],
    exportFailed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ExportWellSearchButtonComponent.prototype.customerID;
    /** @type {?} */
    ExportWellSearchButtonComponent.prototype.routeID;
    /** @type {?} */
    ExportWellSearchButtonComponent.prototype.disabled;
    /** @type {?} */
    ExportWellSearchButtonComponent.prototype.fileName;
    /** @type {?} */
    ExportWellSearchButtonComponent.prototype.exportFailed;
    /** @type {?} */
    ExportWellSearchButtonComponent.prototype.requestWellSearchExport;
    /**
     * @type {?}
     * @private
     */
    ExportWellSearchButtonComponent.prototype._exportService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/inpection-well-name/inpection-well-name.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InpectionWellNameComponent {
    /**
     * @param {?} _inspection_Service
     */
    constructor(_inspection_Service) {
        this._inspection_Service = _inspection_Service;
        this.isPrevInsp = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._inspection_Service.getPreviousCompletedInspection(this.inspectionID).subscribe({
            next: (/**
             * @param {?} inspection
             * @return {?}
             */
            inspection => {
                if (inspection == null) {
                    this.isPrevInsp = false;
                }
                else {
                    this.isPrevInsp = true;
                }
            }),
            error: (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                console.log(error);
            })
        });
    }
}
InpectionWellNameComponent.decorators = [
    { type: Component, args: [{
                selector: 'eec-inpection-well-name',
                template: "<span *ngIf=\"!isPrevInsp\" >{{wellName}}</span>\n<span *ngIf=\"isPrevInsp\"><a target=\"_blank\" href=\"inspections/search/10000?keyword={{wellName.replace('#','%23').replace('&','%26')}}\">{{wellName}}</a></span>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
InpectionWellNameComponent.ctorParameters = () => [
    { type: InspectionService }
];
InpectionWellNameComponent.propDecorators = {
    inspectionID: [{ type: Input }],
    wellName: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    InpectionWellNameComponent.prototype.inspectionID;
    /** @type {?} */
    InpectionWellNameComponent.prototype.wellName;
    /** @type {?} */
    InpectionWellNameComponent.prototype.isPrevInsp;
    /**
     * @type {?}
     * @private
     */
    InpectionWellNameComponent.prototype._inspection_Service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ee-common-lib.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EeCommonLibModule {
}
EeCommonLibModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    LoginComponent,
                    SpinnerComponent,
                    ChangePasswordComponent,
                    ConditionTextComponent,
                    AssetImgComponent,
                    InspectionTableComponent,
                    AsyncImgComponent,
                    DownloadFileButtonComponent,
                    DownloadFileTriggerComponent,
                    DownloadReportButtonComponent,
                    MonthlyInspectionCalendarComponent,
                    NotApplicablePipe,
                    NullCoalescingPipe,
                    TemperaturePipe,
                    UnitsPipe,
                    CalendarPaginationComponent,
                    KeywordSearchFormComponent,
                    EditContactFormComponent,
                    PasswordMatchFormComponent,
                    FormAlertsComponent,
                    PageAlertsComponent,
                    StatesPipe,
                    LogoutButtonComponent,
                    CustomerRouteSearchFormComponent,
                    ViewFileTriggerComponent,
                    DownloadFileComponent,
                    ViewOrDownloadFileButtonComponent,
                    InspectionDetailsComponent,
                    YesNoPipe,
                    PreviousInspectionButtonComponent,
                    CreateWellComponent,
                    EditWellFormComponent,
                    YearlyInspectionCalendarComponent,
                    InspectionSearchTableComponent,
                    ExportInspectionSearchButtonComponent,
                    EditInspectionFormComponent,
                    UpdateInspectionComponent,
                    EditAssetImageComponent,
                    WellOverviewPanelComponent,
                    AnodesTableComponent,
                    FieldNotesListComponent,
                    InspectionSearchComponent,
                    ExportWellInspectionsButtonComponent,
                    AutocompleteComponent,
                    AutocompleteInspectionComponent,
                    AutocompleteVesselComponent,
                    DeleteScheduledInspectionButtonComponent,
                    PrevInspectionDatePipe,
                    PreviousInspectionDateComponent,
                    PreviousInspectionHWLComponent,
                    RecentInspectionDateComponent,
                    RecentInspectionHwlComponent,
                    ExportWellSearchButtonComponent,
                    InpectionWellNameComponent
                ],
                imports: [
                    NgbModule,
                    BrowserModule,
                    HttpClientModule,
                    ReactiveFormsModule,
                    AutocompleteLibModule
                ],
                exports: [
                    LoginComponent,
                    SpinnerComponent,
                    ChangePasswordComponent,
                    ConditionTextComponent,
                    AssetImgComponent,
                    InspectionTableComponent,
                    AsyncImgComponent,
                    DownloadFileButtonComponent,
                    DownloadReportButtonComponent,
                    MonthlyInspectionCalendarComponent,
                    NotApplicablePipe,
                    NullCoalescingPipe,
                    TemperaturePipe,
                    UnitsPipe,
                    CalendarPaginationComponent,
                    KeywordSearchFormComponent,
                    EditContactFormComponent,
                    PasswordMatchFormComponent,
                    FormAlertsComponent,
                    PageAlertsComponent,
                    StatesPipe,
                    LogoutButtonComponent,
                    CustomerRouteSearchFormComponent,
                    DownloadFileComponent,
                    ViewOrDownloadFileButtonComponent,
                    InspectionDetailsComponent,
                    YesNoPipe,
                    PreviousInspectionButtonComponent,
                    CreateWellComponent,
                    EditWellFormComponent,
                    YearlyInspectionCalendarComponent,
                    InspectionSearchTableComponent,
                    ExportInspectionSearchButtonComponent,
                    EditInspectionFormComponent,
                    UpdateInspectionComponent,
                    EditAssetImageComponent,
                    WellOverviewPanelComponent,
                    AnodesTableComponent,
                    FieldNotesListComponent,
                    InspectionSearchComponent,
                    ExportWellInspectionsButtonComponent,
                    ExportWellSearchButtonComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ee-common-lib.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ABBREV_MONTH_YEAR_DATE_FORMAT, APP_CONFIG, AUTHENTICATION, AUTH_CONFIG, ActionButton, AnodeType, AnodeTypesResolverService, AssetImgComponent, AssetService, AsyncImgComponent, AuthGuard, CalendarPaginationComponent, ChangePasswordComponent, ConditionTextComponent, ConstantsService, CreateWellComponent, CustomerResolverService, CustomerRouteSearchFormComponent, CustomerService, CustomersResolverService, DEFAULT_DATE_INPUT_FORMAT, DEFAULT_INSPECTION_SEARCH_DAYS_BEFORE, DEFAULT_WELL_SEARCH_REPORT_NAME, DownloadFileButtonComponent, DownloadFileComponent, DownloadReportButtonComponent, EditContactFormComponent, EditInspectionFormComponent, EditInspectionResolverService, EditWellFormComponent, EeCommonLibModule, ErrorInterceptor, ExportInspectionSearchButtonComponent, ExportService, FileDownloadAction, FileExtValidator, FileHelper, FileService, FormAlertsComponent, HWL, HWLRange, InputConverterService, Inspection, InspectionCondition, InspectionDateHydrator, InspectionDetailsComponent, InspectionExportAction, InspectionResolverService, InspectionSearchTableComponent, InspectionService, InspectionTableComponent, JwtInterceptor, KeywordSearchFormComponent, LoginComponent, LogoutButtonComponent, MONTH_DAY_YEAR_DATE_FORMAT, MONTH_YEAR_DATE_FORMAT, MONTH_YEAR_INPUT_FORMAT, MonthlyInspectionCalendarComponent, MonthlyScheduledInspectionListResolverService, NotApplicablePipe, NullCoalescingPipe, PageAlertsComponent, PasswordMatchFormComponent, PreviousInspectionButtonComponent, ReportService, RouteResolverService, RouteService, RouteTreeService, SharedAppSettings, SpinnerComponent, StatesPipe, StatesResolverService, TemperaturePipe, UnitsPipe, UpdateInspectionComponent, UserRole, UserService, ValueMatchValidator, ViewOrDownloadFileButtonComponent, WellResolverService, WellService, YearlyInspectionCalendarComponent, YesNo, YesNoPipe, DownloadFileTriggerComponent as ɵa, ViewFileTriggerComponent as ɵb, EditAssetImageComponent as ɵc, WellOverviewPanelComponent as ɵd, AnodesTableComponent as ɵe, FieldNotesListComponent as ɵf, InspectionSearchComponent as ɵg, ExportWellInspectionsButtonComponent as ɵh, AutocompleteComponent as ɵi, AutocompleteInspectionComponent as ɵj, AutocompleteVesselComponent as ɵk, DeleteScheduledInspectionButtonComponent as ɵl, PrevInspectionDatePipe as ɵm, PreviousInspectionDateComponent as ɵn, PreviousInspectionHWLComponent as ɵo, RecentInspectionDateComponent as ɵp, RecentInspectionHwlComponent as ɵq, ExportWellSearchButtonComponent as ɵr, InpectionWellNameComponent as ɵs };
//# sourceMappingURL=ee-common-lib.js.map
